// Spanish
const es = {
  "lang.switch": "Idioma",

  "nav.marketplace": "Mercado",
  "nav.coaches": "Coaches",
  "nav.login": "Iniciar sesión",
  "nav.signup": "Empieza gratis",
  "nav.dashboard": "Panel",
  "nav.circles": "Círculos",
  "nav.collab_packages": "Paquetes colaborativos",
  "cp.cta_book": "Reserva una sesión",
  "cp.cta_signup": "Crea una cuenta para reservar",
  "nav.credits": "Créditos",
  "nav.membership": "Membresía",
  "nav.account": "Cuenta",
  "nav.support": "Soporte",
  "nav.billing": "Facturación",
  "home.meta_title": "Coaching y reflexión interior",
  "home.meta_desc": "Encuentra tu coach, reserva sesiones y crece por dentro con autorreflexión guiada por IA.",
  "home.hero_eyebrow": "Tu espacio para el crecimiento interior",
  "home.hero_title": "Encuentra calma, claridad y el coach adecuado para tu camino.",
  "home.hero_sub": "My Within conecta coaches reales y verificados con una autorreflexión suave guiada por IA, en un entorno que se siente tranquilo y seguro.",
  "home.hero_cta_marketplace": "Descubrir ofertas",
  "home.hero_cta_signup": "Empezar gratis",
  "home.hero_free_hint": "Registro 100 % gratuito · sin tarjeta de crédito",
  "home.step1_title": "Encuentra tu coach",
  "home.step1_text": "Explora coaches y ofertas verificadas por tema, región e idioma.",
  "home.step2_title": "Trabajad juntos",
  "home.step2_text": "Reserva sesiones, conecta y crece con acompañamiento humano real.",
  "home.step3_title": "Reflexiona con IA",
  "home.step3_text": "WEVA y EVA acompañan tu trabajo interior entre sesiones, en cualquier momento.",
  "home.offerings_title": "Ofertas destacadas",
  "home.offerings_sub": "Recién llegadas del mercado de nuestros coaches.",
  "home.see_all": "Ver todo",
  "home.coaches_title": "Conoce a nuestros coaches",
  "home.coaches_sub": "Verificados, con experiencia y listos para acompañarte.",
  "home.all_coaches": "Todos los coaches",
  "home.cta_title": "Empieza hoy tu trabajo interior.",
  "home.cta_sub": "Crea una cuenta en menos de un minuto, gratis y sin riesgo.",
  "home.cta_btn": "Empieza gratis ahora",
  "announce.coach_call": "Empieza como coach: reserva una llamada gratuita",
  "announce.free_signup": "O regístrate gratis en menos de un minuto",
  "announce.founder": "Oferta Founder – pago único",
  "foot.tagline": "Un lugar tranquilo para el trabajo interior, con coaches reales y reflexión asistida por IA.",
  "foot.discover": "Descubrir",
  "foot.create_account": "Crear cuenta",
  "foot.legal": "Legal",
  "foot.privacy": "Privacidad",
  "foot.terms": "Términos",
  "foot.built_in_austria": "Hecho con cuidado en Austria",
  "oc.recommended": "Recomendado",
  "oc.minutes": "{n} min",
  "oc.parts": "{n} partes",
  "nav.account_fallback": "Cuenta",
  "nav.signout": "Cerrar sesión",

  "common.or": "O",
  "common.loading": "Cargando…",
  "common.active": "Activo",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",

  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.email_placeholder": "tu@ejemplo.com",
  "auth.quote": "«El camino hacia dentro es el único que realmente lleva hacia delante.»",
  "auth.quote_attr": "My Within · tu espacio de calma",
  "auth.back_home": "← Volver al inicio",
  "auth.google": "Continuar con Google",
  "auth.apple": "Continuar con Apple",
  "auth.apple_toast": "El inicio de sesión con Apple se activará con el lanzamiento web en my-within.app.",

  "login.meta_title": "Iniciar sesión",
  "login.meta_desc": "Inicia sesión en tu cuenta de My Within.",
  "login.title": "Bienvenido de nuevo",
  "login.subtitle": "Inicia sesión para continuar tu trabajo interior.",
  "login.footer_q": "¿Aún no tienes cuenta?",
  "login.footer_link": "Regístrate ahora",
  "login.forgot": "¿Olvidaste?",
  "login.submit": "Iniciar sesión",
  "login.welcome_back": "¡Bienvenido de nuevo!",
  "login.failed": "Error al iniciar sesión.",

  "signup.meta_title": "Registrarse",
  "signup.meta_desc": "Crea tu cuenta gratuita de My Within.",
  "signup.title": "Crear cuenta",
  "signup.subtitle": "Empieza gratis: tú decides cuándo y con quién trabajas.",
  "signup.footer_q": "¿Ya estás registrado?",
  "signup.footer_link": "Iniciar sesión",
  "signup.role_client": "Busco acompañamiento",
  "signup.role_coach": "Soy coach",
  "signup.name": "Nombre",
  "signup.name_placeholder": "Tu nombre",
  "signup.password_placeholder": "Al menos 8 caracteres",
  "signup.consent_pre": "Acepto los",
  "signup.terms": "Términos",
  "signup.consent_mid": "y la",
  "signup.privacy": "Política de Privacidad",
  "signup.consent_post": ", consiento expresamente el tratamiento de mis datos de salud y confirmo que tengo al menos 16 años.",
  "signup.consent_required": "Por favor, confirma tu consentimiento para continuar.",
  "signup.submit": "Registrarse gratis",
  "signup.created": "Cuenta creada: ¡bienvenido a My Within!",
  "signup.failed": "Error en el registro.",

  "dash.meta_title": "Panel",
  "dash.welcome": "Bienvenido de nuevo",
  "dash.hello_fallback": "Nos alegra verte",
  "dash.balance": "Tu saldo",
  "dash.credits": "Créditos",
  "dash.topup": "Recargar",
  "dash.membership": "Membresía",
  "dash.upgrade": "Mejorar",
  "dash.manage": "Gestionar",
  "dash.next": "Continuar",
  "dash.action_credits_title": "Recargar créditos",
  "dash.action_credits_text": "Compra créditos para informes WEVA y contenido.",
  "dash.action_membership_title": "Membresía",
  "dash.action_membership_text": "Desbloquea la reflexión con IA ilimitada.",
  "dash.action_marketplace_title": "Mercado",
  "dash.action_marketplace_text": "Descubre ofertas y cursos de coaches.",
  "dash.action_coaches_title": "Coaches",
  "dash.action_coaches_text": "Encuentra el acompañamiento adecuado para ti.",

  "tier.free": "Gratis",
  "tier.plus": "Plus",
  "tier.plus_yearly": "Plus (anual)",
  "tier.pro": "Pro",
  "tier.pro_yearly": "Pro (anual)",
  "tier.unlimited": "Ilimitado",
  "tier.unlimited_yearly": "Ilimitado (anual)",
  "tier.coach_pro": "Coach Pro",
  "tier.coach_pro_yearly": "Coach Pro (anual)",

  "credits.meta_title": "Créditos",
  "credits.title": "Recargar créditos",
  "credits.subtitle": "Los créditos desbloquean informes WEVA y contenido exclusivo.",
  "credits.suffix": "Créditos",
  "credits.popular": "Popular",
  "credits.incl_vat": "IVA incl.",
  "credits.per_credit": "/crédito",
  "credits.buy": "Comprar",
  "credits.secure": "Pago seguro con Stripe. Serás redirigido brevemente a Stripe para el pago y luego volverás aquí.",
  "credits.payment_received": "Pago recibido: tus créditos se añadirán.",
  "credits.purchase_cancelled": "Compra cancelada.",
  "credits.granted": "{n} créditos añadidos.",
  "credits.failed": "Error en la compra.",

  "account.meta_title": "Cuenta",
  "account.title": "Cuenta",
  "account.referral": "Tu código de referido",
  "account.billing": "Datos de facturación",
  "account.billing_complete": "Completo",
  "account.billing_incomplete": "Incompleto",
  "account.devices": "Dispositivos conectados",
  "account.session": "Sesión {n}",
  "account.logged_in": "Conectado",
  "account.last_active": "Última actividad",
  "account.no_sessions": "No hay sesiones activas.",
  "account.logout": "Cerrar sesión",
  "account.logout_all": "Cerrar todas las sesiones",
  "account.logout_all_done": "Sesión cerrada en todos los dispositivos.",

  // Common (extended)
  "common.saving": "Guardando…",
  "common.search": "Buscar…",
  "common.none_found": "Nada encontrado.",

  // Coach · Ofertas / Productos / Paquetes
  "off.meta_title": "Coach · Ofertas",
  "off.back": "Panel del coach",
  "off.eyebrow": "Ofertas",
  "off.title": "Ofertas y productos",
  "off.subtitle": "Gestiona sesiones, paquetes, bundles y productos.",
  "off.tab_offerings": "Ofertas",
  "off.tab_products": "Productos",
  "off.new": "Nueva oferta",
  "off.new_bundle": "Bundle",
  "off.hide_inactive": "Ocultar inactivas",
  "off.empty_title": "Aún no hay ofertas",
  "off.empty_sub": "Crea tu primera oferta — p. ej. una sesión 1:1.",
  "off.inactive": "Inactiva",
  "off.active": "Activa",
  "off.standard": "Estándar",
  "off.min": "min",
  "off.edit": "Editar",
  "off.delete": "Eliminar",
  "off.delete_confirm": "¿Desactivar esta oferta?",
  "off.deleted": "Oferta desactivada.",
  "off.saved": "Oferta guardada.",
  "off.save_failed": "No se pudo guardar la oferta.",
  "off.min_price": "Precio mínimo €14,99.",
  "off.dialog_new": "Nueva oferta",
  "off.dialog_edit": "Editar oferta",
  "off.f_type": "Tipo",
  "off.f_custom_label": "Etiqueta propia",
  "off.f_custom_ph": "p. ej. Breathwork intensivo",
  "off.f_title": "Título",
  "off.f_title_ph": "p. ej. Sesión profunda de 90 min",
  "off.f_desc": "Descripción",
  "off.f_desc_ph": "Lo que recibe el cliente…",
  "off.f_duration": "Duración (min)",
  "off.f_price": "Precio (EUR)",
  "off.f_modality": "Formato",
  "off.f_online": "Online (Zoom)",
  "off.f_inperson": "Presencial",
  "off.f_location": "Lugar",
  "off.f_location_note": "Nota de lugar (opcional)",
  "off.f_location_online_ph": "Zoom (enlace automático)",
  "off.f_location_ph": "Viena, AT · Dirección del estudio",
  "off.online_hint": "Crearemos un enlace de Zoom automáticamente cuando conectes tu cuenta.",
  "off.f_start": "Inicio (ISO)",
  "off.f_start_ph": "2026-09-14T10:00",
  "off.f_end": "Fin (retiro, ISO)",
  "off.f_end_ph": "2026-09-17T18:00",
  "off.f_capacity": "Capacidad",
  "off.f_sessions": "Número de sesiones",
  "off.cover": "Imagen de portada (opcional)",
  "off.cover_hint": "Una imagen cálida 16:9 mostrada arriba en la pantalla de reserva.",
  "off.cover_library": "Elegir de la biblioteca",
  "off.cover_hide": "Cerrar biblioteca",
  "off.cover_remove": "Quitar",
  "off.toggle_standard": "Marcar como sesión estándar",
  "off.toggle_standard_hint": "Se abre cuando los clientes pulsan «Reservar sesión».",
  "off.toggle_weekly": "Reservable en el calendario semanal",
  "off.toggle_weekly_hint": "Esta oferta aparece cuando el cliente elige un horario.",
  "off.commission_hint": "Comisión de la plataforma: 10 % (Free) · 5 % (Coach Pro).",
  "off.bundle_title": "Crear bundle",
  "off.bundle_pick": "Selecciona ofertas (mín. 2)",
  "off.bundle_discount": "Descuento (%)",
  "off.bundle_total": "Total precios individuales",
  "off.bundle_effective": "Precio del bundle",
  "off.bundle_savings": "Ahorro",
  "off.bundle_none": "No hay ofertas combinables. Crea primero 2 ofertas normales.",
  "off.bundle_need2": "Selecciona al menos 2 ofertas.",
  "off.bundle_saved": "Bundle creado.",
  "off.p_new": "Nuevo producto",
  "off.p_empty_title": "Aún no hay productos",
  "off.p_empty_sub": "Los productos son sesiones simples pagadas con credits o Stripe.",
  "off.p_dialog_new": "Nuevo producto",
  "off.p_dialog_edit": "Editar producto",
  "off.p_name": "Nombre",
  "off.p_name_ph": "p. ej. Llamada de presentación",
  "off.p_desc": "Descripción",
  "off.p_duration": "Duración (min)",
  "off.p_capacity": "Capacidad",
  "off.p_group": "Sesión de grupo",
  "off.p_payment": "Pago",
  "off.p_accept_credits": "Aceptar credits",
  "off.p_price_credits": "Precio (credits)",
  "off.p_accept_stripe": "Aceptar Stripe",
  "off.p_price_eur": "Precio (EUR)",
  "off.p_saved": "Producto guardado.",
  "off.p_deleted": "Producto eliminado.",
  "off.p_delete_confirm": "¿Eliminar este producto?",
  "off.p_payment_required": "Selecciona al menos un método de pago.",
  "off.p_name_required": "Introduce un nombre.",
  "off.type.one_on_one": "Sesión 1:1",
  "off.type.group_online": "Curso grupal (online)",
  "off.type.group_inperson": "Curso grupal (presencial)",
  "off.type.retreat": "Retiro",
  "off.type.workshop": "Taller",
  "off.type.package": "Paquete",
  "off.type.custom": "Personalizado…",

  // Nav (extended)
  "nav.notifications": "Notificaciones",
  "nav.inner": "Inner Circle",
  "nav.mein_kreis": "Mi Círculo",
  "nav.pulse": "Pulso de clientes",
  "nav.offerings": "Ofertas",
  "nav.bookings": "Reservas",
  "nav.earnings": "Ingresos",
  "nav.availability": "Disponibilidad",
  "nav.analytics": "Analytics",
  "nav.collab": "Colaboración",
  "nav.content": "Social",
  "nav.profile": "Perfil y marca",
  "nav.verify": "Verificación",
  "nav.admin": "Admin",
  "nav.group.start": "Inicio",
  "nav.group.circles": "Círculos",
  "nav.group.sell": "Vender",
  "nav.group.grow": "Crecer",
  "nav.group.account": "Cuenta",
  "nav.group.admin": "Admin",
  "nav.experience.journey": "Mi Camino",
  "nav.experience.practice": "Mi Práctica",
  "nav.group.home": "Inicio",
  "nav.group.explore": "Explorar",
  "nav.group.breathe": "Respirar",
  "nav.group.weva": "WEVA",
  "nav.group.connect": "Conectar",
  "nav.group.my_space": "Mi Espacio",
  "nav.group.overview": "Resumen",
  "nav.group.clients": "Clientes",
  "nav.group.schedule": "Agenda y Planes",
  "nav.group.create": "Crear y Ofrecer",
  "nav.group.community": "Comunidad",
  "nav.group.business": "Negocio",
  "nav.group.settings": "Ajustes",
  "nav.practices": "Prácticas",
  "nav.collectives": "Colectivos",
  "nav.referral": "Referidos",
  "nav.client_wins": "Logros de clientes",
  "home.welcome_back": "Bienvenido de nuevo.",
  "home.welcome_q": "¿Qué te sentaría bien hoy?",
  "home.action_breathe_title": "Respirar",
  "home.action_breathe_sub": "Encuentra calma en el momento",
  "home.action_reflect_title": "Reflexionar",
  "home.action_reflect_sub": "Explora tus pensamientos y emociones",
  "home.action_weva_title": "Explorar con WEVA",
  "home.action_weva_sub": "Habla con tu acompañante",
  "home.continue_title": "Continúa tu camino",
  "home.continue_empty": "Tus próximos pasos aparecerán aquí a medida que explores.",
  "home.plan_pending": "Plan semanal pendiente",
  "home.plan_cta": "Ver plan",
  "home.report_latest": "Último informe de WEVA",
  "home.reflections_title": "Tus reflexiones",
  "home.stat_journal": "Entradas de diario",
  "home.stat_reports": "Informes de WEVA",
  "home.stat_practices": "Prácticas hechas",
  "home.stat_areas": "Áreas exploradas",
  "home.more_title": "Más para explorar",
  "home.open": "Abrir",

  // Coach · Perfil y Marca
  "prof.meta_title": "Coach · Perfil",
  "prof.back": "Panel del coach",
  "prof.eyebrow": "Perfil",
  "prof.title": "Perfil y marca",
  "prof.subtitle": "Tu perfil público de coach y tu marca.",
  "prof.tab_profile": "Perfil",
  "prof.tab_branding": "Marca",
  "prof.photo": "Foto de perfil",
  "prof.photo_hint": "Foto de perfil y portada (máx. 2,5 MB). Cuadrada recomendada para la foto.",
  "prof.header": "Imagen de portada",
  "prof.upload": "Subir",
  "prof.remove": "Quitar",
  "prof.too_large": "Imagen demasiado grande (máx. 2,5 MB).",
  "prof.name": "Nombre",
  "prof.bio": "Sobre ti",
  "prof.bio_ph": "Cuenta a los clientes cómo trabajas…",
  "prof.professions": "Profesión(es)",
  "prof.professions_hint": "Elige hasta 5 de la lista.",
  "prof.professions_ph": "Añadir profesión…",
  "prof.topics": "Temas",
  "prof.topics_hint": "Elige temas relevantes.",
  "prof.topics_ph": "Añadir tema…",
  "prof.methods": "Métodos",
  "prof.methods_hint": "Elige tus métodos / modalidades.",
  "prof.methods_ph": "Añadir método…",
  "prof.location": "Ubicación",
  "prof.location_ph": "Viena, Austria",
  "prof.website": "Sitio web",
  "prof.website_ph": "https://…",
  "prof.languages": "Idiomas",
  "prof.languages_hint": "Separados por comas, p. ej. Alemán, Inglés.",
  "prof.experience": "Años de experiencia",
  "prof.audience": "Público objetivo",
  "prof.audience_ph": "¿A quién acompañas?",
  "prof.visibility_public": "Visible públicamente",
  "prof.visibility_hint": "Tu perfil aparece en el marketplace y el directorio de coaches.",
  "prof.saved": "Perfil guardado.",
  "prof.save_failed": "No se pudo guardar el perfil.",
  "prof.view_public": "Ver perfil público",

  // Coach · Marca
  "brand.subtitle": "Logo, color de marca y pie para emails a clientes y tu perfil.",
  "brand.locked_title": "La marca es una función Coach Pro",
  "brand.locked_sub": "Actualiza a Coach Pro para definir logo, color y pie.",
  "brand.upgrade": "Actualizar a Coach Pro",
  "brand.logo": "URL del logo",
  "brand.logo_ph": "https://… (PNG/SVG)",
  "brand.color": "Color de marca",
  "brand.footer": "Texto del pie",
  "brand.footer_ph": "p. ej. «Acompañado con cariño por …» (máx. 200 caracteres)",
  "brand.saved": "Marca guardada.",
  "brand.reset": "Restablecer",
  "brand.reset_done": "Restablecido a los valores por defecto.",

  // Coach · Verificación
  "verify.meta_title": "Coach · Verificación",
  "verify.eyebrow": "Verificación",
  "verify.title": "Verifica tu cualificación",
  "verify.subtitle": "Sube tu certificado para desbloquear todas las funciones de coach.",
  "verify.status": "Estado actual",
  "verify.status_approved": "Verificado",
  "verify.status_pending_ai": "Revisión por IA en curso",
  "verify.status_pending_admin": "En revisión",
  "verify.status_rejected": "Rechazado",
  "verify.status_unverified": "No verificado",
  "verify.approved_title": "Estás verificado 🎉",
  "verify.approved_sub": "Todas las funciones de coach están desbloqueadas — círculos, ofertas, reservas.",
  "verify.reviewer_title": "Acceso de revisor activo",
  "verify.reviewer_sub": "Esta cuenta omite la verificación para revisiones.",
  "verify.step_dpa_title": "Acepta el Acuerdo de Corresponsables",
  "verify.step_dpa_sub": "Acuerdo de protección de datos para corresponsables.",
  "verify.dpa_accept": "Acepto el Acuerdo de Corresponsables.",
  "verify.dpa_accepted": "Acuerdo aceptado.",
  "verify.accept_btn": "Aceptar",
  "verify.step_upload_title": "Subir certificado",
  "verify.step_upload_sub": "Foto/escaneo de tu certificado (PNG/JPEG, máx. 4 MB).",
  "verify.upload_btn": "Subir certificado",
  "verify.reupload_btn": "Volver a subir",
  "verify.uploading": "Subiendo…",
  "verify.upload_failed": "Error al subir.",
  "verify.too_large": "Imagen demasiado grande (máx. 4 MB).",
  "verify.pending_admin_title": "Enviado a revisión",
  "verify.pending_admin_sub": "Una persona revisa tu certificado. Te avisaremos cuando se apruebe.",
  "verify.rejected_title": "Verificación rechazada",
  "verify.rejected_sub": "Sube un certificado más claro, por favor.",
  "verify.ai_verdict": "Evaluación de IA",
  "verify.ai_subject": "Área temática",
  "verify.ai_confidence": "Confianza",

  // Notificaciones
  "notif.meta_title": "Notificaciones",
  "notif.title": "Notificaciones",
  "notif.subtitle": "Novedades sobre reservas, círculos y tu cuenta.",
  "notif.empty_title": "Sin notificaciones",
  "notif.empty_sub": "Aquí aparecerán las novedades.",
  "notif.mark_all": "Marcar todo leído",
  "notif.marked_all": "Todo marcado como leído.",

  // Common (Phase 4c)
  "common.refresh": "Actualizar",

  // Coach · Social y Contenido (Phase 4c)
  "soc.meta_title": "Coach · Social",
  "soc.back": "Panel de coach",
  "soc.eyebrow": "Social",
  "soc.title": "Social y Contenido",
  "soc.subtitle": "Publicaciones, historias, muro de historias, mensajes y WEVA — todo en un lugar.",
  "soc.tab_posts": "Publicaciones",
  "soc.tab_stories": "Historias",
  "soc.tab_wall": "Muro de historias",
  "soc.tab_impact": "Impacto",
  "soc.tab_messages": "Mensajes",
  "soc.tab_weva": "WEVA",

  "soc.posts_new": "Nueva publicación",
  "soc.posts_stat_posts": "Publicaciones",
  "soc.posts_stat_unlocks": "Desbloqueos",
  "soc.posts_stat_credits": "Créditos ganados",
  "soc.posts_stat_reports": "Reportes",
  "soc.posts_empty_title": "Aún no hay publicaciones",
  "soc.posts_empty_sub": "Crea tu primera publicación para el feed.",
  "soc.posts_unlocks": "{n} desbloqueos",
  "soc.posts_credits": "{n} créditos",
  "soc.posts_hidden": "Oculta",
  "soc.posts_dialog_title": "Nueva publicación",
  "soc.posts_f_title": "Título",
  "soc.posts_f_title_ph": "Título de la publicación",
  "soc.posts_f_body": "Texto",
  "soc.posts_f_body_ph": "Comparte un impulso, una reflexión o un ejercicio…",
  "soc.posts_paid": "Contenido de pago",
  "soc.posts_paid_sub": "Los clientes pagan créditos para desbloquear.",
  "soc.posts_price": "Precio (créditos)",
  "soc.posts_price_ph": "p. ej. 10",
  "soc.posts_publish": "Publicar",
  "soc.posts_publishing": "Publicando…",
  "soc.posts_created": "Publicación publicada.",
  "soc.posts_title_required": "Introduce un título.",
  "soc.posts_price_required": "El contenido de pago necesita al menos 1 crédito.",
  "soc.posts_create_failed": "No se pudo crear la publicación.",

  "soc.stories_new": "Nueva historia",
  "soc.stories_sub": "Historias de 24 horas y destacados permanentes.",
  "soc.stories_empty_title": "Aún no hay historias",
  "soc.stories_empty_sub": "Comparte una historia breve de 24 horas con tus clientes.",
  "soc.stories_kind_image": "Imagen",
  "soc.stories_kind_text": "Texto",
  "soc.stories_pick": "Elegir imagen",
  "soc.stories_replace": "Reemplazar imagen",
  "soc.stories_pick_hint": "Elige una imagen (máx. 10 MB).",
  "soc.stories_text_ph": "¿Qué quieres compartir?",
  "soc.stories_ttl_hint": "Las historias desaparecen automáticamente tras 24 horas.",
  "soc.stories_dialog_title": "Nueva historia",
  "soc.stories_publish": "Compartir",
  "soc.stories_publishing": "Compartiendo…",
  "soc.stories_created": "Historia compartida.",
  "soc.stories_too_large": "Imagen demasiado grande (máx. 10 MB).",
  "soc.stories_uploading": "Subiendo…",
  "soc.stories_upload_failed": "No se pudo subir la imagen.",
  "soc.stories_need_content": "Elige una imagen o introduce texto.",
  "soc.stories_create_failed": "No se pudo crear la historia.",
  "soc.stories_status_active": "Activa",
  "soc.stories_status_expired": "Expirada",
  "soc.stories_highlight_badge": "Destacado",
  "soc.stories_views": "{n} visualizaciones",
  "soc.stories_pin": "Fijar",
  "soc.stories_unpin": "Soltar",
  "soc.stories_delete_confirm": "¿Eliminar esta historia?",
  "soc.stories_deleted": "Historia eliminada.",
  "soc.stories_pinned": "Fijada como destacado.",
  "soc.stories_unpinned": "Destacado eliminado.",
  "soc.stories_pin_title": "Fijar como destacado",
  "soc.stories_pin_sub": "Dale al destacado un título corto (opcional).",
  "soc.stories_pin_ph": "p. ej. Testimonios",
  "soc.stories_pin_save": "Fijar",

  "soc.wall_new": "Nuevo momento",
  "soc.wall_sub": "Comparte momentos de clientes públicamente con doble consentimiento.",
  "soc.wall_empty_title": "Aún no hay momentos",
  "soc.wall_empty_sub": "Captura un hito especial — con el consentimiento del cliente.",
  "soc.wall_create_title": "Crear momento",
  "soc.wall_client": "Cliente",
  "soc.wall_kind": "Tipo",
  "soc.wall_title_lbl": "Título",
  "soc.wall_title_ph": "Título corto y potente",
  "soc.wall_body_lbl": "Texto",
  "soc.wall_body_ph": "¿Qué pasó? Describe el momento…",
  "soc.wall_metric_lbl": "Métrica (opcional)",
  "soc.wall_metric_ph": "p. ej. −40 % estrés",
  "soc.wall_color_lbl": "Color",
  "soc.wall_consent_note": "La publicación requiere tu consentimiento Y el del cliente.",
  "soc.wall_missing_fields": "Completa cliente, título y texto.",
  "soc.wall_save": "Guardar momento",
  "soc.wall_saved": "Momento creado.",
  "soc.wall_kind_reflection": "Reflexión",
  "soc.wall_kind_wellbeing_shift": "Bienestar",
  "soc.wall_kind_streak": "Racha",
  "soc.wall_kind_quote": "Cita",
  "soc.wall_kind_milestone": "Hito",
  "soc.wall_status_draft": "Borrador",
  "soc.wall_status_published": "Publicado",
  "soc.wall_status_unlisted": "No listado",
  "soc.wall_coach_consent": "Tu consentimiento",
  "soc.wall_client_consent": "Consentimiento del cliente",
  "soc.wall_consent_granted": "Concedido",
  "soc.wall_consent_pending": "Pendiente",
  "soc.wall_consent_waiting_client": "Esperando al cliente",
  "soc.wall_review_agree": "Revisar y aceptar",
  "soc.wall_review": "Ver consentimiento",
  "soc.wall_coach_consent_title": "Tu consentimiento",
  "soc.wall_coach_consent_body": "Con tu consentimiento este momento puede compartirse públicamente cuando el cliente también acepte.",
  "soc.wall_show_name": "Mostrar mi nombre",
  "soc.wall_show_name_sub": "Tu nombre aparece en el momento publicado.",
  "soc.wall_consent_grant": "Aceptar",
  "soc.wall_consent_revoke": "Retirar",
  "soc.wall_publish": "Publicar",
  "soc.wall_unpublish": "Despublicar",
  "soc.wall_archive": "Archivar",
  "soc.wall_archive_confirm": "¿Archivar este momento?",
  "soc.wall_published_ok": "Momento publicado.",
  "soc.wall_publish_needs_consents": "Se requieren ambos consentimientos para publicar.",

  "soc.impact_sub": "A cuántas personas conmueven tus logros.",
  "soc.impact_empty_title": "Aún no hay momentos de historia",
  "soc.impact_empty_sub": "Cuando publiques logros de clientes, verás aquí visualizaciones, compartidos y tendencias.",
  "soc.impact_overall": "Resumen general",
  "soc.impact_views": "Visualizaciones",
  "soc.impact_shares": "Compartidos",
  "soc.impact_previews": "Aperturas de vista previa",
  "soc.impact_engagement": "Interacción",
  "soc.impact_engagement_hint": "Visualizaciones ÷ aperturas de vista previa",
  "soc.impact_share_rate": "Tasa de compartidos",
  "soc.impact_share_hint": "Compartidos ÷ visualizaciones",
  "soc.impact_trend": "Tendencia de los últimos 7 días",
  "soc.impact_views_7d": "Visualizaciones últimos 7 días",
  "soc.impact_vs_prev": "vs. anterior",
  "soc.impact_ranking": "Ranking de impacto por momento",

  "soc.msg_sub": "Mensajes directos y chats compartidos.",
  "soc.msg_shared": "Chats compartidos",
  "soc.msg_dms": "Mensajes directos",
  "soc.msg_empty": "Aún no hay mensajes. Los clientes y coaches aparecerán aquí.",
  "soc.msg_three_way": "Cuidado conjunto",
  "soc.msg_input_ph": "Escribe un mensaje…",
  "soc.msg_empty_thread": "Aún no hay mensajes. Escribe el primero 👋",
  "soc.msg_deleted": "Mensaje eliminado",
  "soc.msg_delete_confirm": "¿Eliminar este mensaje?",

  "soc.weva_sub": "Patrones anonimizados de tu círculo interno — con impulsos de coaching.",
  "soc.weva_trends_title": "Tendencias anónimas del círculo",
  "soc.weva_trends_clients": "{a} de {t} activos · {d} días",
  "soc.weva_trends_emotions": "Top emociones",
  "soc.weva_trends_themes": "Top temas",
  "soc.weva_trends_beliefs": "Top creencias",
  "soc.weva_trends_practices": "Top prácticas",
  "soc.weva_intro": "Pregúntame sobre patrones en tu círculo interno — emociones, temas, prácticas — y te daré impulsos de coaching.",
  "soc.weva_placeholder": "Pregunta algo a WEVA…",
  "soc.weva_thinking": "WEVA está pensando…",
  "soc.weva_clear": "Borrar historial",
  "soc.weva_clear_confirm": "¿Borrar todo el historial de WEVA?",
  "soc.weva_locked_title": "El chat WEVA para coach es una función Coach Pro",
  "soc.weva_locked_sub": "Mejora a Coach Pro para usar WEVA con información anónima del círculo.",
  "soc.weva_upgrade": "Mejorar a Coach Pro",
  "soc.weva_send_failed": "No se pudo enviar el mensaje.",

  // Common (Phase 4d)
  "common.close": "Cerrar",
  "nav.methods": "Métodos",
  "nav.plans": "Planes",

  // Coach · Métodos y Plantillas (Phase 4d)
  "cm.meta_title": "Coach · Métodos",
  "cm.back": "Panel de coach",
  "cm.eyebrow": "Métodos",
  "cm.title": "Métodos y Plantillas",
  "cm.subtitle": "Crea tus propios ejercicios, gestiónalos, guárdalos como plantilla y mide su impacto.",
  "cm.tab_methods": "Métodos",
  "cm.tab_templates": "Plantillas",
  "cm.tab_breathwork": "Respiración",
  "cm.tab_stats": "Estadísticas",
  "cm.tab_social": "Compartido en el feed",
  "cm.social_title": "Métodos en tu feed social",
  "cm.social_sub": "Los métodos compartidos (gratis o de pago) aparecen como publicaciones en tu feed, con visualizaciones y compras.",
  "cm.social_cta": "Ir a mis publicaciones del feed",

  "cm.new_method": "Nuevo método",
  "cm.filter_all": "Todos",
  "cm.filter_shared": "Compartidos",
  "cm.filter_template": "Plantillas",
  "cm.no_methods_title": "Aún no hay métodos",
  "cm.no_methods_sub": "Empieza con una meditación de audio o un set de preguntas.",
  "cm.no_templates": "Aún no hay plantillas",
  "cm.create_first": "Crear tu primer método",
  "cm.edit": "Editar",
  "cm.tpl": "Plantilla",
  "cm.duplicated": "Método duplicado.",
  "cm.deleted": "Método eliminado.",
  "cm.delete_confirm": "¿Eliminar el método \"{title}\"?",

  "cm.kind_audio": "Meditación de audio",
  "cm.kind_audio_sub": "Sesión guiada de voz/música.",
  "cm.kind_video": "Guía en vídeo",
  "cm.kind_video_sub": "Vídeo breve contigo como coach.",
  "cm.kind_breathwork": "Respiración",
  "cm.kind_breathwork_sub": "Referencia a tu propia técnica de respiración.",
  "cm.kind_questions": "Set de preguntas",
  "cm.kind_questions_sub": "Preguntas de reflexión, respuesta libre.",
  "cm.kind_combo": "Método combinado",
  "cm.kind_combo_sub": "Varios bloques en secuencia.",
  "cm.kind_body_scan": "Escaneo corporal",
  "cm.kind_body_scan_sub": "Guiar la atención por el cuerpo.",
  "cm.kind_gratitude": "Gratitud",
  "cm.kind_gratitude_sub": "3 cosas · foco en el corazón.",
  "cm.kind_visualization": "Visualización",
  "cm.kind_visualization_sub": "Imágenes internas y viaje al futuro.",
  "cm.kind_movement": "Movimiento",
  "cm.kind_movement_sub": "Yoga · somático · shaking.",
  "cm.kind_check_in": "Check-in",
  "cm.kind_check_in_sub": "Pulso diario · emoción y necesidad.",

  "cm.vis_private": "Privado",
  "cm.vis_shared_with_clients": "Clientes",
  "cm.vis_public": "Público",

  "cm.pick_title": "Crear método",
  "cm.pick_hint": "Elige el tipo de tu nuevo método.",
  "cm.editing": "Editar método",
  "cm.change_kind": "Cambiar tipo",
  "cm.save_new": "Guardar método",
  "cm.saved": "Método guardado.",
  "cm.save_failed": "No se pudo guardar el método.",
  "cm.load_failed": "No se pudo cargar el método.",
  "cm.title_required": "Introduce un título.",
  "cm.cover": "Imagen de portada (opcional)",
  "cm.f_title": "Título",
  "cm.title_ph": "Corto y claro (máx. 140 car.)",
  "cm.f_subtitle": "Subtítulo (opcional)",
  "cm.subtitle_ph": "p. ej. \"Llegar y soltar\"",
  "cm.description": "Descripción",
  "cm.description_ph": "¿Para qué sirve este método?",
  "cm.suggest_titles": "Sugerencias IA",
  "cm.ai_no_titles": "No se encontraron sugerencias. Escribe una descripción más detallada.",
  "cm.ai_locked": "Las sugerencias de título por IA son una función Coach Pro.",
  "cm.audio_field": "Audio",
  "cm.video_field": "Vídeo",
  "cm.pick_technique": "Tu propia técnica de respiración",
  "cm.no_bw_yet": "Primero crea tu propio ejercicio de respiración en la app móvil.",
  "cm.questions": "Preguntas",
  "cm.no_questions": "Aún no hay preguntas. Añade la primera.",
  "cm.q_required": "Obligatoria",
  "cm.q_prompt_ph": "Pregunta, p. ej. \"¿Cómo te sientes ahora?\"",
  "cm.q_add": "Añadir pregunta",
  "cm.steps": "Bloques (orden)",
  "cm.steps_empty": "Aún no hay bloques. Añade p. ej. escaneo corporal + respiración + gratitud.",
  "cm.step_title_ph": "Título del bloque, p. ej. \"3 minutos de escaneo corporal\"",
  "cm.step_body_ph": "Texto de instrucción…",
  "cm.step_duration_ph": "Duración (segundos)",
  "cm.step_breathwork": "Respiración",
  "cm.step_audio": "Audio",
  "cm.step_video": "Vídeo",
  "cm.step_body_scan": "Cuerpo",
  "cm.step_gratitude": "Gratitud",
  "cm.step_visualization": "Visión",
  "cm.step_movement": "Movimiento",
  "cm.step_questions": "Preguntas",
  "cm.step_check_in": "Check-in",
  "cm.step_timer": "Temporizador",
  "cm.step_text": "Texto",
  "cm.settings": "Ajustes",
  "cm.duration_min": "Duración (min)",
  "cm.preview_seconds": "Vista previa (seg)",
  "cm.visibility": "Visibilidad",
  "cm.price": "Precio (créditos)",
  "cm.is_template": "Como plantilla",
  "cm.tpl_on": "Plantilla activa",
  "cm.tpl_off": "Guardar como plantilla",
  "cm.ethics_title": "Coaching, no sustituto de terapia",
  "cm.ethics_body": "Formula tu método como oferta de coaching. No sustituye un diagnóstico médico ni psicoterapia. Ante trauma, pensamientos suicidas o síntomas agudos, deriva a un profesional.",

  "cm.media_url_ph": "Pega una URL o sube un archivo",
  "cm.media_upload": "Subir",
  "cm.media_uploading": "Subiendo…",
  "cm.media_uploaded": "Archivo subido.",
  "cm.media_upload_failed": "No se pudo subir el archivo.",

  "cm.preview_lbl": "Vista previa",
  "cm.preview_running": "Los clientes oyen/ven exactamente este fragmento antes de comprar.",
  "cm.preview_done": "Vista previa finalizada.",

  "cm.stats_methods": "Métodos",
  "cm.stats_opens": "Aperturas",
  "cm.stats_completions": "Completados",
  "cm.stats_rate": "Tasa",
  "cm.stats_top_completed": "Favoritos",
  "cm.stats_top_opened": "Más abiertos",
  "cm.stats_empty": "Aún no hay datos. Cuando los clientes usen tus métodos, verás aquí tus favoritos.",

  "cm.templates_sub": "Técnicas distintivas que puedes reutilizar con nuevos clientes. Copia una para adaptarla.",
  "cm.no_templates_long": "Aún no hay plantillas. Abre un método y activa el interruptor de plantilla al guardar.",
  "cm.tpl_use": "Usar",
  "cm.tpl_copied": "Plantilla copiada — ahora edita la copia.",
  "cm.tpl_done": "{n}× completado",

  // Coach · Planes (Phase 4d parte 2)
  "pl.meta_title": "Coach · Planes",
  "pl.back": "Panel de coach",
  "pl.eyebrow": "Planes",
  "pl.title": "Planes",
  "pl.subtitle": "Asigna planes diarios a clientes y comparte planes semanales de respiración.",
  "pl.tab_daily": "Planes diarios",
  "pl.tab_weekly": "Planes semanales",

  "pl.d_sub": "Asigna a los clientes tareas con fecha, hora y técnica.",
  "pl.d_new": "Asignar plan",
  "pl.d_empty_title": "Aún no hay planes asignados",
  "pl.d_empty_sub": "Asigna una tarea a tu primer cliente.",
  "pl.d_done": "Hecho",
  "pl.d_pending": "Pendiente",
  "pl.d_missing": "Elige un título y al menos un cliente.",
  "pl.d_assigned": "Plan asignado a {n} cliente(s).",
  "pl.d_title_ph": "Título, p. ej. Respiración nocturna",
  "pl.d_desc_ph": "Descripción (opcional)",
  "pl.d_date": "Fecha",
  "pl.d_time": "Hora",
  "pl.d_reminder": "Recordatorio (min)",
  "pl.d_technique": "Técnica de respiración (opcional)",
  "pl.d_clients": "Clientes",
  "pl.d_no_clients": "No hay clientes elegibles. Añade a alguien a un círculo primero.",

  "pl.w_mobile_note": "Los planes semanales se crean y editan en la app móvil. Aquí ves tus planes y los compartes con clientes o círculos.",
  "pl.w_my_master": "Mis planes maestros",
  "pl.w_no_plans": "Aún no hay planes semanales. Crea el primero aquí mismo.",
  "pl.w_slots": "{n} bloques",
  "pl.w_flexible": "flexible",
  "pl.w_send": "Enviar",
  "pl.w_sent": "Enviados a clientes",
  "pl.w_sent_hint": "Los planes compartidos aparecen aquí con su estado.",
  "pl.w_to_client": "A cliente",
  "pl.w_share_target": "Compartir plan",
  "pl.w_tab_single": "Individual",
  "pl.w_tab_multi": "Varios",
  "pl.w_tab_circle": "Círculo",
  "pl.w_no_clients": "Sin clientes.",
  "pl.w_no_circles": "Sin círculos.",
  "pl.w_select_all": "Todos",
  "pl.w_deselect_all": "Ninguno",
  "pl.w_circle_members": "{n} miembros",
  "pl.w_overwrite": "Sobrescribir planes existentes",
  "pl.w_msg_ph": "Mensaje opcional…",
  "pl.w_send_plan": "Enviar plan",
  "pl.w_sending": "Enviando…",
  "pl.w_sent_ok": "Plan enviado.",
  "pl.w_multi_summary": "Enviados: {ok} · Fallidos: {fail}",
  "pl.w_circle_summary": "Enviados: {sent} · Omitidos: {skipped} · Actualizados: {updated}",
  "pl.w_web_note": "Crea y edita planes semanales aquí mismo. Las copias ya enviadas a clientes no cambian.",
  "pl.w_new": "Nuevo plan semanal",
  "pl.w_create_plan": "Crear plan",
  "pl.w_editor_new": "Crear plan semanal",
  "pl.w_editor_edit": "Editar plan semanal",
  "pl.w_editor_sub": "Nombra el plan, elige el inicio de semana y añade bloques por día.",
  "pl.w_default_name": "Mi práctica semanal",
  "pl.w_name": "Nombre",
  "pl.w_name_ph": "p. ej. Mi práctica semanal",
  "pl.w_desc": "Descripción",
  "pl.w_desc_ph": "Opcional",
  "pl.w_week_start": "Inicio de semana (lun)",
  "pl.w_slots_lbl": "Bloques",
  "pl.w_add_slot": "Bloque",
  "pl.w_no_slots": "Aún no hay bloques. Añade ejercicios para la semana.",
  "pl.w_slot_day": "Día",
  "pl.w_slot_time": "Hora",
  "pl.w_slot_duration": "Duración (min)",
  "pl.w_slot_category": "Categoría",
  "pl.w_slot_technique": "Ejercicio",
  "pl.w_slot_reminder": "Recordatorio",
  "pl.w_slot_note": "Nota (opcional)",
  "pl.w_slot_save": "Guardar bloque",
  "pl.w_cat_breathing": "Respiración",
  "pl.w_cat_deep_within": "Deep Within",
  "pl.w_cat_rdr": "RDR",
  "pl.w_cat_custom": "Mi respiración",
  "pl.w_cat_coach_method": "Mis métodos",
  "pl.w_days": "Lun,Mar,Mié,Jue,Vie,Sáb,Dom",
  "pl.w_rem_start": "Al inicio",
  "pl.w_rem_min": "{n} min antes",
  "pl.w_rem_hour": "1 hora antes",
  "pl.w_need_name": "Introduce un nombre.",
  "pl.w_need_slots": "Añade al menos un bloque.",
  "pl.w_need_tech": "Elige un ejercicio.",
  "pl.w_created": "Plan semanal creado.",
  "pl.w_updated": "Plan semanal actualizado.",
  "pl.w_save_failed": "No se pudo guardar el plan semanal.",
  "pl.w_delete_confirm": "¿Eliminar el plan semanal \"{name}\"?",
  "pl.w_deleted": "Plan semanal eliminado.",
  "pl.w_no_custom": "Aún no tienes ejercicio propio de respiración. Crea uno en la pestaña Métodos.",
  "pl.w_no_methods": "Aún no hay métodos.",

  // Coach · Técnicas de respiración (mejora)
  "bw.new": "Nuevo ejercicio",
  "bw.edit_existing": "Editar ejercicio",
  "bw.name": "Nombre del ejercicio",
  "bw.name_ph": "p. ej. Respiración caja 4-4-4-4",
  "bw.rhythm": "Ritmo (segundos)",
  "bw.inhale": "Insp.",
  "bw.hold_in": "Reten.",
  "bw.exhale": "Esp.",
  "bw.hold_out": "Reten.",
  "bw.length": "Duración",
  "bw.by_reps": "Repeticiones",
  "bw.by_duration": "Duración total",
  "bw.reps": "Rondas",
  "bw.duration_s": "Segundos",
  "bw.estimated": "Estimado",
  "bw.cycle": "Ciclo",
  "bw.notes": "Nota para el cliente (opcional)",
  "bw.notes_ph": "p. ej. Por la noche antes de dormir",
  "bw.save_new": "Guardar ejercicio",
  "bw.saved": "Ejercicio guardado.",
  "bw.save_failed": "No se pudo guardar el ejercicio.",
  "bw.delete_confirm": "¿Eliminar el ejercicio \"{name}\"?",
  "bw.deleted": "Ejercicio eliminado.",
  "bw.saved_list": "Tus ejercicios",
  "bw.empty": "Aún no hay ejercicio propio guardado.",

  // Nav (Phase 4e)
  "nav.ads": "Publicidad",
  "nav.recommendations": "Recomendaciones",

  // ── Analytics en profundidad (Phase 4e · e1) ──
  "an.back": "Panel de coach",
  "an.eyebrow": "Analítica",
  "an.title": "Analítica en profundidad",
  "an.subtitle": "12 paneles: crecimiento, sesiones, WEVA, contenido, ingresos, comparativas e informes.",
  "an.period_week": "Semana",
  "an.period_month": "Mes",
  "an.period_quarter": "Trimestre",
  "an.period_year": "Año",
  "an.period_all": "Total",
  "an.period_sync": "El periodo se aplica a todos los paneles con base temporal.",
  "an.pro_locked_title": "Coach Pro desbloquea toda la profundidad",
  "an.pro_locked_sub": "Los análisis de ingresos, retención e informes son parte de Coach Pro.",
  "an.pro_upgrade": "Mejorar a Coach Pro",
  "an.insights_kicker": "Mayor movimiento",
  "an.insights_vs_prev": "vs. semana pasada",
  "an.insights_tap": "Ver los 3 mayores cambios",
  "an.insights_modal_title": "Tus mayores cambios",
  "an.insights_modal_sub": "Los mayores movimientos frente a la semana pasada.",
  "an.insights_empty": "Aún no hay datos suficientes para comparar.",
  "an.tip_button": "¿Qué me muestra esto?",
  "an.tip_loading": "WEVA está leyendo los números…",
  "an.tip_error": "No se pudo cargar una explicación ahora.",
  "an.tip_source": "Explicación de IA basada en tus datos",
  "an.t1": "Perfil de un vistazo",
  "an.t2": "Crecimiento de clientes",
  "an.t3": "Sesiones y reservas",
  "an.t4": "Análisis grupal WEVA",
  "an.t5": "Rendimiento de planes semanales",
  "an.t6": "Rendimiento de contenido",
  "an.t7": "Inner vs. Local Circle",
  "an.t8": "Rendimiento de afiliados",
  "an.t9": "Interacción y comunicación",
  "an.t10": "Objetivos de clientes",
  "an.t11": "Comparación de periodos",
  "an.t12": "Informes y exportación",
  "an.t1_clients": "Clientes en total",
  "an.t1_ic": "Inner",
  "an.t1_lc": "Local",
  "an.t1_general": "General",
  "an.t1_sessions": "Sesiones completadas",
  "an.t1_offerings": "Ofertas activas",
  "an.t1_gross": "Ingresos brutos",
  "an.t1_since": "Miembro desde",
  "an.t2_new": "Nuevos",
  "an.t2_churn": "Bajas",
  "an.t2_net": "Neto",
  "an.t2_cumulative": "Acumulado",
  "an.t3_total": "Reservas",
  "an.t3_completed": "Completadas",
  "an.t3_cancelled": "Canceladas",
  "an.t3_cancel_rate": "Tasa de cancelación",
  "an.t3_avg_dur": "Duración media",
  "an.t3_util": "Ocupación",
  "an.t3_hours": "Horas populares",
  "an.t3_weekdays": "Días populares",
  "an.t4_empty": "Aún no hay datos WEVA de tus clientes.",
  "an.t4_client_count": "Clientes",
  "an.t4_reports": "Informes",
  "an.t4_emotions": "Emociones principales",
  "an.t4_emo_drop": "Resolución emocional · últimos 90 días",
  "an.t4_emo_drop_hint": "Basado en {n} sesiones · ≥2 por emoción",
  "an.t4_themes": "Temas",
  "an.t4_trend": "Tendencia de intensidad",
  "an.t4_before": "Antes",
  "an.t4_after": "Después",
  "an.t5_empty": "Aún no se han enviado planes semanales.",
  "an.t5_sent": "Enviados",
  "an.t5_open_rate": "Tasa de apertura",
  "an.t5_completion": "Tasa de finalización",
  "an.t5_sessions_done": "Sesiones hechas",
  "an.t5_top_tech": "Técnicas principales",
  "an.t6_empty": "Aún no has publicado contenido.",
  "an.t6_posts": "Publicaciones",
  "an.t6_views": "Vistas",
  "an.t6_favorites": "Favoritos",
  "an.t6_revenue": "Ingresos",
  "an.t6_top": "Contenido top",
  "an.t7_empty": "Aún no hay datos de círculos.",
  "an.t7_ic": "Inner Circle",
  "an.t7_lc": "Local Circle",
  "an.t7_members": "Miembros",
  "an.t7_revenue": "Ingresos",
  "an.t7_messages": "Mensajes",
  "an.t7_snapshots": "Entregas",
  "an.t8_empty": "Aún no hay referidos con tu código.",
  "an.t8_referrals": "Referidos",
  "an.t8_conversion": "Conversión",
  "an.t8_revenue": "Ingresos",
  "an.t8_active_phases": "Fases activas",
  "an.t8_phase_break": "Desglose por fases",
  "an.t9_msgs": "Mensajes enviados",
  "an.t9_response": "Respuesta media",
  "an.t9_snap_delivered": "Entregas hechas",
  "an.t9_snap_pending": "Entregas pendientes",
  "an.t9_circle_activity": "Actividad de círculos",
  "an.t10_empty": "Aún no hay objetivos de clientes.",
  "an.t10_client_count": "Clientes",
  "an.t10_goals_total": "Objetivos totales",
  "an.t10_goals_done": "Objetivos logrados",
  "an.t10_beliefs_total": "Creencias",
  "an.t10_beliefs_trans": "Transformadas",
  "an.t10_top_cats": "Categorías top",
  "an.t10_show_examples": "Mostrar ejemplos anónimos",
  "an.t10_hide_examples": "Ocultar ejemplos",
  "an.t10_examples_note": "Anonimizado — sin nombres, solo categoría y formulación.",
  "an.t10_goals": "Objetivos",
  "an.t10_beliefs": "Creencias",
  "an.t11_period_a": "Periodo A",
  "an.t11_period_b": "Periodo B",
  "an.t11_gross": "Ingresos brutos",
  "an.t11_bookings": "Reservas",
  "an.t11_msgs": "Mensajes",
  "an.t11_new_clients": "Clientes nuevos",
  "an.t12_hint": "Elige paneles y exporta un informe personalizado.",
  "an.t12_templates": "Plantillas guardadas",
  "an.t12_templates_none": "Aún no hay plantillas guardadas.",
  "an.t12_template_run": "Exportar",
  "an.t12_pick": "Paneles para el informe",
  "an.t12_all_on": "Todos",
  "an.t12_all_off": "Ninguno",
  "an.t12_tpl_name_ph": "Nombre de plantilla",
  "an.t12_tpl_save": "Guardar plantilla",
  "an.t12_tpl_saved": "Plantilla guardada.",
  "an.t12_pdf": "PDF",
  "an.t12_csv": "CSV",
  "an.t12_xlsx": "Excel",
  "an.t12_download_failed": "Descarga fallida. Inténtalo de nuevo.",

  // ── Publicidad / Campañas (Phase 4e · e2) ──
  "ads.back": "Panel de coach",
  "ads.eyebrow": "Publicidad",
  "ads.title": "Campañas publicitarias",
  "ads.subtitle": "Promociona publicaciones y ofertas con audiencia de IA, presupuesto y analítica.",
  "ads.wallet": "Saldo de publicidad",
  "ads.wallet_hint": "Saldo para campañas por impresión o por clic.",
  "ads.topup": "Recargar",
  "ads.topup_ok": "Saldo de publicidad recargado.",
  "ads.topup_title": "Recargar saldo de publicidad",
  "ads.topup_sub": "Saldo actual: {balance}",
  "ads.topup_custom": "Importe personalizado",
  "ads.topup_confirm": "Recargar {amount}",
  "ads.topup_note": "Pago seguro con Stripe. Factura UE incluida.",
  "ads.topup_billing": "Completa primero tus datos de facturación (Cuenta).",
  "ads.new_campaign": "Nueva campaña",
  "ads.new_campaign_sub": "Creada en 3 pasos — incl. audiencia de IA.",
  "ads.offerings": "Gestionar ofertas",
  "ads.offerings_sub": "Edita sesiones, paquetes y precios.",
  "ads.reco_title": "Sugerencias para promocionar",
  "ads.reco_sub": "Elegidas automáticamente por resonancia orgánica.",
  "ads.reco_cta": "Promocionar ahora",
  "ads.reco_reason_default": "Fuerte resonancia orgánica.",
  "ads.reco_reason_views": "Muchas vistas — ideal para escalar.",
  "ads.reco_reason_reactions": "Muchas reacciones de tu comunidad.",
  "ads.reco_reason_comments": "Comentarios y conversaciones animadas.",
  "ads.reco_reason_bookmarks": "Muy guardado — interés real.",
  "ads.reco_reason_freshness": "Fresco y actual — perfecto para un impulso.",
  "ads.reco_reason_bookings": "Buenas cifras de reservas.",
  "ads.reco_reason_favorites": "Muy marcado como favorito.",
  "ads.impressions": "Impresiones",
  "ads.clicks": "Clics",
  "ads.ctr": "CTR",
  "ads.total_spent": "Gastado",
  "ads.budget_left": "Presupuesto restante",
  "ads.my_campaigns": "Mis campañas",
  "ads.empty": "Aún no hay campañas. Crea la primera.",
  "ads.untitled": "Sin título",
  "ads.subject_post": "Publicación",
  "ads.subject_offering": "Oferta",
  "ads.billing_impression": "por impresión",
  "ads.billing_click": "por clic",
  "ads.status_all": "Todas",
  "ads.status_running": "Activa",
  "ads.status_paused": "Pausada",
  "ads.status_pending_review": "En revisión",
  "ads.status_approved": "Aprobada",
  "ads.status_completed": "Finalizada",
  "ads.status_rejected": "Rechazada",
  "ads.pause": "Pausar",
  "ads.resume": "Reanudar",
  "ads.stop": "Detener",
  "ads.view_details": "Detalles",
  "ads.spent_of": "{spent} de {total} gastado",
  "ads.new_title": "Nueva campaña",
  "ads.new_step": "Paso {n} de 3",
  "ads.pick_subject": "¿Qué quieres promocionar?",
  "ads.pick_subject_hint": "Elige una de tus publicaciones u ofertas.",
  "ads.subject_offerings": "Ofertas",
  "ads.subject_posts": "Publicaciones",
  "ads.no_subjects": "Aún no hay publicaciones ni ofertas para promocionar.",
  "ads.audience": "Audiencia",
  "ads.ai_button": "Sugerencia de IA",
  "ads.ai_ok": "Audiencia sugerida.",
  "ads.ai_why": "Por qué esta audiencia",
  "ads.field_themes": "Temas",
  "ads.field_regions": "Regiones",
  "ads.field_education_backgrounds": "Formación",
  "ads.field_life_situations": "Situaciones de vida",
  "ads.field_other_traits": "Otros rasgos",
  "ads.budget": "Presupuesto",
  "ads.daily_eur": "Diario (€)",
  "ads.duration_days": "Duración (días)",
  "ads.total": "Presupuesto total",
  "ads.billing_mode": "Facturación",
  "ads.payment": "Pago",
  "ads.pay_stripe": "Stripe",
  "ads.pay_credits": "Saldo",
  "ads.credits_short": "Saldo insuficiente — recarga por favor.",
  "ads.no_credits": "Tu saldo de publicidad no es suficiente.",
  "ads.new_ok": "Campaña creada — ahora en revisión.",
  "ads.next": "Siguiente",
  "ads.back_step": "Atrás",
  "ads.launch": "Lanzar campaña",
  "ads.detail_title": "Campaña",
  "ads.detail_not_found": "Campaña no encontrada.",
  "ads.range": "{n} días",
  "ads.chart_title": "Impresiones y clics por día",
  "ads.range_totals": "Total · {n} días",

  // ── Recomendaciones (Phase 4e · e3) ──
  "recs.back": "Panel de coach",
  "recs.eyebrow": "Recomendaciones",
  "recs.title": "Recomendaciones",
  "recs.subtitle": "Impacto de tus recomendaciones de publicaciones y recomendaciones cálidas en tu perfil.",
  "recs.tab_posts": "Recom. de publicaciones",
  "recs.tab_testimonials": "Recom. de perfil",
  "recs.sent": "Enviadas",
  "recs.opened": "Abiertas",
  "recs.saved": "Guardadas",
  "recs.booked": "Reservadas",
  "recs.per_post": "Por publicación",
  "recs.see_clients": "Ver clientes",
  "recs.untitled": "Sin título",
  "recs.posts_empty_title": "Aún no has enviado recomendaciones",
  "recs.posts_empty_sub": "Recomienda publicaciones adecuadas a tus clientes — el impacto aparece aquí.",
  "recs.detail_sub": "Por cliente: abierta, guardada, reservada.",
  "recs.no_clients": "Aún no hay clientes para esta publicación.",
  "recs.unknown_client": "Cliente desconocido",
  "recs.dismissed": "Descartada",
  "recs.pending": "Pendiente",
  "recs.testimonials_empty_title": "Aún no hay recomendaciones",
  "recs.testimonials_empty_sub": "Los clientes pueden dejar una recomendación cálida tras una sesión.",
  "recs.testimonials_count": "{n} recomendación(es) en tu perfil",
  "recs.deleted": "Recomendación eliminada.",

  // ── Reservas en profundidad (Phase 4f) ──
  "bk.back": "Panel de coach",
  "bk.eyebrow": "Reservas",
  "bk.title": "Reservas",
  "bk.subtitle": "Gestiona sesiones, reprogramaciones y tu política de cancelación.",
  "bk.tab_bookings": "Reservas",
  "bk.tab_reschedule": "Reprogramaciones",
  "bk.tab_refund": "Política de cancelación",
  "bk.kpi_upcoming": "Próximas",
  "bk.kpi_completed": "Completadas",
  "bk.kpi_pending": "Solicitudes de cancelación",
  "bk.kpi_gross": "Ingresos brutos",
  "bk.scope_upcoming": "Próximas",
  "bk.scope_cancellation_pending": "Solicitudes de cancelación",
  "bk.scope_completed": "Completadas",
  "bk.scope_cancelled": "Canceladas",
  "bk.scope_all": "Todas",
  "bk.status_requested": "Solicitada",
  "bk.status_confirmed": "Confirmada",
  "bk.status_paid": "Pagada",
  "bk.status_pending": "Pendiente",
  "bk.status_completed": "Completada",
  "bk.status_pending_cancellation": "Cancelación solicitada",
  "bk.status_cancelled_refunded": "Cancelada (reembolsada)",
  "bk.status_cancelled_no_refund": "Cancelada",
  "bk.status_cancelled_refund_pending": "Cancelada (reembolso pendiente)",
  "bk.status_declined": "Rechazada",
  "bk.online": "En línea",
  "bk.session": "Sesión",
  "bk.client": "Cliente",
  "bk.reason": "Motivo",
  "bk.refund_per_policy": "Reembolso según política: {pct}%",
  "bk.approve_refund": "Aprobar y reembolsar",
  "bk.decline": "Rechazar",
  "bk.refunded": "Reembolsado: {amount} ({pct}%)",
  "bk.empty_title": "Sin reservas",
  "bk.empty_sub": "No hay nada que ver en esta vista por ahora.",
  "bk.load_failed": "No se pudieron cargar las reservas.",
  "bk.approved_toast": "Cancelación aprobada y reembolso emitido.",
  "bk.declined_toast": "Cancelación rechazada.",
  "bk.action_failed": "Acción fallida.",
  "bk.rs_title": "Auto-reprogramación",
  "bk.rs_sub": "Con cuánta antelación pueden los clientes reprogramar automáticamente sus sesiones.",
  "bk.rs_window_label": "Ventana de auto-aprobación (horas antes de la sesión)",
  "bk.rs_window_unit": "h",
  "bk.rs_saved": "La auto-reprogramación es ahora {n}h antes de la sesión.",
  "bk.rs_hint": "Los clientes solo pueden auto-reprogramar si la sesión está al menos a esta distancia en el futuro Y el nuevo horario está al menos a esta distancia. 0 = requiere siempre tu aprobación.",
  "bk.rs_invalid": "Introduce un número entre 0 y 336 horas.",
  "bk.rs_pending_title": "Pendientes de revisión",
  "bk.rs_pending_empty": "No hay solicitudes pendientes. 🌱",
  "bk.rs_currently": "Actualmente",
  "bk.rs_reason_too_close": "⚠️ Solicitada demasiado cerca del inicio de la sesión",
  "bk.rs_reason_no_slot": "ℹ️ Ninguno de los horarios del cliente estaba libre",
  "bk.rs_client_windows": "Sugerido por el cliente",
  "bk.rs_approve": "Aprobar",
  "bk.rs_reject_ph": "Mensaje opcional para el cliente",
  "bk.rs_counter": "🕰️ Contrapropuesta",
  "bk.rs_reject": "Rechazar",
  "bk.rs_approved_toast": "La sesión de {name} se ha movido.",
  "bk.rs_rejected_toast": "Se notificará a {name}.",
  "bk.cp_title": "Enviar contrapropuestas",
  "bk.cp_sub": "Sugiere horarios alternativos a {name}.",
  "bk.cp_add_slot": "Añadir horario",
  "bk.cp_message_ph": "Mensaje opcional",
  "bk.cp_send": "Enviar propuestas",
  "bk.cp_sent": "Contrapropuestas enviadas.",
  "bk.cp_need_one": "Elige al menos un horario.",
  "bk.rf_warn_bold": "La plataforma nunca asume pérdidas.",
  "bk.rf_warn_body": "Cualquier reembolso que acuerdes sale de tus ingresos. Stripe NO reembolsa la comisión de procesamiento cobrada en el pago — se queda con Stripe y se descuenta de tu pago. Elige niveles que puedas permitirte.",
  "bk.rf_your_tiers": "Tus niveles",
  "bk.rf_tiers_hint": "Los niveles se aplican en orden descendente de horas antes de la sesión.",
  "bk.rf_hours_before": "Horas antes",
  "bk.rf_percent": "Reembolso %",
  "bk.rf_add_tier": "Añadir nivel",
  "bk.rf_reset": "Predeterminado",
  "bk.rf_estimator": "¿Qué te cuesta?",
  "bk.rf_sample_price": "Precio de ejemplo",
  "bk.rf_at_tier": "En nivel",
  "bk.rf_refund_amount": "Importe del reembolso",
  "bk.rf_stripe_fee": "Comisión Stripe perdida",
  "bk.rf_out_of_pocket": "Tu coste",
  "bk.rf_commission_kept": "Comisión de plataforma (sigue debida)",
  "bk.rf_net_kept": "Tu neto retenido",
  "bk.rf_msg_to_clients": "Mensaje a los clientes",
  "bk.rf_msg_ph": "p. ej. reprogramar es gratis con 48h de antelación.",
  "bk.rf_save": "Guardar",
  "bk.rf_saved": "Tu política de cancelación se ha actualizado.",

  // Plantillas de audiencia (mejora del asistente)
  "ads.tpl_label": "Plantillas de audiencia",
  "ads.tpl_none": "Aún no hay plantillas guardadas.",
  "ads.tpl_save": "Guardar",
  "ads.tpl_name_ph": "Nombre de plantilla",
  "ads.tpl_saved": "Audiencia guardada como plantilla.",
  "ads.tpl_applied": "Plantilla «{name}» aplicada.",
  "ads.tpl_deleted": "Plantilla eliminada.",
  "ads.tpl_save_hint": "Guarda los campos de audiencia actuales para reutilizarlos.",
  "zoom.title": "Zoom",
  "zoom.soon": "El equipo lo está configurando — disponible pronto.",
  "zoom.connected": "Conectado",
  "zoom.hint": "Conecta tu cuenta de Zoom para enlaces de reunión automáticos en reservas online.",
  "zoom.connect": "Conectar Zoom",
  "zoom.disconnect": "Desconectar",
  "zoom.t_connected": "Cuenta de Zoom conectada.",
  "zoom.t_error": "Error al conectar con Zoom.",
  "zoom.t_disconnected": "Zoom desconectado.",
  "zoom.not_setup": "Zoom aún no está configurado.",

  "pl.tab_programs": "Programas de respiración",
  "bp.sub": "Crea programas de respiración de varios días con 3–5 técnicas y compártelos por asignación o código.",
  "bp.new": "Nuevo programa",
  "bp.empty_title": "Aún no hay programas de respiración",
  "bp.empty_sub": "Crea tu primer programa de varios días para tus clientes.",
  "bp.techniques_n": "{n} técnicas",
  "bp.days_n": "{n} días",
  "bp.assigned_n": "{n} asignados",
  "bp.share": "Compartir",
  "bp.archive_confirm": "¿Archivar el programa «{name}»?",
  "bp.archived": "Programa archivado.",
  "bp.editor_new_title": "Nuevo programa de respiración",
  "bp.editor_edit_title": "Editar programa",
  "bp.editor_desc": "Elige 3–5 técnicas y define duración y ritmo.",
  "bp.name_ph": "Nombre del programa",
  "bp.desc_ph": "Descripción breve (opcional)",
  "bp.days_label": "Duración (días)",
  "bp.rhythm_label": "Ritmo",
  "bp.tech_count": "Técnicas ({n}/5)",
  "bp.min": "min",
  "bp.note_ph": "Nota",
  "bp.need_valid": "Se requieren nombre y 3–5 técnicas.",
  "bp.created": "Programa creado.",
  "bp.updated": "Programa actualizado.",
  "bp.save_failed": "Error al guardar.",
  "bp.share_title": "Compartir «{name}»",
  "bp.share_desc": "Asigna el programa directamente a un cliente o comparte el código {code}.",
  "bp.no_clients": "Aún no hay clientes.",
  "bp.assign_note_ph": "Mensaje personal (opcional)",
  "bp.assign": "Asignar",
  "bp.sending": "Enviando…",
  "bp.assigned_ok": "Programa asignado.",
  "bp.assign_failed": "Error en la asignación.",
  "bp.sched_all_daily": "Todas a diario",
  "bp.sched_rotate": "Rotativo",
  "bp.tech_box": "Respiración en caja",
  "bp.tech_478": "4-7-8",
  "bp.tech_coherent": "Respiración coherente",
  "bp.tech_physiological_sigh": "Suspiro fisiológico",
  "bp.tech_cooling": "Respiración refrescante",
  "bp.tech_bhramari": "Bhramari",
  "bp.tech_nadi_shodhana": "Respiración alterna",
  "bp.tech_ocean": "Respiración oceánica",
  "bp.tech_wim_hof": "Wim Hof",
  "bp.tech_kapalabhati": "Kapalabhati",

  "cd.back": "Pulso de clientes",
  "cd.no_access_title": "Sin acceso",
  "cd.no_access_sub": "No hay una relación activa con este cliente.",
  "cd.client_fallback": "Cliente",
  "cd.upcoming": "Próximas sesiones ({n})",
  "cd.no_upcoming": "No hay próximas sesiones.",
  "cd.past": "Sesiones pasadas ({n})",
  "cd.no_past": "Aún no hay sesiones pasadas.",
  "cd.plans": "Planes semanales ({n})",
  "cd.no_plans": "No se han compartido planes semanales.",
  "cd.plan_meta": "{slots} bloques · {done} hechos · {week}",
  "cd.flexible": "flexible",
  "cd.session_fallback": "Sesión",
  "cd.sharing_title": "Datos compartidos",
  "cd.no_sharing": "Este cliente no comparte datos de Deep Within contigo por ahora.",
  "cd.analysis_title": "Análisis",
  "cd.digestions": "Digestiones",
  "cd.transformations": "Transformaciones",
  "cd.journal": "Diario",
  "cd.no_emotions": "No hay datos de emociones compartidos en el periodo.",
  "cd.weva": "Informes WEVA ({n})",
  "cd.no_weva": "Aún no hay informes WEVA para este cliente.",
  "cd.days_n": "{n} días",
  "cd.snapshots_n": "{n} solicitud(es) de snapshot",
  "cd.attachments": "Adjuntos compartidos ({n})",
  "cd.load_failed": "No se pudo cargar el cliente.",
  "cd.scope_share_events": "Eventos",
  "cd.scope_share_hrv": "HRV",
  "cd.scope_share_plans": "Planes",
  "cd.scope_share_ai_reports": "Informes de IA",
  "cd.scope_share_feed_activity": "Actividad del feed",
  "cd.scope_share_beliefs": "Creencias",
  "cd.scope_share_upper_limits": "Límites superiores",
  "cd.scope_share_goals": "Objetivos",
  "cd.scope_share_comfortzone": "Zona de confort",
  "cd.scope_share_coping": "Afrontamiento",
  "cd.scope_share_journal": "Diario",
  "cd.scope_share_weva_reports": "Informes WEVA",
  "cd.count_beliefs": "Creencias",
  "cd.count_upper_limits": "Límites superiores",
  "cd.count_goals": "Objetivos",
  "cd.count_comfortzone": "Zona de confort",
  "cd.count_coping": "Afrontamiento",
  "cd.count_journal": "Entradas de diario",
  "cd.count_ai_reports": "Informes de IA",
  "cd.count_events": "Eventos",

  // ── Phase A P1 ──
  // Profundidad de colaboración
  "col.tab_projects": "Proyectos",
  "col.tab_stats": "Estadísticas",
  "col.tab_ai": "Recomendaciones IA",
  "col.stats_title": "Próximamente",
  "col.stats_body": "Reservas, ingresos y retención de clientes por colaboración en un panel claro.",
  "col.ai_title": "Próximamente",
  "col.ai_body": "WEVA encuentra coaches compatibles para nuevas colaboraciones según temas, públicos y disponibilidad en común.",
  "col.project_type_offering": "Oferta",
  "col.project_type_circle": "Círculo",
  "col.project_status_active": "Activo",
  "col.project_status_archived": "Archivado",
  "col.project_empty_active": "Aún no hay proyectos activos",
  "col.project_empty_archived": "No hay proyectos archivados",
  "col.project_empty_hint": "Las ofertas y círculos compartidos aparecen aquí como proyectos.",
  "col.project_members_n": "{n} miembros",
  "col.project_tasks": "tareas",
  "col.project_revenue": "Ingresos totales",
  "col.project_my_share": "Tu parte ({pct}%)",
  "col.project_participants": "Participantes",
  "col.project_team": "Equipo de coaches",
  "col.project_documents": "Documentos",
  "col.project_purchases": "Compras",
  "col.accept": "Aceptar",
  "col.add_block_hint": "Añade al menos un bloque.",
  "col.archive": "Archivar",
  "col.back": "Panel del coach",
  "col.badge_client": "Cliente",
  "col.badge_coach": "Coach",
  "col.bill_monthly": "Mensual",
  "col.bill_one_time": "Pago único",
  "col.bill_yearly": "Anual",
  "col.billing": "Facturación",
  "col.block_title_ph": "Título del bloque",
  "col.blocks": "Bloques",
  "col.bookings_suffix": " · {n} reservas",
  "col.chat_fallback": "Chat",
  "col.chat_offer": "Oferta de chat",
  "col.chatoffer_active": "Oferta de chat activa",
  "col.chatoffer_desc": "Ofrece a tus clientes acceso de chat de pago contigo.",
  "col.chatoffer_saved": "Oferta de chat guardada.",
  "col.chatoffer_title": "Oferta de chat de pago",
  "col.chats_empty_text": "Inicia un chat desde la pestaña «Conectados».",
  "col.chats_empty_title": "Aún no hay chats",
  "col.circ_confirmed": "Círculo confirmado.",
  "col.circ_empty_text": "Funda un círculo de co-coaching con coaches conectados: los ingresos se comparten.",
  "col.circ_empty_title": "Aún no hay círculos compartidos",
  "col.circ_pending": "Esperando confirmaciones",
  "col.circle_created": "Círculo compartido creado.",
  "col.circle_name_ph": "p. ej. Breath & Mind Collective",
  "col.circles_n": "{n} círculos",
  "col.co_coaches_connected": "Co-coaches (conectados)",
  "col.coach_fallback": "Coach",
  "col.coaches": "Coaches",
  "col.coaches_connected": "Coaches (conectados)",
  "col.confirm": "Confirmar",
  "col.confirmed_of": "{confirmed}/{total} confirmados",
  "col.conn_empty_text": "Encuentra coaches en la pestaña «Buscar» y envía una solicitud.",
  "col.conn_empty_title": "Aún no hay conexiones",
  "col.create": "Crear",
  "col.create_failed": "No se pudo crear.",
  "col.day": "Día",
  "col.days": "Días",
  "col.decline": "Rechazar",
  "col.dialog_new_circle_desc": "Un círculo de co-coaching con membresía compartida. Todos los coaches deben aceptar antes de publicarlo.",
  "col.dialog_new_offering_desc": "Un paquete de bloques (formación, 1:1, producto). Los ingresos por bloque se contabilizan según tu reparto.",
  "col.duration_min": "Duración (min)",
  "col.err_add_block": "Añade al menos un bloque.",
  "col.err_block_day": "Bloque {n}: al menos un día con fecha/hora.",
  "col.err_block_product": "Bloque {n}: elige un producto.",
  "col.err_block_split": "Bloque {n}: el reparto debe sumar 100 % (actualmente {sum} %).",
  "col.err_block_title": "Bloque {n}: falta el título.",
  "col.err_name_min": "Nombre (mín. 3 caracteres).",
  "col.err_override_high": "El precio del paquete no puede ser mayor que la suma.",
  "col.err_pick_coach": "Selecciona al menos un coach.",
  "col.err_split_100": "El reparto debe sumar 100 % (actualmente {sum} %).",
  "col.err_title_min": "Título (mín. 3 caracteres).",
  "col.err_total_zero": "El precio total debe ser mayor que 0.",
  "col.executing_coaches": "Coaches ejecutores",
  "col.extras": "Extras (separados por comas)",
  "col.extras_ph": "p. ej. notas de voz, resumen en PDF",
  "col.eyebrow": "Colaboración",
  "col.f_description": "Descripción",
  "col.f_name": "Nombre",
  "col.f_title": "Título",
  "col.filter_all": "Todos",
  "col.filter_coaches": "Coaches",
  "col.filter_with_client": "Con cliente",
  "col.fully_booked": "Completo",
  "col.included_msgs": "Mensajes incluidos",
  "col.incoming_n": "Entrantes ({n})",
  "col.kind_one_on_one": "Sesión 1:1",
  "col.kind_product": "Producto",
  "col.kind_training": "Formación",
  "col.max_participants": "Máx. participantes (0 = ilimitado)",
  "col.message": "Mensaje",
  "col.message_label": "Mensaje (opcional)",
  "col.message_ph": "Preséntate brevemente y describe tu idea…",
  "col.msg_deleted": "Mensaje eliminado",
  "col.msg_input_ph": "Escribe un mensaje…",
  "col.needs_confirm": "Falta tu confirmación",
  "col.new_circle": "Nuevo círculo compartido",
  "col.new_offering": "Nueva oferta compartida",
  "col.no_coaches_text": "Prueba con otro término de búsqueda.",
  "col.no_coaches_title": "No se encontraron coaches",
  "col.no_connected_coaches": "Aún no hay coaches conectados. Conéctate primero en la pestaña «Buscar».",
  "col.no_incoming": "No hay solicitudes entrantes.",
  "col.no_messages": "Aún no hay mensajes. Escribe el primero 👋",
  "col.no_outgoing": "No hay solicitudes enviadas.",
  "col.no_shared_clients_desc": "Ambos coaches necesitan el mismo cliente con consentimiento de colaboración.",
  "col.no_shared_clients_title": "No hay clientes compartidos",
  "col.off_accepted": "Oferta aceptada.",
  "col.off_archived": "Oferta archivada.",
  "col.off_declined": "Oferta rechazada.",
  "col.off_empty_text": "Crea un paquete con coaches conectados: los ingresos se reparten automáticamente.",
  "col.off_empty_title": "Aún no hay ofertas compartidas",
  "col.off_published": "Oferta publicada.",
  "col.offering_created": "Oferta compartida creada.",
  "col.offering_fallback": "Oferta compartida",
  "col.offering_title_ph": "p. ej. paquete retiro Breath & Body",
  "col.offers_n": "{n} ofertas",
  "col.open_desc": "Otros coaches pueden verte en la red de colaboración y enviarte solicitudes.",
  "col.open_title": "Abierto a colaboración",
  "col.outgoing_n": "Enviadas ({n})",
  "col.override_price": "Anular precio del paquete (descuento)",
  "col.package_price_ph": "Precio del paquete (EUR)",
  "col.pending": "Pendiente",
  "col.phone_included": "Llamada telefónica incluida",
  "col.phone_minutes": "Minutos de teléfono",
  "col.pick_client_desc": "Solo clientes que dieron consentimiento de colaboración a ambos coaches.",
  "col.pick_client_title": "¿Qué cliente conectar?",
  "col.pick_product_ph": "Elige producto/método/plan…",
  "col.price_eur": "Precio (EUR)",
  "col.publish": "Publicar",
  "col.req_accepted": "Solicitud aceptada.",
  "col.req_declined": "Solicitud rechazada.",
  "col.req_empty_text": "Las solicitudes entrantes y enviadas aparecen aquí.",
  "col.req_empty_title": "No hay solicitudes abiertas",
  "col.request": "Solicitar",
  "col.request_failed": "La solicitud falló.",
  "col.request_sent": "Solicitud enviada a {name}.",
  "col.request_to": "Solicitud a {name}",
  "col.rev_split": "Reparto de ingresos (%)",
  "col.save": "Guardar",
  "col.search_client_ph": "Buscar cliente…",
  "col.search_coach_ph": "Buscar coach por nombre o especialidad…",
  "col.seats": "Plazas (opcional)",
  "col.send_request": "Enviar solicitud",
  "col.sending": "Enviando…",
  "col.seo": "Coach · Colaboración",
  "col.shared_chat": "Chat compartido",
  "col.split_all": "Todos",
  "col.split_executing": "Ejecutores",
  "col.split_pct": "Reparto (%)",
  "col.st_archived": "Archivado",
  "col.st_draft": "Borrador",
  "col.st_pending": "Esperando confirmación",
  "col.st_published": "Publicado",
  "col.stat_connected": "Coaches conectados",
  "col.stat_in": "Solicitudes entrantes",
  "col.stat_offerings": "Ofertas compartidas",
  "col.stat_out": "Solicitudes salientes",
  "col.subtitle": "Conéctate con otros coaches, chatea en conjunto y crea ofertas compartidas.",
  "col.sum_100": "La suma debe ser 100 %.",
  "col.sum_blocks": "Suma de bloques",
  "col.tab_chats": "Chats",
  "col.tab_circles": "Círculos compartidos",
  "col.tab_connected": "Conectados",
  "col.tab_find": "Buscar",
  "col.tab_offerings": "Ofertas compartidas",
  "col.tab_requests": "Solicitudes",
  "col.title": "Colaboración",
  "col.topic_label": "Tema (opcional)",
  "col.topic_ph": "p. ej. retiro conjunto",
  "col.unlimited_msgs": "Mensajes ilimitados",
  "col.you": "Tú",

  // Comparación de instantáneas WEVA
  "cd.snap_title": "Comparación de instantáneas WEVA",
  "cd.snap_request": "Solicitar instantánea",
  "cd.snap_requesting": "Solicitando…",
  "cd.snap_requested": "Solicitud de instantánea enviada.",
  "cd.snap_request_failed": "La solicitud falló.",
  "cd.snap_need_more": "Aún no hay datos suficientes para comparar. Instantáneas existentes: {count}. Se necesitan dos instantáneas aprobadas.",
  "cd.snap_days_between": "{n} días entre instantáneas",
  "cd.snap_beliefs_new": "{n} creencias nuevas",
  "cd.snap_beliefs_dissolved": "{n} disueltas",
  "cd.snap_beliefs_recurring": "{n} recurrentes",
  "cd.snap_pillars_shifted": "Áreas de foco que cambiaron",
  "cd.snap_pillar_realize": "Reconocer",
  "cd.snap_pillar_designate": "Nombrar",
  "cd.snap_pillar_release": "Soltar",
  "cd.snap_practice_shift": "Próxima práctica cambiada",
  "cd.snap_previous": "Anterior",
  "cd.snap_latest": "Más reciente",

  // Formularios de consentimiento
  "cf.meta_title": "Consentimientos",
  "cf.back": "Panel de coach",
  "cf.eyebrow": "Consentimiento",
  "cf.title": "Formularios de consentimiento",
  "cf.subtitle": "Crea plantillas que los clientes firman digitalmente antes de reservar.",
  "cf.new": "Nueva plantilla",
  "cf.empty_title": "Aún no hay plantillas",
  "cf.empty_sub": "Crea un formulario de consentimiento que deba firmarse antes de reservar.",
  "cf.badge_required": "Obligatorio antes de reservar",
  "cf.sig_count": "{n} firmas",
  "cf.delete_confirm": "¿Archivar esta plantilla?",
  "cf.deleted": "Plantilla archivada.",
  "cf.saved": "Plantilla guardada.",
  "cf.dialog_new": "Nuevo formulario de consentimiento",
  "cf.dialog_edit": "Editar plantilla",
  "cf.dialog_desc": "Título y texto del formulario. Los clientes firman digitalmente en la app.",
  "cf.f_title": "Título",
  "cf.f_title_ph": "p. ej. Exención de responsabilidad de breathwork",
  "cf.f_body": "Texto",
  "cf.f_body_ph": "Escribe aquí el texto completo del consentimiento…",
  "cf.f_required": "Obligatorio antes de reservar",
  "cf.f_required_hint": "Los clientes deben firmar antes de poder reservar.",
  "cf.version_note": "Las ediciones de texto suben la versión — las firmas existentes se conservan.",
  "cf.err_title": "Introduce un título.",
  "cf.err_body": "Introduce el texto.",
  "cf.sig_title": "Firmas",
  "cf.sig_empty": "Aún no hay firmas.",
  "cf.sig_version": "Versión {v}",

  // Programador de publicaciones
  "ps.tab_label": "Planificador",
  "ps.new": "Nuevo borrador",
  "ps.saved": "Guardado.",
  "ps.published": "Publicado.",
  "ps.status_draft": "Borradores",
  "ps.status_scheduled": "Programados",
  "ps.status_published": "Publicados",
  "ps.next_hint": "La próxima publicación «{title}» se publica el {when}.",
  "ps.wd_mon": "Lun",
  "ps.wd_tue": "Mar",
  "ps.wd_wed": "Mié",
  "ps.wd_thu": "Jue",
  "ps.wd_fri": "Vie",
  "ps.wd_sat": "Sáb",
  "ps.wd_sun": "Dom",
  "ps.undated_title": "Borradores sin fecha",
  "ps.undated_empty": "No hay borradores sin programar.",
  "ps.dialog_new": "Nueva publicación",
  "ps.dialog_edit": "Editar publicación",
  "ps.dialog_desc": "Crea un borrador o programa la publicación para más tarde.",
  "ps.f_title": "Título",
  "ps.f_title_ph": "Titular de la publicación",
  "ps.f_body": "Contenido",
  "ps.f_body_ph": "Escribe tu publicación…",
  "ps.f_scheduled": "Programado para",
  "ps.f_scheduled_hint": "Déjalo vacío para un borrador sin fecha. Con fecha se publica automáticamente.",
  "ps.f_inner_circle": "Solo Inner Circle",
  "ps.publish_now": "Publicar ahora",
  "ps.err_title": "Introduce un título.",

  // Ofertas de afiliados
  "aff.tab_label": "Afiliados",
  "aff.intro": "Enlaces de afiliados externos que aparecen en tu perfil público.",
  "aff.new": "Nueva oferta de afiliado",
  "aff.saved": "Guardado.",
  "aff.deleted": "Eliminado.",
  "aff.delete_confirm": "¿Eliminar esta oferta de afiliado?",
  "aff.locked_title": "Solo Coach Pro",
  "aff.locked_sub": "Las ofertas de afiliados están disponibles para suscriptores Coach Pro y miembros Founder 50/500.",
  "aff.empty_title": "Aún no hay ofertas de afiliados",
  "aff.empty_sub": "Enlaza productos que recomiendas — con etiqueta de publicidad automática.",
  "aff.ad_badge": "Publicidad",
  "aff.inactive": "Inactivo",
  "aff.dialog_new": "Nueva oferta de afiliado",
  "aff.dialog_edit": "Editar oferta",
  "aff.dialog_desc": "El enlace se abre en el navegador externo y se etiqueta automáticamente como publicidad.",
  "aff.f_title": "Título",
  "aff.f_title_ph": "p. ej. Mi diario favorito",
  "aff.f_url": "Enlace de afiliado",
  "aff.f_desc": "Descripción",
  "aff.f_desc_ph": "Descripción breve (máx. 400 caracteres)",
  "aff.f_category": "Categoría",
  "aff.f_category_ph": "p. ej. Libros",
  "aff.f_price": "Precio",
  "aff.f_price_ph": "opcional",
  "aff.f_cover": "Imagen de portada",
  "aff.f_cover_hint": "Opcional. Aparece en la tarjeta de afiliado de tu perfil público.",
  "aff.compete_hint": "Nota: no se permiten enlaces a apps competidoras o plataformas con las mismas funciones que My Within.",
  "aff.ack_label": "Soy consciente del deber de divulgación y etiqueto este enlace como publicidad.",
  "aff.ack_compete": "Confirmo que este enlace no lleva a una plataforma competidora.",
  "aff.err_title": "Introduce un título.",
  "aff.err_url": "Introduce una URL válida (http/https).",
  "aff.err_ack": "Marca ambas confirmaciones.",

  // Configuración del coach
  "cs.meta_title": "Configuración del coach",
  "cs.back": "Panel de coach",
  "cs.eyebrow": "Configuración",
  "cs.title": "Configuración del coach",
  "cs.subtitle": "Cuatro pasos para un perfil de coach listo — luego ganas la insignia Founding Coach.",
  "cs.progress_label": "{done} de {total} pasos completados",
  "cs.badge_title": "Insignia Founding Coach activa ✨",
  "cs.badge_sub": "Llevas la insignia Founding Coach en tu perfil {n} días más.",
  "cs.step_n": "Paso {n}",
  "cs.done": "Hecho",
  "cs.mark_done": "Marcar como hecho",
  "cs.step_consent_title": "Crear un formulario de consentimiento",
  "cs.step_consent_sub": "Crea una plantilla que los clientes firman antes de reservar.",
  "cs.step_consent_cta": "Ir a consentimientos",
  "cs.step_story_title": "Comparte tu primera historia",
  "cs.step_story_sub": "Aparece en el muro de historias y genera confianza.",
  "cs.step_story_cta": "Ir a Social y contenido",
  "cs.step_program_title": "Crear un programa de respiración",
  "cs.step_program_sub": "Crea un programa que puedas asignar a clientes.",
  "cs.step_program_cta": "Ir a planes",
  "cs.step_invite_title": "Invita a tu primer cliente",
  "cs.step_invite_sub": "Comparte tu código de invitación y trae a tus primeros clientes.",
  "cs.step_invite_cta": "Mostrar código de invitación",

  // ── Phase A P2 · Hub de ajustes ──
  "cset.meta_title": "Ajustes",
  "cset.back_dashboard": "Panel de coach",
  "cset.eyebrow": "Cuenta",
  "cset.title": "Ajustes",
  "cset.subtitle": "Cuenta, reglas de reservas, marca, informes y créditos en un solo lugar.",
  "cset.group_account": "Cuenta",
  "cset.group_bookings": "Reservas",
  "cset.group_brand": "Marca e informes",
  "cset.group_billing": "Facturación",
  "cset.group_language": "Idioma",
  "cset.row_profile": "Perfil y marca",
  "cset.row_profile_sub": "Perfil público, bio y marca.",
  "cset.row_verify": "Verificación",
  "cset.row_verify_sub": "Sube tu cualificación y estado.",
  "cset.row_availability": "Disponibilidad",
  "cset.row_availability_sub": "Abre y cierra franjas semanales.",
  "cset.row_refund": "Cancelación y reembolsos",
  "cset.row_refund_sub": "Tus propios niveles de reembolso y costes.",
  "cset.row_reschedule": "Reprogramaciones",
  "cset.row_reschedule_sub": "Ventana de aprobación automática y solicitudes.",
  "cset.row_branding": "Marca personalizada",
  "cset.row_branding_sub": "Logo, color de marca y pie de email.",
  "cset.row_digest": "Vista previa del resumen semanal",
  "cset.row_digest_sub": "Tus reservas de colaboración de la última semana.",
  "cset.row_credits": "Créditos · {n}",
  "cset.row_credits_sub": "Recarga créditos para anuncios y más.",
  "cset.row_language": "Idioma de la app",
  "cset.logout": "Cerrar sesión",

  // Cancelación y reembolsos
  "refpol.meta_title": "Cancelación y reembolsos",
  "refpol.eyebrow": "Reservas",
  "refpol.title": "Cancelación y reembolsos",
  "refpol.subtitle": "Define tus propios niveles de reembolso que anulan los predeterminados de la plataforma.",
  "refpol.warn_bold": "La plataforma nunca absorbe pérdidas.",
  "refpol.warn_body": "Cualquier reembolso sale de tus ingresos. Stripe NO reembolsa la comisión de procesamiento — se queda con Stripe y se descuenta de tu pago. Elige solo niveles que puedas asumir.",
  "refpol.your_tiers": "Tus niveles",
  "refpol.tiers_hint": "Los niveles se aplican en orden descendente de horas antes de la sesión.",
  "refpol.hours_before": "Horas antes",
  "refpol.refund_pct": "Reembolso %",
  "refpol.add_tier": "Añadir nivel",
  "refpol.reset": "Restablecer por defecto",
  "refpol.cost_title": "¿Cuánto cuesta un reembolso?",
  "refpol.sample_price": "Precio de ejemplo",
  "refpol.est_refund": "Importe del reembolso",
  "refpol.est_stripe": "Comisión Stripe perdida",
  "refpol.est_oop": "Tu coste directo",
  "refpol.est_commission": "Comisión de plataforma (aún debida)",
  "refpol.est_net": "Tu neto retenido",
  "refpol.notes": "Mensaje para clientes",
  "refpol.notes_ph": "p. ej. Reprogramar es gratis hasta 48h antes.",
  "refpol.save": "Guardar política",
  "refpol.saved": "Política guardada.",

  // Reprogramaciones
  "resch.meta_title": "Reprogramaciones",
  "resch.eyebrow": "Reservas",
  "resch.title": "Ajustes de reprogramación",
  "resch.subtitle": "Con cuánta antelación los clientes pueden reprogramar automáticamente sus sesiones.",
  "resch.window_label": "Ventana de aprobación automática (horas antes de la sesión)",
  "resch.window_hint": "Los clientes solo pueden reprogramar automáticamente si la sesión está al menos a esta distancia en el futuro Y la nueva franja también. Pon 0 para requerir tu aprobación siempre.",
  "resch.save": "Guardar",
  "resch.saved": "Guardado.",
  "resch.invalid": "Introduce un número entre 0 y 336.",
  "resch.pending_title": "Pendientes de revisión",
  "resch.pending_empty": "No hay solicitudes pendientes. 🌱",
  "resch.currently": "Actualmente",
  "resch.reason_too_close": "⚠️ Solicitado demasiado cerca del inicio de la sesión",
  "resch.reason_no_slot": "ℹ️ Ninguna de las franjas del cliente estaba libre",
  "resch.client_windows": "Sugerido por el cliente",
  "resch.approve": "Aprobar",
  "resch.approved": "Aprobado.",
  "resch.reject_ph": "Mensaje opcional para el cliente",
  "resch.reject": "Rechazar solicitud",
  "resch.rejected": "Rechazado.",

  // Marca personalizada
  "cbr.meta_title": "Marca personalizada",
  "cbr.eyebrow": "Marca",
  "cbr.title": "Marca personalizada",
  "cbr.subtitle": "Logo, color de marca y pie de página para tus emails a clientes.",
  "cbr.locked_title": "Solo Coach Pro",
  "cbr.locked_sub": "La marca personalizada es parte de Coach Pro. Mejora para usar tu propio logo y colores.",
  "cbr.f_logo": "URL del logo",
  "cbr.f_logo_hint": "URL https pública de tu logo (aparece en emails).",
  "cbr.f_color": "Color de marca",
  "cbr.f_footer": "Pie de email",
  "cbr.f_footer_ph": "p. ej. Con cariño, tu nombre de coach · legal/enlaces",
  "cbr.save": "Guardar marca",
  "cbr.saved": "Marca guardada.",
  "cbr.reset": "Restablecer",
  "cbr.reset_confirm": "¿Restablecer la marca a los valores por defecto?",
  "cbr.reset_done": "Restablecido por defecto.",
  "cbr.err_logo": "La URL del logo debe empezar con http:// o https://.",
  "cbr.err_color": "El color debe ser #RRGGBB (p. ej. #6B8E6E).",

  // Vista previa del resumen semanal
  "wdig.meta_title": "Resumen semanal",
  "wdig.eyebrow": "Informes",
  "wdig.title": "Vista previa del resumen semanal",
  "wdig.subtitle": "Tus reservas de colaboración de la última semana — como en el email.",
  "wdig.this_week": "Esta semana",
  "wdig.bookings": "Reservas",
  "wdig.gross": "Ingresos brutos",
  "wdig.trend": "Tendencia de 4 semanas",
  "wdig.offerings": "Por oferta",
  "wdig.offerings_empty": "Aún no hay reservas de colaboración esta semana.",
  "wdig.n_bookings": "{n} reservas",
  "wdig.last_sent": "Último envío {when} · {n} reservas · {gross}",

  // Créditos
  "cred.meta_title": "Créditos",
  "cred.eyebrow": "Facturación",
  "cred.title": "Créditos",
  "cred.subtitle": "Recarga créditos para publicar anuncios y usar funciones premium.",
  "cred.balance": "Saldo actual",
  "cred.per_credit": "{price} por crédito",
  "cred.buy": "Comprar",
  "cred.mock_granted": "{n} créditos otorgados (modo prueba).",
  "cred.vat_note": "Precios con IVA incluido. Facturado por Inside Out Harmony e.U. (Austria).",

  // ── Phase A P2 Parte 2 · Filas de ajustes ──
  "cset.row_professional": "Perfil profesional y certificados",
  "cset.row_professional_sub": "Profesión, métodos, cualificaciones y pruebas.",
  "cset.row_checkin": "Plantilla de check-in",
  "cset.row_checkin_sub": "Mensaje cálido para clientes en silencio.",
  "cset.group_growth": "Crecimiento",
  "cset.row_referral": "Recomienda y gana",
  "cset.row_referral_sub": "Tu código, enlaces y recompensas.",
  "cset.row_ic_invites": "Invitaciones Inner Circle",
  "cset.row_ic_invites_sub": "Invita clientes y sigue las aceptaciones.",
  "cset.row_wins": "Logros de clientes",
  "cset.row_wins_sub": "Historias de éxito y testimonios.",
  "cset.row_collectives": "Colectivos",
  "cset.row_collectives_sub": "Alianzas de coaches con ingresos compartidos.",
  "cset.group_support": "Soporte y ayuda",
  "cset.row_support": "Tickets de soporte",
  "cset.row_support_sub": "Pregunta al equipo de My Within directamente.",
  "cset.row_help": "Ayuda y FAQ",
  "cset.row_help_sub": "Respuestas a preguntas frecuentes.",
  "cset.row_tour": "Recorrido",
  "cset.row_tour_sub": "Vista rápida de tu panel.",
  "cset.row_upgrade": "Coach Pro",
  "cset.row_upgrade_sub": "Mejora para 10% de comisión, marca y más.",

  // Support
  "sup.meta_title": "Soporte", "sup.eyebrow": "Soporte", "sup.title": "Soporte y atención",
  "sup.subtitle": "Pregunta al equipo de My Within directamente — respondemos personalmente.",
  "sup.new": "Nueva solicitud", "sup.new_desc": "Elige un tema y describe tu problema.",
  "sup.f_category": "Tema", "sup.f_subject": "Asunto (opcional)", "sup.f_subject_ph": "Título breve",
  "sup.f_body": "Tu mensaje", "sup.f_body_ph": "Describe tu problema lo más concreto posible…",
  "sup.submit": "Enviar", "sup.created": "Solicitud enviada.", "sup.err_cat": "Elige al menos un tema.", "sup.err_body": "Describe tu problema.",
  "sup.empty_title": "Aún no hay solicitudes", "sup.empty_sub": "Envía tu primera solicitud — estamos para ti.",
  "sup.n_msg": "{n} mensajes",
  "sup.status_open": "Abierto", "sup.status_in_progress": "En curso", "sup.status_answered": "Respondido", "sup.status_closed": "Cerrado",
  "sup.reply_ph": "Escribe una respuesta…", "sup.send": "Enviar", "sup.close": "Cerrar ticket", "sup.close_confirm": "¿Cerrar este ticket?", "sup.closed": "Cerrado.", "sup.is_closed": "Este ticket está cerrado. Crea una nueva solicitud para más preguntas.",

  // Referral
  "ref.meta_title": "Recomendar", "ref.eyebrow": "Crecimiento", "ref.title": "Recomienda y gana",
  "ref.subtitle": "Comparte My Within y gana recompensas por cada registro con tu código.",
  "ref.your_code": "Tu código de recomendación", "ref.share": "Compartir", "ref.copied": "Enlace copiado.",
  "ref.links": "Tus enlaces", "ref.web_link": "Enlace web", "ref.app_link": "Enlace app",
  "ref.rewards_title": "Cómo funcionan las recompensas",
  "ref.rule_coach_bonus": "{pct}% de bonus en suscripciones de clientes que recomiendes — hasta {months} meses.",
  "ref.rule_c2c": "{eur} € de crédito por persona recomendada — hasta {max}×/año.",
  "ref.rule_note": "Las recompensas se liberan tras el periodo de reembolso.",

  // Plantilla de check-in
  "chk.meta_title": "Plantilla de check-in", "chk.eyebrow": "Reservas", "chk.title": "Plantilla de check-in",
  "chk.subtitle": "Tu mensaje cálido por defecto para clientes en silencio del Pulso de clientes.",
  "chk.default_hint": "Estás usando la plantilla por defecto. Ajústala a tu tono.",
  "chk.f_template": "Texto de la plantilla", "chk.preview": "Vista previa", "chk.save": "Guardar plantilla", "chk.saved": "Guardado.", "chk.err_short": "Introduce al menos 10 caracteres.",

  // Upgrade
  "upg.meta_title": "Coach Pro", "upg.eyebrow": "Suscripción", "upg.title": "Mejora a Coach Pro",
  "upg.subtitle": "Menor comisión, tu propia marca y todas las herramientas premium.",
  "upg.already_pro": "Ya eres Coach Pro — ¡gracias por estar aquí! ✨",
  "upg.best_value": "Mejor precio", "upg.plan_monthly": "Mensual", "upg.plan_yearly": "Anual", "upg.per_month": "mes", "upg.per_year": "año",
  "upg.f_commission": "Solo 10% de comisión en sesiones", "upg.f_unlimited_weva": "Análisis WEVA ilimitados", "upg.f_branding": "Marca personalizada (logo y color)",
  "upg.f_analytics": "Analíticas avanzadas", "upg.f_priority": "Procesamiento WEVA prioritario", "upg.f_group_tools": "Herramientas de grupo y colectivo", "upg.f_bulk_export": "Exportación masiva de tus datos",
  "upg.subscribe": "Mejorar ahora", "upg.current": "Plan actual", "upg.pay_credits": "Pagar con {n} créditos", "upg.activated": "¡Coach Pro activado!", "upg.vat_note": "Precios con 20% de IVA austriaco. Cancela cuando quieras.",

  // Ayuda / FAQ
  "help.meta_title": "Ayuda", "help.eyebrow": "Ayuda", "help.title": "Ayuda y FAQ", "help.subtitle": "Respuestas rápidas a las preguntas más comunes de coaches.",
  "help.q_getting_started": "¿Cómo empiezo como coach?", "help.a_getting_started": "Completa la configuración de coach (4 pasos): crea un formulario de consentimiento, comparte tu primera historia, crea un programa de respiración e invita a tu primer cliente.",
  "help.q_payouts": "¿Cómo recibo mis pagos?", "help.a_payouts": "Conecta tu cuenta de Stripe en Ingresos. Los pagos se procesan automáticamente tras el periodo de reembolso — menos la comisión de la plataforma.",
  "help.q_clients": "¿Cómo veo a los clientes en silencio?", "help.a_clients": "El Pulso de clientes muestra quién ha estado inactivo. Desde ahí puedes enviar un check-in cálido o redactar un nudge con IA.",
  "help.q_pro": "¿Qué ofrece Coach Pro?", "help.a_pro": "Coach Pro reduce tu comisión al 10% y desbloquea marca personalizada, analíticas avanzadas, WEVA prioritario y herramientas de grupo.",
  "help.q_branding": "¿Cómo uso mi propia marca?", "help.a_branding": "Con Coach Pro puedes configurar tu logo, color de marca y pie de email en Ajustes → Marca personalizada.",
  "help.q_refunds": "¿Cómo funcionan los reembolsos?", "help.a_refunds": "En Ajustes → Cancelación y reembolsos defines tus propios niveles. Nota: las comisiones de Stripe no se reembolsan y salen de tu pago.",
  "help.contact_sub": "¿No encontraste respuesta? Escríbenos directamente.", "help.contact_cta": "Contactar soporte",

  // Recorrido
  "tour.meta_title": "Recorrido", "tour.eyebrow": "Bienvenida", "tour.title": "Tu recorrido de coach", "tour.subtitle": "Las paradas clave de tu panel en 5 pasos.", "tour.step_n": "Paso {n}",
  "tour.clients_title": "Acompaña clientes", "tour.clients_sub": "Revisa el pulso, detecta clientes en silencio y haz seguimiento cálido.",
  "tour.plans_title": "Planes y programas", "tour.plans_sub": "Asigna planes diarios y comparte programas de respiración.",
  "tour.offerings_title": "Vende ofertas", "tour.offerings_sub": "Configura sesiones, paquetes y ofertas de afiliados.",
  "tour.circles_title": "Construye círculos", "tour.circles_sub": "Inner y Local Circle para ingresos recurrentes.",
  "tour.analytics_title": "Mide el crecimiento", "tour.analytics_sub": "Análisis profundo de ingresos, WEVA y retención.",
  "tour.cta_sub": "¿Listo? Completa tu configuración.", "tour.cta": "Ir a configuración de coach",

  // Invitaciones Inner Circle
  "ici.meta_title": "Invitaciones Inner Circle", "ici.back": "Inner Circle", "ici.eyebrow": "Inner Circle", "ici.title": "Gestionar invitaciones",
  "ici.subtitle": "Invita clientes a tu Inner Circle y sigue las aceptaciones.",
  "ici.stat_sent": "Enviadas", "ici.stat_accept_rate": "Tasa de aceptación", "ici.stat_active": "Subs activas", "ici.stat_retention": "Retención 30 días",
  "ici.invite_title": "Invitar por email", "ici.emails_ph": "Direcciones de email, separadas por coma o línea", "ici.note_ph": "Nota personal (opcional, máx. 200 caracteres)",
  "ici.send": "Enviar invitaciones", "ici.sent": "{n} invitaciones enviadas.", "ici.err_email": "Introduce al menos un email válido.",
  "ici.list_title": "Invitaciones enviadas", "ici.empty": "Aún no hay invitaciones enviadas.",
  "ici.status_pending": "Pendiente", "ici.status_accepted": "Aceptada", "ici.status_revoked": "Revocada",

  // Colectivos
  "col2.meta_title": "Colectivos", "col2.eyebrow": "Colaboración", "col2.title": "Colectivos", "col2.subtitle": "Únete con otros coaches en una alianza con ingresos compartidos.",
  "col2.new": "Nuevo colectivo", "col2.new_desc": "Da un nombre y una descripción a tu colectivo.",
  "col2.f_name": "Nombre", "col2.f_name_ph": "p. ej. Alianza Breathwork Viena", "col2.f_desc": "Descripción", "col2.f_desc_ph": "¿De qué trata este colectivo?", "col2.f_cover": "Imagen de portada",
  "col2.err_name": "Introduce un nombre.", "col2.created": "Colectivo creado.", "col2.empty_title": "Aún no hay colectivos", "col2.empty_sub": "Crea un colectivo o espera una invitación.",
  "col2.members_n": "{n} miembros", "col2.owner": "Propietario", "col2.status_draft": "Borrador", "col2.status_active": "Activo", "col2.status_archived": "Archivado",
  "col2.detail_meta": "Colectivo", "col2.you_invited": "Has sido invitado a este colectivo.", "col2.accept": "Aceptar", "col2.decline": "Rechazar", "col2.resp_accepted": "Aceptado.", "col2.resp_declined": "Rechazado.",
  "col2.members": "Miembros", "col2.invite": "Invitar", "col2.share_pct": "{pct}% de ingresos", "col2.mstatus_invited": "Invitado", "col2.mstatus_declined": "Rechazado",
  "col2.publish": "Publicar", "col2.archive": "Archivar", "col2.saved": "Guardado.", "col2.invited": "Invitado.", "col2.err_email": "Introduce un email válido.",
  "col2.invite_title": "Invitar coach", "col2.invite_email": "Email del coach", "col2.invite_share": "% de ingresos",

  // Logros de clientes
  "win.meta_title": "Logros de clientes", "win.eyebrow": "Social", "win.title": "Logros de clientes", "win.subtitle": "Convierte el progreso real en historias de éxito — con el consentimiento de tus clientes.",
  "win.suggestions": "Sugerencias IA", "win.suggestions_empty": "Sin sugerencias por ahora. Aparecen cuando los clientes logran progresos medibles.", "win.create": "Crear como logro", "win.requested": "Creado — enviado al cliente para aprobación.",
  "win.my_wins": "Tus logros", "win.empty": "Aún no has creado logros.", "win.delete_confirm": "¿Eliminar este logro?", "win.deleted": "Eliminado.",
  "win.pending": "Esperando aprobación", "win.approved": "Aprobado", "win.private": "Privado",

  // Progreso del perfil profesional
  "pon.meta_title": "Perfil profesional", "pon.eyebrow": "Perfil", "pon.title": "Perfil profesional y progreso", "pon.subtitle": "Completa tu perfil profesional para que los clientes confíen en ti.", "pon.progress": "{done} de {total} áreas completadas",
  "pon.step_profession": "Profesión principal elegida", "pon.step_methods": "Métodos añadidos", "pon.step_focus": "Áreas de enfoque elegidas", "pon.step_qualifications": "Cualificaciones añadidas", "pon.step_languages": "Idiomas elegidos", "pon.step_certificates": "Certificado subido",
  "pon.certificates": "Certificados", "pon.cert_add": "Subir", "pon.cert_empty": "Aún no hay certificados. PDF, JPG o PNG (máx. 20 MB).", "pon.cert_uploaded": "Certificado subido.", "pon.cert_fail": "Error al subir.", "pon.cert_delete_confirm": "¿Eliminar este certificado?", "pon.cert_deleted": "Eliminado.", "pon.edit_in_profile": "Editar perfil profesional en Perfil",

  // Nudge EVA (detalle de cliente)
  "nudge.title": "Redactar nudge IA", "nudge.hint": "Deja que WEVA redacte un mensaje cálido y breve basado en la última reflexión de tu cliente. Tú lo revisas y envías.",
  "nudge.generate": "Redactar nudge", "nudge.regenerate": "Redactar de nuevo", "nudge.generating": "Redactando…", "nudge.failed": "No se pudo redactar un nudge ahora.", "nudge.theme": "Tema", "nudge.copy": "Copiar", "nudge.send_hint": "Consejo: copia el texto y envíalo al cliente desde tus mensajes.",
  "nav.coach_hub": "Coaches",
  "nav.group.book": "Reservar",
  "nav.my_bookings": "Reservas",
  "bkc.hub_title": "Coaches y reservas",
  "bkc.hub_sub": "Tus acompañantes y sus ofertas reservables.",
  "bkc.my_coaches": "Mis coaches",
  "bkc.no_coaches": "Aún no tienes coaches",
  "bkc.no_coaches_sub": "Descubre el acompañamiento ideal y reserva tu primera sesión.",
  "bkc.browse_all": "Ver todos los coaches",
  "bkc.view_profile": "Ver perfil",
  "bkc.offerings": "Ofertas",
  "bkc.no_products": "No hay ofertas reservables.",
  "bkc.book_cta": "Reservar",
  "bkc.group": "Grupo",
  "bkc.min": "min",
  "bkc.with_coach": "con {name}",
  "bkc.back": "Atrás",
  "bkc.pick_date": "Elige una fecha",
  "bkc.slots": "Horarios disponibles",
  "bkc.no_slots": "No hay horarios libres este día.",
  "bkc.payment": "Pago",
  "bkc.pay_credits": "{n} créditos",
  "bkc.pay_card": "Tarjeta",
  "bkc.confirm_credits": "Reservar con {n} créditos",
  "bkc.confirm_card": "Reservar por {amount}",
  "bkc.select_slot_first": "Elige primero un horario.",
  "bkc.checkout_opened": "Pago abierto en una pestaña nueva …",
  "bkc.booked": "¡Reserva confirmada!",
  "bkc.book_failed": "La reserva falló.",
  "bkc.product_not_found": "Oferta no encontrada.",
  "bkc.bookings_title": "Mis reservas",
  "bkc.bookings_sub": "Tus sesiones próximas y pasadas.",
  "bkc.upcoming": "Próximas",
  "bkc.past": "Pasadas",
  "bkc.none": "Aún no tienes reservas",
  "bkc.none_sub": "Reserva tu primera sesión con un coach.",
  "bkc.no_upcoming": "No hay reservas próximas.",
  "bkc.no_past": "Aún no hay sesiones pasadas.",
  "bkc.open_details": "Detalles",
  "bkc.join_zoom": "Unirse a Zoom",
  "bkc.cancel": "Cancelar",
  "bkc.cancel_request": "Solicitar cancelación",
  "bkc.cancel_confirm": "¿Cancelar esta reserva?",
  "bkc.cancel_sent": "Solicitud de cancelación enviada.",
  "bkc.marketplace": "Mercado",
  "bkc.status_confirmed": "Confirmada",
  "bkc.status_paid": "Pagada",
  "bkc.status_pending": "Pendiente",
  "bkc.status_payment_pending": "Pago pendiente",
  "bkc.status_cancelled": "Cancelada",
  "bkc.status_pending_cancellation": "Cancelación solicitada",
  "bkc.status_cancelled_refunded": "Cancelada · reembolsada",
  "bkc.status_cancelled_no_refund": "Cancelada · sin reembolso",
  "bkc.status_cancelled_refund_pending": "Cancelada · reembolso pendiente",
  "bkc.refund_title": "Condiciones de cancelación",
  "bkc.refund_intro": "Esto es lo que recuperarías si cancelas ahora:",
  "bkc.refund_tier_72": "Más de 72 h antes · 100%",
  "bkc.refund_tier_24": "24–72 h antes · 50%",
  "bkc.refund_tier_now": "Menos de 24 h antes · 0%",
  "bkc.refund_you_get": "Recuperas",
  "bkc.refund_pct": "{pct}% de reembolso",
  "bkc.refund_amount": "≈ {amount}",
  "bkc.refund_hours_left": "quedan {hours} h hasta la sesión",
  "bkc.refund_note": "Tu coach confirma el reembolso final.",
  "bkc.reason_ph": "Motivo (opcional)",
  "bkc.submit_cancel": "Solicitar cancelación",
  "bkc.session_title": "Sesión",
  "bkc.session_not_found": "Sesión no encontrada.",
  "bkc.when": "Cuándo",
  "bkc.where": "Dónde",
  "bkc.your_coach": "Tu coach",
  "bkc.virtual": "Sesión online",
  "bkc.join_meeting": "Unirse a la reunión",
  "bkc.link_tba": "Enlace pendiente.",
  "bkc.in_person": "Presencial",
  "bkc.location_tba": "Ubicación pendiente.",
  "bkc.in_person_hint": "Tu coach te compartirá la dirección exacta.",
  "bkc.time_tba": "Fecha por confirmar",
  "bkc.note_title": "Tu nota para el coach",
  "bkc.note_hint": "Comparte de antemano en qué quieres trabajar.",
  "bkc.note_ph": "¿De qué tratará esta sesión?",
  "bkc.note_saved_at": "Guardado el {when}",
  "bkc.save": "Guardar",
  "bkc.clear": "Borrar",
  "bkc.saved": "Guardado.",
  "bkc.cancel_policy": "Cancelación: actualmente {pct}% de reembolso.",
  "bkc.duration_min": "{n} min",
  "bkc.email": "Correo",
  "bkc.phone": "Llamar",

  // Session booking (sb)
  "sb.title": "Reserva tu sesión",
  "sb.back": "Atrás",
  "sb.not_found": "Coach no encontrado.",
  "sb.pick_offering": "Elige una oferta",
  "sb.no_offerings": "Este coach no tiene ofertas reservables por ahora.",
  "sb.minutes": "{n} min",
  "sb.credits_label": "créditos",
  "sb.payment": "Método de pago",
  "sb.pay_credits": "Pagar con créditos",
  "sb.pay_card": "Pagar con tarjeta",
  "sb.credits_balance": "Saldo: {balance} créditos",
  "sb.credits_insufficient": "Te faltan {need} créditos (tienes {have}).",
  "sb.add_credits": "Añadir créditos",
  "sb.preferred_time": "Hora preferida",
  "sb.available_times": "Horarios disponibles",
  "sb.no_slots_day": "No hay huecos libres este día — prueba otra fecha.",
  "sb.note_title": "Una nota breve (opcional)",
  "sb.note_ph": "¿De qué te gustaría hablar?",
  "sb.legal": "Comprobación de pago única. El coach confirma en cuanto se realiza el pago.",
  "sb.confirm_credits": "Reservar por {credits} créditos",
  "sb.confirm_card": "Reservar por {amount}",
  "sb.confirm_insufficient": "Créditos insuficientes",
  "sb.booked": "Tu sesión está reservada 💛",
  "sb.book_failed": "La reserva falló.",

  // Collab packages (cov)
  "cov.packages_title": "Paquetes colaborativos",
  "cov.packages_sub": "Paquetes creados en conjunto por varios coaches.",
  "cov.none": "No hay paquetes colaborativos disponibles por ahora.",
  "cov.not_found": "Paquete no encontrado.",
  "cov.coaches": "Coaches",
  "cov.included": "Incluido",
  "cov.kind_training": "Entrenamiento",
  "cov.kind_one_on_one": "Sesión 1:1",
  "cov.kind_product": "Producto",
  "cov.min": "min",
  "cov.capacity": "{n} de {total} libres",
  "cov.total": "Total",
  "cov.payment": "Pago",
  "cov.balance": "Saldo: {balance}",
  "cov.insufficient": "Faltan {need} (tienes {have}).",
  "cov.add_credits": "Añadir créditos",
  "cov.book_credits": "Reservar por {credits} créditos",
  "cov.book_card": "Reservar por {amount}",
  "cov.full": "Completo",
  "cov.book_failed": "La reserva falló.",
  "cov.booked_title": "Paquete reservado",
  "cov.booked_sub": "Todo listo. Tus coaches han sido avisados.",
  "cov.booked_blocks": "Tu paquete",
  "cov.booked_ready": "Listo",
  "cov.booked_slot": "Programado: {when}",
  "cov.booked_slot_pending": "Horario pendiente",
  "cov.booked_home": "Ir a mis reservas",
  "cov.slot_title": "Elige tus horarios",
  "cov.slot_sub": "Fija una hora para cada sesión 1:1.",
  "cov.slot_all_done": "Todos los horarios fijados",
  "cov.slot_pending": "{n} horario(s) pendiente(s)",
  "cov.slot_pick_coach": "Elige un coach",
  "cov.slot_pick_slot": "Elige un horario",
  "cov.slot_none": "No hay horarios libres.",
  "cov.slot_save": "Guardar horario",
  "cov.slot_saved": "Horarios guardados",
  "cov.slot_skip": "Hacerlo más tarde",
  "cov.slot_done": "Listo",

  // Deep Within + Journal + Practices (Welle 1)
  "nav.deep_within": "Deep Within",
  "nav.journal": "Diario",
  "dw.title": "Deep Within",
  "dw.subtitle": "Tu espacio para reconocer, nombrar y soltar lo que llevas.",
  "dw.in_progress": "en trabajo suave",
  "dw.transformed": "transformado",
  "dw.hero_practices_title": "Reconocer · Nombrar · Soltar",
  "dw.hero_practices_sub": "Prácticas guiadas para transformar lo que sientes.",
  "dw.hero_journal_title": "Journaling",
  "dw.hero_journal_sub": "Escríbete libre, día a día.",
  "dw.soon": "Próximamente",
  "dw.buckets_heading": "Tus áreas",
  "dw.entries": "{n} entradas",
  "dw.not_found": "Área no encontrada.",
  "dw.add": "Añadir",
  "dw.edit": "Editar",
  "dw.delete": "Eliminar",
  "dw.save": "Guardar",
  "dw.cancel": "Cancelar",
  "dw.saved": "Guardado.",
  "dw.save_failed": "No se pudo guardar.",
  "dw.deleted": "Eliminado.",
  "dw.delete_failed": "No se pudo eliminar.",
  "dw.delete_confirm": "¿Eliminar esta entrada?",
  "dw.primary_required": "Rellena el campo principal.",
  "dw.tab_own": "Propias",
  "dw.tab_weva": "WEVA",
  "dw.tab_all": "Todas",
  "dw.tab_progress": "En trabajo suave",
  "dw.tab_transformed": "Transformadas",
  "dw.empty_title": "Aún no hay nada",
  "dw.empty_sub": "Añade tu primera entrada cuando estés listo.",
  "dw.status_label": "Estado",
  "dw.status_open": "Abierto",
  "dw.status_in_progress": "En progreso",
  "dw.status_transformed": "Transformado",
  "dw.weva_toggle": "Incluir en la reflexión WEVA",
  "dw.readonly_weva": "Reconocido por WEVA — solo estado y el interruptor WEVA son editables.",
  "dw.show_details": "Más detalles",
  "dw.hide_details": "Ocultar detalles",
  "dw.f.reframe": "Nueva versión fortalecedora",
  "dw.f.reframe_ph": "¿Cómo te gustaría verlo en su lugar?",
  "dw.f.frequency": "Frecuencia",
  "dw.f.origin": "Origen",
  "dw.f.body_location": "Zona del cuerpo",
  "dw.f.physical_pain": "Sensación física",
  "dw.f.applied_practice": "Práctica aplicada",
  "dw.ul.title": "Upper limit",
  "dw.ul.title_ph": "¿Cómo te frenas cuando todo va bien?",
  "dw.ul.life_area": "Área de vida",
  "dw.ul.symptoms": "Síntomas",
  "dw.ul.symptoms_ph": "p. ej. preocupación, conflicto (separado por comas)",
  "dw.ul.trigger": "Desencadenante",
  "dw.ul.core_false_belief": "Creencia falsa subyacente",
  "dw.ul.zone_of_genius_impact": "Impacto en tu zona de genialidad",
  "dw.beliefs.title": "Creencias",
  "dw.beliefs.sub": "Convicciones que te marcan",
  "dw.beliefs.field": "Creencia",
  "dw.beliefs.ph": "¿Qué crees sobre ti o el mundo?",
  "dw.fears.title": "Miedos",
  "dw.fears.sub": "Lo que te frena",
  "dw.fears.field": "Miedo",
  "dw.fears.ph": "¿A qué le tienes miedo?",
  "dw.surroundings.title": "Entorno",
  "dw.surroundings.sub": "Personas y lugares a tu alrededor",
  "dw.surroundings.field": "Entorno",
  "dw.surroundings.ph": "¿Qué parte de tu entorno te ocupa?",
  "dw.dreams.title": "Sueños",
  "dw.dreams.sub": "Hacia dónde anhelas ir",
  "dw.dreams.field": "Sueño",
  "dw.dreams.ph": "¿Con qué sueñas?",
  "dw.values.title": "Valores",
  "dw.values.sub": "Lo que te importa",
  "dw.values.field": "Valor",
  "dw.values.ph": "¿Qué valor te guía?",
  "dw.strengths.title": "Fortalezas",
  "dw.strengths.sub": "En lo que puedes apoyarte",
  "dw.strengths.field": "Fortaleza",
  "dw.strengths.ph": "¿Qué fortaleza vive en ti?",
  "dw.habits.title": "Hábitos",
  "dw.habits.sub": "Tus patrones diarios",
  "dw.habits.field": "Hábito",
  "dw.habits.ph": "¿Qué hábito quieres observar?",
  "dw.boundaries.title": "Límites",
  "dw.boundaries.sub": "Lo que proteges",
  "dw.boundaries.field": "Límite",
  "dw.boundaries.ph": "¿Qué límite quieres poner?",
  "dw.upper-limits.title": "Upper limits",
  "dw.upper-limits.sub": "Donde te frenas a ti mismo",
  "jr.title": "Diario",
  "jr.subtitle": "Un lugar tranquilo para tus pensamientos.",
  "jr.new_ph": "¿Qué te mueve ahora mismo?",
  "jr.mood": "Ánimo",
  "jr.weva": "Incluir en WEVA",
  "jr.save": "Guardar entrada",
  "jr.saved": "Entrada guardada.",
  "jr.save_failed": "No se pudo guardar.",
  "jr.empty_err": "Escribe algo primero.",
  "jr.empty_title": "Aún no hay entradas",
  "jr.empty_sub": "Tu primera entrada te espera.",
  "jr.delete": "Eliminar",
  "jr.delete_confirm": "¿Eliminar esta entrada?",
  "jr.deleted": "Entrada eliminada.",
  "pr.title": "Reconocer · Nombrar · Soltar",
  "pr.subtitle": "Prácticas guiadas y basadas en evidencia para transformar lo que sientes con seguridad. Llega en una de las próximas olas.",
  "pr.soon": "Próximamente",
  "pr.pillar_realize": "Reconocer",
  "pr.pillar_designate": "Nombrar",
  "pr.pillar_release": "Soltar",

  // Practices (Erkennen·Benennen·Loslassen) — ported from mobile
  "back": "Atrás",
  "body_arms": "Brazos",
  "body_belly": "Vientre",
  "body_chest": "Pecho",
  "body_face": "Cara",
  "body_feet": "Pies",
  "body_head": "Cabeza",
  "body_heart": "Corazón",
  "body_hips": "Caderas",
  "body_legs": "Piernas",
  "body_lower_back": "Espalda baja",
  "body_mark_neutral": "Neutro",
  "body_mark_open": "Abierto",
  "body_mark_tense": "Tenso",
  "body_pelvis": "Pelvis",
  "body_shoulders": "Hombros",
  "body_solar_plexus": "Plexo solar",
  "body_throat": "Garganta",
  "body_upper_back": "Espalda alta",
  "bodymap_hint": "Toca una zona: tenso → neutro → abierto.",
  "emdr_hint": "Trae el recuerdo o sentimiento a la mente y sigue el punto.",
  "emdr_rounds": "Rondas",
  "emdr_min_rounds": "Al menos 10 rondas para continuar ({n}/10)",
  "emdr_speed": "Velocidad",
  "emdr_speed_fast": "Rápido",
  "emdr_speed_med": "Med",
  "emdr_speed_slow": "Lento",
  "emo_abandoned": "abandonado",
  "emo_accomplished": "logrado",
  "emo_aching": "doliente",
  "emo_amazed": "asombrado",
  "emo_anger": "ira",
  "emo_annoyed": "molesto",
  "emo_anxious": "ansioso",
  "emo_ashamed": "avergonzado",
  "emo_betrayed": "traicionado",
  "emo_bitter": "amargo",
  "emo_cherished": "querido",
  "emo_confident": "seguro",
  "emo_confused": "confundido",
  "emo_connected": "conectado",
  "emo_contemptuous": "despreciativo",
  "emo_content": "contento",
  "emo_critical": "crítico",
  "emo_curious": "curioso",
  "emo_defeated": "derrotado",
  "emo_disappointed": "decepcionado",
  "emo_disgust": "asco",
  "emo_disoriented": "desorientado",
  "emo_disrespected": "faltado al respeto",
  "emo_eager": "impaciente",
  "emo_embarrassed": "avergonzado",
  "emo_empty": "vacío",
  "emo_energized": "con energía",
  "emo_enraged": "enfurecido",
  "emo_excited": "emocionado",
  "emo_exposed": "expuesto",
  "emo_fear": "miedo",
  "emo_frozen": "congelado",
  "emo_frustrated": "frustrado",
  "emo_furious": "furioso",
  "emo_grateful": "agradecido",
  "emo_grief": "en duelo",
  "emo_guilty": "culpable",
  "emo_hateful": "lleno de odio",
  "emo_heartbroken": "con el corazón roto",
  "emo_helpless": "impotente",
  "emo_hopeless": "sin esperanza",
  "emo_hostile": "hostil",
  "emo_hurt": "herido",
  "emo_impatient": "impaciente",
  "emo_inadequate": "inadecuado",
  "emo_insecure": "inseguro",
  "emo_intrigued": "intrigado",
  "emo_irritated": "irritado",
  "emo_isolated": "aislado",
  "emo_jealous": "celoso",
  "emo_jolted": "sacudido",
  "emo_joy": "alegría",
  "emo_judgmental": "crítico",
  "emo_lonely": "solo",
  "emo_lost": "perdido",
  "emo_loving": "amoroso",
  "emo_mourning": "de luto",
  "emo_nauseated": "con náuseas",
  "emo_open": "abierto",
  "emo_overwhelmed": "abrumado",
  "emo_paralyzed": "paralizado",
  "emo_peaceful": "en paz",
  "emo_perplexed": "perplejo",
  "emo_powerless": "sin poder",
  "emo_primary": "Primaria",
  "emo_proud": "orgulloso",
  "emo_repulsed": "repulsado",
  "emo_resentful": "resentido",
  "emo_restless": "inquieto",
  "emo_revolted": "asqueado",
  "emo_sadness": "tristeza",
  "emo_scared": "asustado",
  "emo_secondary": "Secundaria",
  "emo_seen": "visto",
  "emo_shocked": "en shock",
  "emo_small": "pequeño",
  "emo_specific": "Específica",
  "emo_startled": "sobresaltado",
  "emo_superior": "superior",
  "emo_surprise": "sorpresa",
  "emo_tearful": "lloroso",
  "emo_tender": "tierno",
  "emo_terrified": "aterrado",
  "emo_threatened": "amenazado",
  "emo_thrilled": "entusiasmado",
  "emo_trapped": "atrapado",
  "emo_unfair": "injusto",
  "emo_unseen": "invisible",
  "emo_unworthy": "indigno",
  "emo_violent": "violento",
  "emo_warm": "cálido",
  "emo_worried": "preocupado",
  "favorite": "Favorito",
  "p_abc_a_label": "A — ¿Qué pasó? (sólo hechos)",
  "p_abc_a_ph": "Mi jefa dijo…",
  "p_abc_b_label": "B — ¿Qué significado le di?",
  "p_abc_b_ph": "Que no soy competente…",
  "p_abc_c_label": "C — ¿Cómo me sentí y actué?",
  "p_abc_c_ph": "Me quedé congelado, evité…",
  "p_abc_dispute_label": "¿B es objetivamente cierto? ¿Qué otra lectura hay?",
  "p_abc_dispute_ph": "Quizás también estaba estresada…",
  "p_abc_intro_body": "A (evento activador) → B (creencia / evaluación) → C (consecuencia). La magia está en B.",
  "p_abc_intro_title": "Ve la secuencia",
  "p_abc_model": "Modelo ABC",
  "p_abc_model_desc": "Disparador → Evaluación → Consecuencia. Ver la secuencia.",
  "p_abc_newc_label": "Con la nueva creencia — ¿cómo se vería C?",
  "p_abc_title": "Modelo ABC",
  "p_body_scan": "Escaneo Corporal",
  "p_body_scan_bodymap_hint": "Toca cada zona para marcar su estado.",
  "p_body_scan_bodymap_label": "¿Dónde lo sientes?",
  "p_body_scan_desc": "Sentir de la cabeza a los pies y marcar lo que pide atención.",
  "p_body_scan_intro_body": "Mueve tu atención lentamente de la coronilla a las plantas. Marca lo que está tenso, neutro, abierto.",
  "p_body_scan_intro_title": "Siente de la cabeza a los pies",
  "p_body_scan_invite_breath": "Ser respirado",
  "p_body_scan_invite_label": "¿Qué quiere ese lugar?",
  "p_body_scan_invite_movement": "Movimiento",
  "p_body_scan_invite_stillness": "Sólo presencia",
  "p_body_scan_invite_touch": "Una mano de cuidado",
  "p_body_scan_invite_words": "Palabras cálidas",
  "p_body_scan_mood_after": "Después",
  "p_body_scan_mood_before": "Antes",
  "p_body_scan_sensation_label": "¿Cuál es la sensación más viva?",
  "p_body_scan_sensation_ph": "Un anillo apretado alrededor de mi garganta…",
  "p_body_scan_title": "Escaneo corporal",
  "p_cb_after": "Después",
  "p_cb_before": "Antes",
  "p_cb_dur_20": "20 min",
  "p_cb_dur_30": "30 min",
  "p_cb_dur_40": "40 min",
  "p_cb_dur_starter": "10 min (inicio)",
  "p_cb_duration_label": "Duración de la sesión",
  "p_cb_exp_calm": "Calma profunda",
  "p_cb_exp_heat": "Calor / frío",
  "p_cb_exp_images": "Imágenes vívidas",
  "p_cb_exp_movement": "El cuerpo quería moverse",
  "p_cb_exp_nothing": "Nada dramático",
  "p_cb_exp_tears": "Lágrimas",
  "p_cb_exp_tetany": "Hormigueo / tetania",
  "p_cb_experience_label": "¿Qué surgió durante la respiración? (marca después)",
  "p_cb_intention_label": "Tu intención para esta sesión",
  "p_cb_intention_ph": "Dejar que el duelo se mueva…",
  "p_cb_intro_body": "Inhalación-exhalación continua sin pausa. Mejor con un facilitador o pista guiada. 20–40 minutos.",
  "p_cb_intro_title": "Respiración circular",
  "p_cb_posture_bed": "En cama / mat",
  "p_cb_posture_chair": "Sentado en silla",
  "p_cb_posture_floor": "Suelo",
  "p_cb_posture_label": "¿Dónde te acostarás o sentarás?",
  "p_cb_reflection_label": "Reflexión",
  "p_cb_title": "Respiración conectada",
  "p_cognitive_restructuring": "Reestructuración Cognitiva",
  "p_cognitive_restructuring_desc": "Probar un pensamiento pesado y elegir uno más ligero y verdadero.",
  "p_connected_breath": "Respiración Conectada",
  "p_connected_breath_desc": "Respiración circular para mover energía emocional bloqueada.",
  "p_core_deeper1_label": "Si lo consiguiera plenamente, ¿qué le daría eso?",
  "p_core_deeper1_ph": "Seguridad, quizás.",
  "p_core_deeper2_label": "¿Y si consiguiera ESO plenamente?",
  "p_core_integration_label": "¿Cómo cambia la reacción original cuando ya tienes esto?",
  "p_core_intro_body": "Pregúntale a cada reacción \"si obtuvieras todo lo que quieres, ¿qué me daría eso?\" — hasta llegar a un estado esencial (Paz, Amor, Ser).",
  "p_core_intro_title": "Síguelo hasta casa",
  "p_core_state_being": "Ser / estar bien",
  "p_core_state_label": "¿Qué estado esencial se siente más cercano?",
  "p_core_state_love": "Amor",
  "p_core_state_oneness": "Unidad",
  "p_core_state_peace": "Paz",
  "p_core_transformation": "Core Transformation",
  "p_core_transformation_desc": "Seguir una reacción hasta su intención positiva más profunda.",
  "p_core_transformation_title": "Transformación esencial",
  "p_core_trigger_label": "¿Con qué reacción trabajas?",
  "p_core_trigger_ph": "Cuando mi pareja ignora mis mensajes, me enfado…",
  "p_core_want_label": "¿Qué quiere esa parte?",
  "p_core_want_ph": "Quiero ser visto.",
  "p_cr_balanced_label": "Un pensamiento más equilibrado",
  "p_cr_balanced_ph": "A veces me cuesta Y ya he crecido a través de cosas difíciles.",
  "p_cr_belief_after": "¿Qué tan cierto se siente el pensamiento equilibrado ahora?",
  "p_cr_belief_before": "¿Qué tan cierto se siente? (1 bajo – 10 alto)",
  "p_cr_dist_all_or_nothing": "Todo-o-nada",
  "p_cr_dist_catastrophizing": "Catastrofización",
  "p_cr_dist_label": "¿Qué distorsiones cognitivas están en juego?",
  "p_cr_dist_labeling": "Etiquetado",
  "p_cr_dist_mind_reading": "Lectura mental",
  "p_cr_dist_personalizing": "Personalización",
  "p_cr_dist_should": "Frases con «debería»",
  "p_cr_evidence_against": "Pruebas EN CONTRA del pensamiento",
  "p_cr_evidence_for": "Pruebas A FAVOR del pensamiento",
  "p_cr_heavy_label": "Escribe el pensamiento pesado",
  "p_cr_heavy_ph": "Nunca seré suficiente…",
  "p_cr_intro_body": "Un pensamiento pesado no es un hecho. Pésalo, luego elige uno más cierto.",
  "p_cr_intro_title": "Pon a prueba el pensamiento",
  "p_cr_title": "Reestructuración cognitiva",
  "p_dream_log": "Diario de Sueños",
  "p_dream_log_desc": "Capturar sueños frescos - símbolos, sensaciones, umbrales.",
  "p_dream_log_intro_body": "Los sueños se desvanecen en minutos. Escribe lo que recuerdas — incluso los fragmentos llevan sentido.",
  "p_dream_log_intro_title": "Atrapa el hilo",
  "p_dream_log_narrative_label": "Cuéntalo — en presente si puedes.",
  "p_dream_log_narrative_ph": "Camino a través de…",
  "p_dream_log_question_label": "¿Qué pregunta hace este sueño?",
  "p_dream_log_question_ph": "…",
  "p_dream_log_sym_animal": "Animal",
  "p_dream_log_sym_fire": "Fuego",
  "p_dream_log_sym_house": "Casa / habitación",
  "p_dream_log_sym_light": "Luz / oscuridad",
  "p_dream_log_sym_person": "Persona",
  "p_dream_log_sym_threshold": "Umbral / puerta",
  "p_dream_log_sym_vehicle": "Vehículo",
  "p_dream_log_sym_water": "Agua",
  "p_dream_log_symbols_hint": "Elige tantos como encajen.",
  "p_dream_log_symbols_label": "Símbolos que resaltaron",
  "p_dream_log_title": "Diario de sueños",
  "p_dream_log_title_label": "Un título breve para este sueño",
  "p_dream_log_title_ph": "La escalera sin fin",
  "p_dream_log_tone_grieving": "En duelo",
  "p_dream_log_tone_joyful": "Alegre",
  "p_dream_log_tone_label": "La sensación general fue…",
  "p_dream_log_tone_mystery": "Misterioso",
  "p_dream_log_tone_peaceful": "Pacífico",
  "p_dream_log_tone_tense": "Tenso",
  "p_emdr": "EMDR (autoaplicado)",
  "p_emdr_desc": "Estimulación bilateral con un recuerdo o emoción.",
  "p_emdr_intro_body": "Esta es una adaptación de EMDR para auto-uso — para malestar suave del día a día, no para trauma profundo. Para eso, busca un profesional titulado.",
  "p_emdr_intro_title": "Estimulación bilateral",
  "p_emdr_session_hint": "Completa 1–3 series de 20–30 rondas. Entre series, respira y deja flotar imágenes.",
  "p_emdr_session_label": "Mira el punto mientras sostienes el objetivo",
  "p_emdr_shift_label": "¿Qué se movió en imagen, cuerpo o pensamiento?",
  "p_emdr_suds_after": "SUDS ahora (0 – 10)",
  "p_emdr_suds_before": "SUDS — malestar ahora (0 calma – 10 máx.)",
  "p_emdr_target_label": "Objetivo: trae a la mente un recuerdo o sentimiento",
  "p_emdr_target_ph": "El momento de ayer cuando…",
  "p_emdr_title": "EMDR (auto-uso)",
  "p_emotion_wheel": "Rueda de Emociones",
  "p_emotion_wheel_after": "Después de nombrarlo — ¿cómo estás?",
  "p_emotion_wheel_before": "Antes",
  "p_emotion_wheel_desc": "Precisar lo que sientes - de lo amplio a lo específico.",
  "p_emotion_wheel_intro_body": "Cuando podemos nombrarla, podemos encontrarla. Ve de lo amplio a lo específico.",
  "p_emotion_wheel_intro_title": "La precisión lo cambia todo",
  "p_emotion_wheel_title": "Rueda de emociones",
  "p_emotion_wheel_trigger_label": "¿Qué desencadenó esto?",
  "p_emotion_wheel_trigger_ph": "Una frase corta…",
  "p_emotion_wheel_wheel_label": "Muévete hacia afuera — general → específico",
  "p_inner_critic": "El Crítico Interior",
  "p_inner_critic_desc": "Conoce la voz interior - y qué está protegiendo.",
  "p_inner_critic_intro_body": "El crítico interior no eres tú — es una parte de ti que intenta protegerte a la antigua. Encuéntralo, escúchalo, agradécele.",
  "p_inner_critic_intro_title": "Encuentra la voz",
  "p_inner_critic_mood_after": "¿Y ahora?",
  "p_inner_critic_mood_before": "¿Cómo estás antes de empezar?",
  "p_inner_critic_mood_before_hint": "1 = pesado, 10 = ligero",
  "p_inner_critic_protect_hint": "Mira debajo de la dureza. ¿Qué miedo vive ahí?",
  "p_inner_critic_protect_label": "¿De qué intenta protegerte?",
  "p_inner_critic_response_label": "¿Qué podrías responderle — con amabilidad?",
  "p_inner_critic_response_ph": "Gracias por intentar protegerme. Te escucho, y esto lo llevo yo.",
  "p_inner_critic_title": "El crítico interior",
  "p_inner_critic_tone_label": "¿Qué tono utiliza?",
  "p_inner_critic_tone_opt_anxious": "Ansioso y catastrofista",
  "p_inner_critic_tone_opt_cold": "Frío y despectivo",
  "p_inner_critic_tone_opt_harsh": "Duro y cortante",
  "p_inner_critic_tone_opt_pushy": "Insistente y exigente",
  "p_inner_critic_voice_label": "¿Qué te dice tu crítico hoy?",
  "p_inner_critic_voice_ph": "Nunca vas a…",
  "p_parts_age_label": "¿Qué edad tiene?",
  "p_parts_age_ph": "7, 42, o sin edad",
  "p_parts_intro_body": "Tienes muchas partes internas. Elige una activa hoy — dale un nombre, una edad, y escucha.",
  "p_parts_intro_title": "Encuentra las partes",
  "p_parts_message_label": "¿Qué quiere que sepas?",
  "p_parts_name_label": "Dale un nombre a esta parte",
  "p_parts_name_ph": "El sobreexigido",
  "p_parts_role_exile": "Exiliado (guarda dolor)",
  "p_parts_role_firefighter": "Bombero",
  "p_parts_role_label": "¿Cuál es su papel?",
  "p_parts_role_manager": "Gerente / planificador",
  "p_parts_role_protector": "Protector",
  "p_parts_role_witness": "Testigo interior",
  "p_parts_self_label": "¿Qué responde tu Yo tranquilo?",
  "p_parts_self_ph": "Te escucho. Gracias por sostener esto.",
  "p_parts_work": "Trabajo de Partes",
  "p_parts_work_desc": "Conocer tus ego-estados como personajes internos con roles.",
  "p_parts_work_title": "Trabajo de partes",
  "p_the_work": "El Trabajo (Byron Katie)",
  "p_the_work_belief_label": "Escribe el pensamiento estresante",
  "p_the_work_belief_ph": "Deberían amarme como yo quiero.",
  "p_the_work_desc": "Cuatro preguntas y una inversión para una creencia estresante.",
  "p_the_work_intro_body": "Trae una creencia estresante. Hazle cuatro preguntas. Luego dala vuelta.",
  "p_the_work_intro_title": "Cuatro preguntas y una vuelta",
  "p_the_work_q1_label": "1. ¿Es cierto?",
  "p_the_work_q2_label": "2. ¿Puedes saber con absoluta certeza que es cierto?",
  "p_the_work_q3_label": "3. ¿Cómo reaccionas — qué pasa — cuando crees este pensamiento?",
  "p_the_work_q4_label": "4. ¿Quién serías sin este pensamiento?",
  "p_the_work_title": "The Work (Byron Katie)",
  "p_the_work_turnaround_label": "Dala vuelta — escribe una inversión que sea igual de cierta, o más.",
  "p_the_work_turnaround_ph": "Debería amarme como quiero que me amen.",
  "p_tre": "TRE",
  "p_tre_after": "Después",
  "p_tre_before": "Antes",
  "p_tre_desc": "Ejercicios liberadores de trauma - dejar que el cuerpo tiemble.",
  "p_tre_intro_body": "TRE fatiga el psoas y libera el reflejo de temblor. Hazlo sobre una superficie blanda. Puedes parar en cualquier momento. No para trauma avanzado sin acompañamiento.",
  "p_tre_intro_title": "Deja que el cuerpo tiemble",
  "p_tre_reflection_label": "¿Qué notaste?",
  "p_tre_session_hint": "Sigue cada fase. El temblor es seguro cuando fluye libre.",
  "p_tre_session_label": "Sesión guiada",
  "p_tre_title": "TRE",
  "p_yesno_no": "No",
  "p_yesno_unsure": "No estoy seguro",
  "p_yesno_yes": "Sí",
  "pillar_designate": "Nombrar",
  "pillar_designate_desc": "Nombrar y estructurar lo que ves.",
  "pillar_realize": "Reconocer",
  "pillar_realize_desc": "Ver lo que realmente está aquí.",
  "pillar_release": "Liberar",
  "pillar_release_desc": "Deja que fluya a través de ti.",
  "practices_hub_subtitle": "Doce prácticas guiadas a través de los tres pilares.",
  "practices_hub_title": "Notar - Nombrar - Liberar",
  "saving": "Guardando...",
  "tre_hint": "Sigue las 4 fases. Detente en cualquier momento si te sientes inseguro.",
  "tre_intensity_lbl": "Intensidad del temblor (0 – 10)",
  "tre_phase_fatigue": "2. Fatiga con sentadilla en pared",
  "tre_phase_rest": "4. Descanso de integración",
  "tre_phase_tremor": "3. Fase de temblor (tumbado)",
  "tre_phase_warmup": "1. Calentamiento (pies, pantorrillas)",
  "ui_continue": "Continuar",
  "ui_could_not_save": "No se pudo guardar",
  "ui_please_try_again": "Inténtalo de nuevo.",
  "ui_save_finish": "Guardar y terminar",
  "unfavorite": "Quitar favorito",
  "widget_pause": "Pausa",
  "widget_resume": "Reanudar",
  "widget_start": "Iniciar",
  // Deep Within tabs, insights, workings + view switcher (iter250)
  "nav.switch_to_client": "Mi espacio personal",
  "nav.switch_to_coach": "Área de coach",
  "dw.tab_practice": "Práctica",
  "dw.tab_insights": "Insights",
  "dw.tab_history": "Historial",
  "dw.insights_total": "Entradas totales",
  "dw.insights_streak_current": "Racha actual",
  "dw.insights_streak_longest": "Racha más larga",
  "dw.insights_mood_delta": "Cambio medio",
  "dw.insights_7d": "Últimos 7 días",
  "dw.insights_by_pillar": "Por pilar",
  "dw.insights_mood": "Ánimo",
  "dw.insights_mood_before": "antes",
  "dw.insights_mood_after": "después",
  "dw.insights_sources": "Fuentes",
  "dw.insights_top": "Práctica favorita",
  "dw.insights_empty_title": "Aún no hay datos",
  "dw.insights_empty_sub": "Completa una práctica o añade una entrada — tus insights aparecerán aquí.",
  "dw.src_practices": "Prácticas",
  "dw.src_goals": "Objetivos",
  "dw.src_comfortzone": "Zona de confort",
  "dw.src_coping": "Afrontamiento",
  "dw.src_journal": "Diario",
  "dw.history_full_log": "Historial completo",
  "dw.history_empty_title": "Aún no hay prácticas",
  "dw.history_empty_sub": "Tus prácticas completadas aparecerán aquí.",
  "dw.workings": "Journey",
  "dw.workings_add": "Paso",
  "dw.workings_none": "Aún no hay pasos en esta journey.",
  "dw.working_saved": "Paso guardado.",
  "dw.working_title": "Paso de la journey",
  "dw.working_sub": "Anota lo que cambió al trabajarlo.",
  "dw.working_intensity": "Intensidad",
  "dw.working_success": "Sensación de logro",
  "dw.working_reflection": "¿Qué cambió?",
  "dw.working_still": "Todavía estoy trabajando en ello",
  "dw.working_hint_progress": "Permanece en trabajo suave.",
  "dw.working_hint_done": "Se marca como transformado.",
  "practices_history_title": "Historial de prácticas",
  "practices_history_sub": "Todas tus prácticas completadas.",
  "practices_history_empty_title": "Aún no hay prácticas",
  "practices_history_empty_sub": "Empieza una práctica desde el hub de Prácticas.",
  "practices_delete_confirm": "¿Eliminar esta entrada?",

  // --- WEVA / EVA (Phase B Epic C+B · Welle 2) ---
  "weva": "WEVA",
  "weva_full_name": "Wellbeing Emotional Vitality Assistant",
  "weva_freemium_notice": "WEVA es una función de IA — Plus (5,97 €/mes) o superior desbloquea chat, informes, análisis de creencias e insights.",
  "weva_tab_insight": "Insight",
  "weva_action_insight_sub": "Estadísticas de práctica + última reflexión.",
  "weva_action_chat": "Chatear con WEVA",
  "weva_action_chat_sub": "WEVA escucha solo cuando la invitas.",
  "weva_action_reports": "Generar informes",
  "weva_action_reports_sub": "Elige períodos de tiempo y fuentes para tu informe.",
  "weva_action_beliefs": "Tus creencias",
  "weva_action_beliefs_sub": "Tu tabla + las observaciones de WEVA, lado a lado.",
  "weva_tab_history": "Historial IA",
  "weva_report_fallback_title": "Informe",
  "ui_latest_reflection": "Última reflexión de WEVA",
  "ui_open_full_report": "Abrir informe completo",
  "ui_no_report_yet": "Aún sin informe. Genera uno desde el tab WEVA.",
  "weva_generate_report_cta": "Generar un informe",
  "eva_chat": "Chatea con WEVA",
  "eva_chat_sub": "Pregúntale a WEVA sobre tus patrones, emociones o próximos pasos.",
  "eva_chat_tab_chat": "Chat",
  "eva_chat_tab_past": "Pasado",
  "eva_chat_tab_reports": "Reportes",
  "eva_chat_empty": "Salúdala - WEVA recuerda lo que has compartido.",
  "eva_chat_send_hint": "WEVA responde basándose en tu diario, breakouts y último informe.",
  "eva_chat_thinking": "WEVA está reflexionando…",
  "eva_chat_placeholder": "¿Qué tienes en mente?",
  "eva_chat_used": "{n}/{q} mensajes hoy",
  "eva_chat_limit_hit": "Límite diario alcanzado - mejora tu plan.",
  "eva_chat_clear": "Borrar conversación",
  "eva_chat_clear_confirm": "¿Borrar toda la conversación con WEVA?",
  "eva_chat_new_session": "Iniciar un chat nuevo",
  "eva_chat_past_empty": "Tus chats pasados aparecen aquí una vez que terminas una conversación.",
  "eva_chat_current_pill": "Actual",
  "eva_chat_msgs_short": "msgs",
  "eva_chat_empty_session": "sesión vacía",
  "eva_chat_reflecting": "Reflexionando…",
  "eva_chat_view_report": "Ver informe",
  "eva_chat_make_report": "Crear informe",
  "eva_chat_reports_empty": "Después de un chat, toca \\\"Crear reporte\\\" en la pestaña Pasado. Los resúmenes se guardan aquí.",
  "eva_chat_report_fallback": "Informe de chat",
  "insights_2": "Perspectivas",
  "delete_report": "Eliminar informe",
  "eva_chat_voice_locked": "La voz requiere Plus, Pro o Ultimate.",
  "journal_upgrade_cta": "Desbloquear",
  "cancel": "Cancelar",
  "delete": "Eliminar",
  "popup_report_failed": "Error del informe",
  "popup_not_enough_credits": "Créditos insuficientes",
  "popup_signup_required": "Registro necesario",
  "popup_signup_to_report": "Completa el registro para generar este informe.",
  "weekly_digest": "Resumen semanal",
  "what_weva_noticed": "Lo que WEVA notó",
  "a_gentle_next_step": "Un próximo paso gentil",
  "weva_didn_t_leave_a_summary_for_this": "WEVA no dejó un resumen para esta semana.",
  "talk_with_weva_about_this": "Habla con WEVA sobre esto",
  "retry": "Reintentar",
  "weva_report": "Reporte WEVA",
  "report_not_found": "Reporte no encontrado.",
  "expand_all": "Expandir todo",
  "collapse_all": "Contraer todo",
  "since_your_last_report": "Desde tu último reporte",
  "this_is_your_first_weva_report": "Este es tu primer reporte WEVA",
  "welcome_to_the_journey_come_back_after": "Bienvenido al viaje. Regresa después de tu próxima ventana de práctica: la tarjeta \\\"antes vs después\\\" comenzará a registrar tu crecimiento desde aquí.",
  "tap_to_open_previous_report": "Toca para abrir el reporte anterior ›",
  "try_this_first": "Prueba esto primero",
  "try_this_next": "Prueba esto después",
  "open_the_practice": "Abrir la práctica ›",
  "open_the_beliefs_table": "Abrir la tabla de Creencias ›",
  "weva_reports_title": "Nuevo informe de WEVA",
  "weva_reports_sub": "Elige qué considera WEVA.",
  "weva_reports_scope_all": "Todos los datos",
  "one_timeframe_applied_to_all_sources": "Un marco temporal aplicado a todas las fuentes.",
  "weva_reports_include_realize": "Incluir datos de Reconocer",
  "weva_reports_include_designate": "Incluir datos de Nombrar",
  "weva_reports_include_release": "Incluir datos de Soltar",
  "weva_reports_include_breakouts": "Incluir sesiones de Breathwork",
  "weva_reports_include_goals": "Incluir Mis Objetivos",
  "weva_reports_include_comfortzone": "Incluir Mi Zona de Confort",
  "weva_reports_include_coping": "Incluir Mi Afrontamiento",
  "weva_reports_include_journal": "Incluir Mi Diario",
  "my_beliefs_section_title": "Mis creencias",
  "upper_limits_section_title": "Mis límites superiores",
  "weva_reports_include_prior": "Incluir informes anteriores de WEVA",
  "weva_reports_generate": "Generar informe",
  "weva_reports_history": "Informes anteriores",
  "your_reports_will_live_here": "Tus informes vivirán aquí.",
  "no_reports_match_your_filters": "Ningún informe coincide con tus filtros.",
  "search_reports": "Buscar informes…",
  "weva_lang_picker_label": "Idioma del informe",
  "weva_lang_picker_hint": "El informe WEVA se escribirá en este idioma.",
  "get_a_weva_report": "Obtener un informe de WEVA",
  "reports_left": "informes restantes",
  "every_report_distils_your_recent": "Cada informe destila tu trabajo reciente de respiración, diarios, metas y zona de confort en una reflexión clara de WEVA.",
  "confirm_delete_weva_report_title": "¿Eliminar este informe WEVA?",
  "confirm_delete_weva_report_body": "Esta acción no se puede deshacer.",
  "confirm_delete": "Eliminar",
  "popup_delete_failed": "No se pudo eliminar",
  "nav.weva": "WEVA",
  "weva_subtitle": "Tu acompañante de vitalidad con IA.",
  "weva_action_digests": "Reflexiones semanales",
  "weva_action_digests_sub": "Resúmenes semanales de WEVA de tu trabajo interior.",
  "weva_digests_title": "Reflexiones semanales",
  "weva_digests_sub": "Resúmenes semanales de WEVA de tu trabajo interior.",
  "weva_digests_empty": "Aún no hay reflexiones semanales. Aparecen a medida que practicas con regularidad.",
  "weva_reflects_title": "WEVA reflexiona",
  "weva_reflects_sub": "El corazón de este informe",
  "weva_recommended_title": "Prácticas para ahora mismo",
  "weva_recommended_sub": "Toca para abrir",
  "weva_beliefs_noticed_title": "Creencias que WEVA notó",
  "weva_comp_new_entries": "Entradas nuevas",
  "weva_comp_practice_days": "Días de práctica",
  "weva_comp_mood_delta": "Δ ánimo medio",
  "weva_comp_beliefs": "Creencias",
  "weva_generating": "WEVA está reflexionando…",
  "weva_no_data": "No hay datos en el periodo elegido. Practica algo primero y vuelve a intentarlo.",
  "weva_credits_needed": "Este informe necesita 15 créditos (o una suscripción Plus/Pro). ¿Recargar créditos ahora?",
  "weva_scope_sources": "Fuentes y periodos",
  "weva_reports_left": "informes restantes",
  "weva_report_language": "Idioma del informe",
  "weva_tts_play": "Leer en voz alta",
  "weva_tts_stop": "Detener",


  // --- Collaboration (Teilen mit Coach) ---
  "collaboration_2": "Colaboración",
  "decide_who_sees_what_only_coaches_whose": "Decide quién ve qué. Solo los coaches a cuyo círculo interno te uniste pueden recibir tus datos.",
  "you_re_not_connected_to_any_coach_yet": "Aún no estás conectado con ningún coach.",
  "inner_circle_2": "Círculo Interno",
  "collab_join": "Unirse",
  "allow_to_collaborate_with": "Permitir colaborar con:",
  "even_in_a_3_way_chat_each_coach_only": "Incluso en un chat de 3 personas, cada coach solo ve los datos que compartiste con ELLOS. Nadie ve el otro lado.",
  "nav.collaboration": "Colaboración",
  "collab_share_events": "Eventos de crisis + emociones",
  "collab_share_hrv": "VFC + señal de frecuencia cardiaca",
  "collab_share_plans": "Planes de práctica + calendario",
  "collab_share_ai_reports": "Informes de análisis con IA",
  "collab_share_feed": "Actividad del feed",
  "collab_not_in_circle": "Fuera del círculo interno",
  "collab_active": "Círculo interno · activo",
  "collab_join_first": "Únete primero al círculo interno de este coach.",
  "collab_saved": "Permisos actualizados",


  // --- Epic E (Journal depth) + Epic F (Goals) ---
  "goals_action_archive": "Archivar",
  "goals_action_complete": "Marcar como completo",
  "goals_actions_body": "Elige una acción para este objetivo.",
  "goals_actions_title": "Acciones del objetivo",
  "goals_add": "Añadir",
  "goals_add_first": "Añadir tu primer objetivo",
  "goals_empty_body": "Un objetivo ayuda a WEVA y a ti a ver adónde vas. Añade el primero - son 3 minutos.",
  "goals_empty_title": "Aún no hay objetivos",
  "goals_framework_recap": "Tu marco",
  "goals_last_scale": "Último registro: {n}/10",
  "goals_log_note_ph": "Opcional: una nota sobre hoy (privada)",
  "goals_log_progress": "Registrar progreso",
  "goals_log_prompt": "¿Dónde estás hoy en este objetivo, de 1 (lejos) a 10 (vivido plenamente)?",
  "goals_more_hint": "Abre todos tus objetivos",
  "goals_no_progress_yet": "Aún sin progreso registrado",
  "goals_progress_card": "Progreso",
  "goals_progress_last_n": "Últimos {n} registros",
  "goals_q1_hint": "¿Qué sentimiento buscas realmente? Paz, conexión, autoconfianza, libertad. Escribe libremente, con tus propias palabras.",
  "goals_q1_num": "PASO 1 · INTROSPECCIÓN",
  "goals_q1_placeholder": "Siento que busco…",
  "goals_q1_short": "Necesidad emocional",
  "goals_q1_title": "Reconoce tu verdadera necesidad emocional.",
  "goals_q2_hint": "Pasa de lo vago a lo específico. ej. \\\"Quiero responder con más compasión en los conflictos\\\" en lugar de \\\"Quiero ser más amable.\\\"",
  "goals_q2_num": "PASO 2 · ESPECIFICIDAD",
  "goals_q2_placeholder": "Concretamente, quiero…",
  "goals_q2_short": "Objetivo concreto",
  "goals_q2_title": "Haz tu objetivo concreto.",
  "goals_q3_high": "Plenamente vivido",
  "goals_q3_hint": "Este es tu punto de partida - sin juicio. Registrarás check-ins en la misma escala.",
  "goals_q3_low": "Lejos",
  "goals_q3_num": "PASO 3 · MEDIBILIDAD",
  "goals_q3_scale_hint": "1 = lejos   ·   10 = plenamente vivido",
  "goals_q3_short": "Punto de partida",
  "goals_q3_title": "¿Dónde estás hoy en este objetivo, de 1 a 10?",
  "goals_q4_hint": "¿Por qué te importa este sentimiento? ¿Qué se vuelve posible cuando lo vives?",
  "goals_q4_num": "PASO 4 · ATRACTIVO",
  "goals_q4_placeholder": "Esto me importa porque…",
  "goals_q4_short": "Tu porqué",
  "goals_q4_title": "Conecta el objetivo con un porqué emocional profundo.",
  "goals_q5_hint": "Ajusta para que el objetivo trate de tus propias respuestas, no de lo que otros deben hacer. Mantenlo alcanzable.",
  "goals_q5_num": "PASO 5 · RELEVANCIA",
  "goals_q5_placeholder": "Esto está en mi control porque…",
  "goals_q5_short": "Realismo",
  "goals_q5_title": "¿Está este objetivo bajo tu propio control y es realista?",
  "goals_q6_hint": "ej. \\\"En las próximas cuatro semanas\\\", \\\"Antes del final del verano\\\".",
  "goals_q6_num": "PASO 6 · MARCO TEMPORAL",
  "goals_q6_placeholder": "En las próximas…",
  "goals_q6_short": "Marco temporal",
  "goals_q6_title": "¿En qué marco temporal quieres vivir esto?",
  "goals_q7_hint": "Dilo primero para ti, después escríbelo aquí. Es tu promesa escrita - amable y honesta.",
  "goals_q7_num": "PASO 7 · COMPROMISO ESCRITO",
  "goals_q7_placeholder": "Me comprometo a…",
  "goals_q7_short": "Compromiso",
  "goals_q7_title": "Escribe tu compromiso con tus propias palabras.",
  "goals_section_subtitle": "Define los objetivos que guían tu práctica.",
  "goals_section_title": "Mis Objetivos",
  "goals_see_all": "Ver los {n} objetivos",
  "goals_status_active": "Activo",
  "goals_status_archived": "Archivado",
  "goals_status_completed": "Completado",
  "goals_status_paused": "En pausa",
  "goals_title_placeholder": "ej. Responder con compasión en los conflictos",
  "goals_view_all": "Ver todos los objetivos",
  "goals_weva_analyze": "Analizar con WEVA",
  "goals_weva_card_title": "Reflexión de WEVA",
  "goals_weva_challenges": "Invitaciones suaves",
  "goals_weva_enable_body": "WEVA lee tus siete respuestas y registros, y ofrece una reflexión compasiva - fortalezas, invitaciones suaves y un próximo paso amable. Puedes desactivarlo en cualquier momento.",
  "goals_weva_enable_first_body": "Activa WEVA para este objetivo arriba, luego ejecuta el análisis.",
  "goals_weva_enable_first_title": "Activa primero la reflexión de WEVA",
  "goals_weva_enable_title": "Deja que WEVA reflexione sobre este objetivo",
  "goals_weva_next_step": "Un próximo paso amable",
  "goals_weva_no_analysis_yet": "Aún sin reflexión. Toca Analizar para invitar a WEVA.",
  "goals_weva_regenerate": "Reflexionar de nuevo",
  "goals_weva_strengths": "Lo que ya llevas contigo",
  "goals_wizard_discard_body": "Ya has empezado a rellenar. ¿Salir sin guardar?",
  "goals_wizard_discard_confirm": "Descartar",
  "goals_wizard_discard_title": "¿Descartar este objetivo?",
  "goals_wizard_final_h": "Casi listo - una última elección",
  "goals_wizard_final_hint": "Opcional: deja que WEVA reflexione sobre este objetivo en privado.",
  "goals_wizard_final_num": "CASI LISTO",
  "goals_wizard_recap": "Tu compromiso en resumen",
  "goals_wizard_recap_title": "Título",
  "goals_wizard_save": "Guardar objetivo",
  "goals_wizard_step_of": "Paso {n} de {total}",
  "goals_wizard_title_h": "Dale un nombre corto a tu objetivo",
  "goals_wizard_title_hint": "Una línea que reconozcas. Puedes cambiarla cuando quieras.",
  "goals_wizard_title_num": "TÍTULO DEL OBJETIVO",
  "journal_tab_entries": "Entradas del journal",
  "journal_tab_weva": "Insight WEVA",
  "journal_recording": "Grabando… toca para parar",
  "journal_transcribing": "Transcribiendo…",
  "journal_transcription_ready": "Transcripción lista. Edita o guarda.",
  "journal_tap_to_record": "Toca para grabar",
  "journal_permission_denied": "Micrófono denegado - habilítalo en Ajustes.",
  "journal_locked_voice": "El diario por voz requiere Plus.",
  "journal_monthly_used": "{n}/{q} entradas este mes",
  "journal_saved": "Entrada guardada. Inclúyela en un informe WEVA cuando quieras reflexionar.",
  "journal_empty": "Aún sin entradas. Tu primera reflexión está a una respiración.",
  "journal_subtitle": "Tu espacio privado de reflexión - escribe o habla.",
  "journal_prompt": "¿Cómo te sientes hoy? ¿Qué emociones, situaciones o creencias están vivas?",
  "journal_placeholder": "p. ej. Sentí tensión en el pecho antes de la reunión. Creí que me quedaría en blanco…",
  "journal_mood": "Ánimo",
  "journal_save": "Guardar entrada",
  "journal_new_entry": "Nueva entrada",
  "journal_tap_to_open": "Toca para abrir",
  "journal_entry_detail_title": "Entrada del journal",
  "journal_take_this_further": "Profundiza esto",
  "journal_work_alone_title": "Trabaja esto en soledad",
  "journal_work_alone_sub": "Genera un insight WEVA centrado solo en esta entrada para ver los patrones que revela.",
  "journal_work_coach_title": "Trabaja con un coach",
  "journal_work_coach_sub": "Reserva una sesión — tu entrada será adjuntada para que el coach pueda prepararse.",
  "journal_delete_confirm": "¿Borrar esta entrada? No se puede deshacer.",
  "journal_weva_included": "Tienes {n} {reportWord} incluidos en tu plan {plan}.",
  "journal_weva_credits_hint": "Un insight WEVA = 15 créditos. O mejora para incluir informes mensuales.",
  "journal_weva_report_singular": "informe",
  "journal_weva_report_plural": "informes",
  "journal_pick_prompt": "Marca 1+ entradas para enfocar un informe — o déjalo vacío para los últimos 30 días.",
  "journal_pick_selected_singular": "{n} entrada seleccionada",
  "journal_pick_selected_plural": "{n} entradas seleccionadas",
  "journal_pick_clear": "Limpiar",
  "journal_pick_empty": "Escribe tu primera entrada del journal — luego vuelve para marcarla para un informe.",
  "journal_weva_btn_picked": "Generar informe WEVA ({n} entradas)",
  "journal_weva_btn_30d": "Generar informe WEVA (últimos 30 días)",
  "journal_weva_btn_picked_credits": "Generar informe WEVA ({n} entradas) · 15 créditos",
  "journal_weva_btn_30d_credits": "Generar informe WEVA (últimos 30 días) · 15 créditos",
  "journal_weva_hint_picked": "WEVA se enfocará en las entradas que marcaste y revelará emociones, creencias y patrones recurrentes.",
  "journal_weva_hint_30d": "Combina tus entradas recientes del journal en una historia coherente de emociones, creencias y patrones.",
  "journal_weva_history_empty": "Aún no hay informes WEVA — genera el primero para ver patrones en tus entradas.",
  "journal_weva_report_fallback": "Informe generado.",
  "journal_journey_title": "Camina con un coach",
  "journal_journey_sub": "Alguien que pueda acompañarte a través de lo que revelan tus entradas.",
  "journal_new_entry_a11y": "Nueva entrada del journal",
  "eva": "WEVA",
  "eva_full_name": "Wellbeing Emotional Vitality Assistant",
  "eva_latest_insight": "Última percepción WEVA",
  "eva_tag_emotions": "Emociones",
  "eva_tag_beliefs": "Creencias",
  "eva_tag_behaviors": "Conductas",
  "eva_tag_body": "Señales del cuerpo",
  "eva_tag_situations": "Situaciones",
  "eva_tag_themes": "Temas",
  "eva_reflection": "WEVA reflexiona",
  "picked": "ELEGIDO",
  "goal_voice_hint": "Simplemente dilo en voz alta — nosotros lo escribimos.",
  "continue": "Continuar",
  "more": "more",
  "error": "Error",
  "done": "Hecho",
  "close": "Cerrar",
  "save": "Guardar",
  "nav.goals": "Metas",
  "jr_voice_hint": "Solo habla — lo escribimos por ti.",
  "jr_voice_start": "Grabar voz",
  "jr_voice_stop": "Detener grabación",
  "jr_voice_mic_denied": "Acceso al micrófono denegado. Permítelo en el navegador.",
  "jr_tab_entries": "Entradas",
  "jr_tab_weva": "Reflexión WEVA",

  "goals_coach_cta_title": "Trabaja esto con un coach",
  "goals_coach_cta_sub": "Encuentra un coach y reserva para trabajar juntos en esta meta.",


  // --- Epic D (Breathwork client) ---
  "best_for": "Ideal para",
  "breathwork": "Breathwork",
  "breathwork_insights_sub": "Tiempo de práctica, logros y patrones de tus sesiones.",
  "breathwork_insights_title": "Perspectivas",
  "breathwork_plan_examples": "Planes de ejemplo",
  "breathwork_plan_from_coach": "Plan de tu coach",
  "breathwork_plan_sub": "Anclas respiratorias: mañana, mediodía, noche.",
  "breathwork_plan_title": "Tu plan semanal",
  "breathwork_start_sub": "Elige emoción, comparte contexto, respira.",
  "breathwork_start_title": "Iniciar sesión",
  "breathwork_subtitle": "Mover la emoción por el cuerpo con la respiración.",
  "breathwork_techniques_sub": "Explora cada técnica antes de empezar.",
  "breathwork_techniques_title": "Biblioteca de técnicas",
  "confirm_decline": "Rechazar",
  "confirm_decline_plan_body": "Siempre puedes crear tu propia versión.",
  "confirm_decline_plan_title": "¿Rechazar el plan?",
  "confirm_delete_plan_body": "Esta acción no se puede deshacer.",
  "confirm_delete_plan_title": "¿Eliminar este plan?",
  "duration_2": "Duración",
  "explanation_how_it_works": "Cómo funciona",
  "how_to": "Cómo hacerlo",
  "intensity_2": "Intensidad",
  "intensity_gentle": "suave",
  "intensity_intense": "intenso",
  "intensity_medium": "medio",
  "lib_session_back_btn": "Volver a la biblioteca",
  "lib_session_note_ph": "¿Qué has notado?",
  "lib_session_note_sub": "Una nota corta para ti — opcional.",
  "lib_session_note_title": "¿Cómo fue tu sesión?",
  "lib_session_start_btn": "Iniciar sesión",
  "lib_session_wellbeing_sub": "1 = agotado, 10 = radiante",
  "lib_session_wellbeing_title": "¿Cómo te sientes ahora?",
  "lib_tech_478_body": "La respiración 4-7-8, popularizada por el Dr. Andrew Weil, funciona como un tranquilizante natural del sistema nervioso. La exhalación larga activa el nervio vago y prepara al cuerpo y la mente para el sueño o la calma profunda.",
  "lib_tech_478_step1": "Exhala por completo por la boca con un sonido suave.",
  "lib_tech_478_step2": "Cierra la boca e inhala por la nariz durante 4 segundos.",
  "lib_tech_478_step3": "Retén el aire durante 7 segundos.",
  "lib_tech_478_step4": "Exhala despacio por la boca durante 8 segundos.",
  "lib_tech_478_step5": "Haz 4 ciclos y luego descansa.",
  "lib_tech_bhramari_body": "Bhramari — la respiración de la abeja — usa un zumbido suave al exhalar que vibra en el nervio vago. Calma vagal profunda, ideal para ansiedad, insomnio y el ritual de dormir.",
  "lib_tech_bhramari_step1": "Siéntate erguido y cierra los ojos.",
  "lib_tech_bhramari_step2": "Inhala despacio por la nariz.",
  "lib_tech_bhramari_step3": "Al exhalar, zumba suavemente como una abeja.",
  "lib_tech_bhramari_step4": "Deja que la vibración llene tu cara y pecho.",
  "lib_tech_bhramari_step5": "Continúa de 6 a 10 rondas.",
  "lib_tech_box_body": "La respiración cuadrada es un ritmo sencillo de 4 partes que estabiliza el sistema nervioso en pocos minutos. Las fuerzas especiales la usan antes de decisiones tensas — discreta, portátil y eficaz.",
  "lib_tech_box_step1": "Inhala por la nariz durante 4 segundos.",
  "lib_tech_box_step2": "Mantén el aire con suavidad 4 segundos.",
  "lib_tech_box_step3": "Exhala por la boca durante 4 segundos.",
  "lib_tech_box_step4": "Mantén los pulmones vacíos 4 segundos.",
  "lib_tech_box_step5": "Repite el cuadrado de 3 a 10 minutos.",
  "lib_tech_coherent_body": "La respiración coherente (5-5) sincroniza el aliento y el ritmo cardíaco, aumentando la variabilidad de la frecuencia cardíaca. Solo 5 minutos te llevan del estrés a un estado calmado y enfocado — los cardiólogos la recomiendan como práctica diaria.",
  "lib_tech_coherent_step1": "Inhala suavemente por la nariz durante 5 segundos.",
  "lib_tech_coherent_step2": "Exhala suavemente por la nariz durante 5 segundos.",
  "lib_tech_coherent_step3": "Mantenlo blando — sin esfuerzo, sin forzar.",
  "lib_tech_coherent_step4": "Continúa de 5 a 20 minutos.",
  "lib_tech_cooling_body": "Sitali — la respiración refrescante — enfría literalmente el cuerpo y la mente. Ideal para momentos calientes: enfado, agitación, calor corporal o sofocos menopáusicos. Un clásico del yoga veraniego.",
  "lib_tech_cooling_step1": "Enrolla la lengua en forma de tubo (o frunce los labios suavemente).",
  "lib_tech_cooling_step2": "Inhala despacio por la boca sobre la lengua fresca.",
  "lib_tech_cooling_step3": "Cierra la boca y exhala suavemente por la nariz.",
  "lib_tech_cooling_step4": "Continúa de 3 a 8 minutos.",
  "lib_tech_kapalabhati_body": "Kapalabhati — la respiración que ilumina el cráneo — usa exhalaciones agudas e inhalaciones pasivas para energizar cuerpo y mente. Ideal por la mañana. Sáltala si sientes mareo o durante el embarazo.",
  "lib_tech_kapalabhati_step1": "Inhalaciones pasivas, exhalaciones agudas por la nariz.",
  "lib_tech_kapalabhati_step2": "El vientre se retrae en cada exhalación.",
  "lib_tech_kapalabhati_step3": "Empieza con 30 pulsos — descanso — repite de 2 a 3 rondas.",
  "lib_tech_kapalabhati_step4": "Detente inmediatamente si te sientes mareado.",
  "lib_tech_nadi_shodhana_body": "La respiración alternada (Nadi Shodhana) equilibra los hemisferios izquierdo y derecho del cerebro y disipa la niebla mental. Técnica yóguica tradicional — 5 minutos para más claridad.",
  "lib_tech_nadi_shodhana_step1": "Cierra la fosa derecha con el pulgar e inhala por la izquierda.",
  "lib_tech_nadi_shodhana_step2": "Cierra la izquierda con el anular y exhala por la derecha.",
  "lib_tech_nadi_shodhana_step3": "Inhala por la derecha.",
  "lib_tech_nadi_shodhana_step4": "Cierra la derecha y exhala por la izquierda.",
  "lib_tech_nadi_shodhana_step5": "Eso es una ronda — haz de 5 a 10.",
  "lib_tech_ocean_body": "Ujjayi — la respiración del océano — crea un susurro suave en la garganta que ancla la atención como olas en la playa. La respiración clásica de la meditación y el yoga.",
  "lib_tech_ocean_step1": "Contrae ligeramente el fondo de la garganta.",
  "lib_tech_ocean_step2": "Respira con un susurro oceánico suave y audible.",
  "lib_tech_ocean_step3": "Solo tú deberías escucharlo.",
  "lib_tech_ocean_step4": "Deja que sea el ancla de tu atención.",
  "lib_tech_physiological_sigh_body": "El suspiro fisiológico es la vía más rápida para liberar el estrés agudo — doble inhalación seguida de una larga exhalación, descubierto por el neurocientífico Dr. Andrew Huberman de Stanford. Funciona en menos de un minuto.",
  "lib_tech_physiological_sigh_step1": "Toma una inhalación larga y lenta por la nariz.",
  "lib_tech_physiological_sigh_step2": "Añade encima una segunda inhalación más corta.",
  "lib_tech_physiological_sigh_step3": "Suéltalo todo con una larga exhalación por la boca.",
  "lib_tech_physiological_sigh_step4": "Repite de 1 a 3 veces — nota el cambio.",
  "lib_tech_wim_hof_body": "El método Wim Hof combina 30 respiraciones profundas rápidas con una retención. Inunda el sistema con oxígeno y construye resiliencia. Intenso — nunca lo practiques mientras conduces o en el agua.",
  "lib_tech_wim_hof_step1": "Haz 30 respiraciones profundas — inhalación plena, exhalación relajada (sin forzar).",
  "lib_tech_wim_hof_step2": "Tras la número 30, exhala y retén tanto como sea cómodo.",
  "lib_tech_wim_hof_step3": "Cuando lo necesites, inhala profundamente y retén 15 segundos.",
  "lib_tech_wim_hof_step4": "Repite de 3 a 4 rondas.",
  "lib_tech_wim_hof_step5": "Detente inmediatamente si te sientes mal — nunca conduciendo o en el agua.",
  "phase_exhale": "Exhala",
  "phase_hold_in": "Retén",
  "phase_hold_out": "Descansa",
  "phase_inhale": "Inhala",
  "popup_adopted": "Adoptado ✓",
  "popup_plan_under_myplans": "El plan está ahora en «Mis planes». Ábrelo para adaptarlo o replanificar.",
  "posture_lying": "Tumbado boca arriba",
  "posture_reclined": "Semi-reclinado, apoyado en un bolster",
  "posture_seated_chair": "Sentado en una silla, pies apoyados",
  "posture_seated_cross": "Sentado con las piernas cruzadas, espalda recta",
  "posture_standing": "De pie, brazos relajados",
  "recommended_posture": "Postura recomendada",
  "session_done_btn": "Listo",
  "session_success_body": "Esta respiración valió la pena. Quédate en esta sensación.",
  "session_success_title": "¡Bien hecho!",
  "tech_478": "Respiración 4-7-8",
  "tech_478_bestfor": "sueño, ansiedad",
  "tech_478_desc": "Inhala 4, retén 7, exhala 8. Calma el sistema nervioso.",
  "tech_478_step1": "Exhala completamente por la boca.",
  "tech_478_step2": "Inhala por la nariz durante 4 segundos.",
  "tech_478_step3": "Retén 7 segundos.",
  "tech_478_step4": "Exhala por la boca durante 8 segundos.",
  "tech_478_step5": "Haz 4 ciclos - luego descansa.",
  "tech_bhramari": "Bhramari (aliento de abeja)",
  "tech_bhramari_bestfor": "tono vagal, calma",
  "tech_bhramari_desc": "Zumba al exhalar - calma vagal.",
  "tech_bhramari_step1": "Siéntate erguido, cierra los ojos.",
  "tech_bhramari_step2": "Inhala por la nariz.",
  "tech_bhramari_step3": "Al exhalar, tararea como una abeja.",
  "tech_bhramari_step4": "Siente la vibración en cara y pecho.",
  "tech_bhramari_step5": "Continúa durante 6–10 rondas.",
  "tech_box": "Respiración Cuadrada (4-4-4-4)",
  "tech_box_bestfor": "estrés, concentración",
  "tech_box_desc": "Igual dentro / retener / fuera / retener. Reset rápido.",
  "tech_box_step1": "Inhala por la nariz durante 4 segundos.",
  "tech_box_step2": "Retén 4 segundos.",
  "tech_box_step3": "Exhala por la boca durante 4 segundos.",
  "tech_box_step4": "Mantén vacío 4 segundos.",
  "tech_box_step5": "Repite durante 3–10 minutos.",
  "tech_coherent": "Respiración Coherente (5-5)",
  "tech_coherent_bestfor": "arraigo, VFC",
  "tech_coherent_desc": "5s dentro, 5s fuera. Ancla la VFC.",
  "tech_coherent_step1": "Inhala suavemente durante 5 segundos.",
  "tech_coherent_step2": "Exhala suavemente durante 5 segundos.",
  "tech_coherent_step3": "Mantén suave - sin esfuerzo.",
  "tech_coherent_step4": "Continúa durante 5–20 minutos.",
  "tech_connected": "Respiración Conectada",
  "tech_connected_bestfor": "liberación emocional",
  "tech_connected_desc": "Circular, sin pausa. Liberación emocional; hazlo acompañado.",
  "tech_connected_learn_more": "Conocer esta práctica",
  "tech_connected_step1": "Inhalación + exhalación continuas sin pausa.",
  "tech_connected_step2": "Respira por boca o nariz.",
  "tech_connected_step3": "Hazlo sólo con un facilitador entrenado o en un espacio bien sostenido.",
  "tech_connected_step4": "Pueden surgir emociones — ese es el objetivo.",
  "tech_cooling": "Respiración refrescante (Sitali)",
  "tech_cooling_bestfor": "calor, ira, agitación",
  "tech_cooling_desc": "Inhala lento sobre la lengua enrollada - libera calor e irritación.",
  "tech_cooling_step1": "Enrolla la lengua en tubo (o frunce los labios).",
  "tech_cooling_step2": "Inhalación lenta por la boca sobre la lengua fría.",
  "tech_cooling_step3": "Cierra la boca, exhala suavemente por la nariz.",
  "tech_cooling_step4": "Repite durante 3–8 minutos.",
  "tech_kapalabhati": "Kapalabhati (cráneo brillante)",
  "tech_kapalabhati_bestfor": "vigilia",
  "tech_kapalabhati_desc": "Exhalaciones agudas, inhalaciones pasivas. Activadora.",
  "tech_kapalabhati_step1": "Inhalaciones pasivas, exhalaciones agudas por la nariz.",
  "tech_kapalabhati_step2": "El vientre se retrae en cada exhalación.",
  "tech_kapalabhati_step3": "Empieza con 30 pulsos - descansa - repite 2–3 rondas.",
  "tech_kapalabhati_step4": "Detente si te mareas.",
  "tech_nadi_shodhana": "Nadi Shodhana (nariz alterna)",
  "tech_nadi_shodhana_bestfor": "equilibrio, concentración",
  "tech_nadi_shodhana_desc": "Equilibra hemisferios izquierdo/derecho.",
  "tech_nadi_shodhana_step1": "Cierra la fosa derecha, inhala por la izquierda.",
  "tech_nadi_shodhana_step2": "Cierra la izquierda, exhala por la derecha.",
  "tech_nadi_shodhana_step3": "Inhala por la derecha.",
  "tech_nadi_shodhana_step4": "Cierra la derecha, exhala por la izquierda.",
  "tech_nadi_shodhana_step5": "Eso es una ronda - haz 5–10.",
  "tech_ocean": "Respiración Oceánica (Ujjayi)",
  "tech_ocean_bestfor": "ancla de meditación",
  "tech_ocean_desc": "Contrae ligeramente la garganta - ancla meditativa.",
  "tech_ocean_step1": "Contrae ligeramente el fondo de la garganta.",
  "tech_ocean_step2": "Respira con un suave susurro tipo océano.",
  "tech_ocean_step3": "Manténlo audible sólo para ti.",
  "tech_ocean_step4": "Que sea el ancla de tu atención.",
  "tech_physiological_sigh": "Suspiro fisiológico",
  "tech_physiological_sigh_bestfor": "estrés agudo",
  "tech_physiological_sigh_desc": "Doble inhalación + exhalación larga - caída rápida del estrés.",
  "tech_physiological_sigh_step1": "Toma una inhalación larga por la nariz.",
  "tech_physiological_sigh_step2": "Luego una segunda inhalación más pequeña encima.",
  "tech_physiological_sigh_step3": "Exhalación larga y lenta por la boca.",
  "tech_physiological_sigh_step4": "Repite 1–3 veces.",
  "tech_practice_guide_only": "Práctica guiada",
  "tech_practice_guide_only_body": "Esta técnica es una práctica guiada - sigue los pasos de arriba. Un reproductor in-app está en camino.",
  "tech_wim_hof": "Wim Hof",
  "tech_wim_hof_bestfor": "energía, resiliencia",
  "tech_wim_hof_desc": "30 respiraciones profundas → retención → recuperación.",
  "tech_wim_hof_step1": "30 respiraciones profundas - llena, deja salir (no fuerces).",
  "tech_wim_hof_step2": "Después de la 30, exhala y retén todo lo cómodo.",
  "tech_wim_hof_step3": "Inhala profundamente y retén 15 segundos.",
  "tech_wim_hof_step4": "Repite 3–4 rondas.",
  "tech_wim_hof_step5": "Nunca lo hagas conduciendo o en el agua.",
  "technique_not_found": "Técnica no encontrada",
  "ui_accept_activate": "Aceptar y activar",
  "ui_adopt": "Adoptar este plan",
  "ui_create_plan": "Crear plan",
  "ui_days": "días",
  "ui_decline": "Rechazar",
  "ui_min": "min",
  "ui_my_plans": "Mis planes",
  "ui_no_coach_plans_sub": "Cuando tu coach comparta un plan, aparecerá aquí.",
  "ui_no_coach_plans_title": "Sin planes del coach",
  "ui_no_plans_sub": "Crea uno o adopta una plantilla.",
  "ui_no_plans_title": "Aún sin planes",
  "ui_pending_action": "esperando tu respuesta",
  "ui_sessions": "sesiones",
  "ui_slots": "slots",
  "ui_templates_empty_sub": "Actualiza o revisa tu conexión.",
  "ui_templates_empty_title": "No se pudieron cargar los ejemplos",

  "nav.breathwork": "Respiración",
  "nav.breakout": "Breakout",


  // --- Epic G+H (Feed + Messages client) ---
  "feed": "Feed",
  "feed_tab_global": "Global",
  "feed_tab_regional": "Regional",
  "feed_tab_interest": "Interés",
  "feed_search_placeholder": "Busca título, coach o hashtag…",
  "no_posts_yet": "Aún no hay publicaciones.",
  "loading": "Cargando...",
  "coach": "Coach",
  "post_paid_chip": "PAGO",
  "post_sponsored_chip": "Patrocinado",
  "unlock_credits": "Desbloquear · {n} créditos",
  "paid_locked": "Vista previa de pago",
  "post_book_now": "Reservar",
  "post_action_react": "Reaccionar",
  "post_action_comment": "Comentar",
  "post_action_save": "Guardar",
  "post_action_share": "Compartir",
  "report_post_title": "Reportar esta publicación",
  "report_reason_spam": "Spam o engañoso",
  "report_reason_inappropriate": "Contenido inapropiado",
  "report_reason_medical_claim": "Afirmación médica sin respaldo",
  "report_reason_other": "Otro",
  "reported": "Reportado. Gracias.",
  "description": "Descripción",
  "submit": "Enviar",
  "reaction_heart": "Corazón",
  "reaction_inspired": "Inspirado",
  "reaction_moved": "Conmovido",
  "reaction_strong": "Fuerte",
  "block_user_cta": "Bloquear a este usuario",
  "chats": "Chats",
  "chats_tab_all": "Todos",
  "chats_tab_circles": "Círculos",
  "chats_tab_direct": "Directos",
  "chats_tab_shared": "Compartidos",
  "no_conversations": "Aún no hay conversaciones.",
  "my_circles": "Mis círculos",
  "shared_chats": "Chats de coaching compartidos",
  "direct_messages": "Mensajes directos",
  "three_way_care": "Cuidado del cliente a 3 bandas",
  "members": "miembros",
  "message_deleted": "Mensaje eliminado",
  "message": "Mensaje",
  "no_messages_hint": "Envía un mensaje para comenzar la conversación.",
  "write_a_message": "Escribe un mensaje...",
  "delete_message_title": "¿Eliminar mensaje?",
  "delete_message_confirm": "Este mensaje será reemplazado por un marcador «eliminado» para todos en el chat.",
  "something_went_wrong": "Algo salió mal. Inténtalo de nuevo.",
  "nav.feed": "Feed",
  "nav.messages": "Mensajes",
  "feed_comments_title": "Comentarios",
  "feed_no_comments": "Aún no hay comentarios. Sé la primera voz amable.",
  "feed_write_comment": "Escribe un comentario…",
  "feed_add_comment": "Publicar",
  "feed_unlocked": "Desbloqueado",
  "feed_open_post": "Abrir publicación",
  "feed_credits_needed": "Esta publicación cuesta {n} créditos. ¿Recargar ahora?",
  "msg_support": "Soporte",
  "msg_new_chat": "Nuevo mensaje",

  "messages": "Mensajes",
  "chats_support_btn": "Soporte",
  "join_by_code": "¿Tienes un código de invitación?",
  "chats_join_placeholder": "Introduce el código",
  "join": "Unirse",
  "chats_invalid_code": "Código no válido",
  "circles_empty_sub": "Cuando un coach te invite a un círculo, aparecerá aquí.",
  "new_chat_fab_a11y": "Iniciar un nuevo chat",
  "shared_coaching_chat": "Chat de coaching compartido",
  "shared_chat_banner": "Todos los miembros pueden ver los mensajes de este chat compartido.",
  "shared_chat_no_access_title": "Este chat es privado",
  "shared_chat_no_access_body": "Solo los miembros de este chat de coaching compartido pueden ver los mensajes.",
  "shared_chat_empty": "Aún no hay mensajes. Inicia la conversación.",
  "shared_chat_placeholder": "Escribe a todos …",
  "new_chat_title": "Nuevo chat",
  "new_chat": "Nuevo chat",
  "new_chat_pick_coach": "Elige un coach",
  "new_chat_pick_second": "Elige un segundo coach",
  "new_chat_shared_toggle": "Iniciar un chat compartido con dos coaches",
  "new_chat_search_placeholder": "Buscar coaches …",
  "new_chat_no_results": "No se encontraron coaches.",
  "new_chat_cancel": "Cancelar",
  "new_chat_start_btn": "Iniciar chat",
  "new_chat_start_shared_btn": "Iniciar chat compartido",
  "new_chat_error_same_coach": "Elige dos coaches diferentes.",
  "post_details": "Publicación",
  "post_not_found": "Publicación no encontrada.",
  "comment_sheet_title": "Comentarios ({n})",
  "comment_empty": "Aún no hay comentarios. Sé el primero.",
  "comment_input_placeholder": "Escribe un comentario …",
  "series_progress": "{viewed}/{total} vistos",
  "panic_attack_btn": "Ataque de pánico",
  "panic_attack_btn_sub": "Ayuda respiratoria guiada",
  "panic_picker_title": "¿Dónde estás ahora mismo?",
  "panic_picker_sub": "Elige la fase que corresponda — te guiaremos con la respiración adecuada.",
  "panic_stage_early_title": "Primeros signos",
  "panic_stage_early_sub": "Inquietud interior, la ansiedad sube",
  "panic_stage_acute_title": "Emergencia aguda",
  "panic_stage_acute_sub": "Ataque de pánico completo, falta de aire",
  "panic_stage_subside_title": "Fase de disminución",
  "panic_stage_subside_sub": "Cuerpo temblando, pulso bajando lentamente",
  "panic_stage_prevent_title": "Prevención",
  "panic_stage_prevent_sub": "En el día a día, sin ansiedad aguda",
  "panic_tech_2_4": "Respiración 2-4",
  "panic_tech_pursed": "Respiración con labios fruncidos · postura de portero",
  "panic_tech_478": "Respiración 4-7-8",
  "panic_tech_diaphragm": "Respiración diafragmática",
  "panic_technique_label": "Técnica",
  "panic_intro_early_title": "Calma la ola que llega",
  "panic_intro_early_body": "Esta técnica evita la hiperventilación. La exhalación prolongada le señala seguridad a tu cerebro pronto.",
  "panic_intro_acute_title": "Alivio inmediato para los pulmones",
  "panic_intro_acute_body": "Efecto inmediato: la resistencia de los labios empuja el aire usado fuera de los pulmones y detiene la falta de aire aguda.",
  "panic_intro_subside_title": "Un sedante natural",
  "panic_intro_subside_body": "Actúa como un sedante natural. La retención larga y la exhalación llevan al sistema cardiovascular a una relajación profunda.",
  "panic_intro_prevent_title": "Entrena tu diafragma a diario",
  "panic_intro_prevent_body": "Entrena el diafragma y reduce el nivel de estrés a largo plazo, para que el cuerpo reaccione con menos intensidad en crisis.",
  "panic_body_hint_early": "Siéntate o quédate de pie erguido. Respira suavemente por la nariz.",
  "panic_body_hint_acute": "Postura de portero: inclínate ligeramente hacia adelante, manos en las rodillas, labios fruncidos como para soplar una vela.",
  "panic_body_hint_subside": "Siéntate erguido. Punta de la lengua detrás de los dientes superiores. Exhala con un suave “whoosh”.",
  "panic_body_hint_prevent": "Coloca una mano sobre tu vientre. Sube al inhalar, baja al exhalar.",
  "panic_intensity_recap_title": "¿Qué tan intenso fue tu pánico?",
  "panic_intensity_scale_hint": "1 = calma, 10 = máxima",
  "panic_intensity_continue": "Continuar",
  "panic_analytics_title": "Analítica de ataques de pánico",
  "panic_analytics_sub": "Tu respuesta al pánico en el tiempo.",
  "breathe_easy_btn": "Respirar Mejor",
  "breathe_easy_btn_sub": "Para EPOC y falta de aire",
  "copd_picker_title": "¿Qué situación te describe?",
  "copd_picker_sub": "Elige una técnica — te guiaremos paso a paso.",
  "copd_stage_pursed_title": "Respiración con labios fruncidos",
  "copd_stage_pursed_sub": "Falta de aire aguda, tras esfuerzo",
  "copd_stage_belly_title": "Respiración abdominal",
  "copd_stage_belly_sub": "Fases de descanso, relajación",
  "copd_stage_contact_title": "Respiración de contacto",
  "copd_stage_contact_sub": "Estrés, ventilación profunda dirigida",
  "copd_stage_huff_title": "Huffing",
  "copd_stage_huff_sub": "Mucosidad persistente en las vías respiratorias",
  "copd_stage_acbt_title": "Ciclo activo de respiración",
  "copd_stage_acbt_sub": "Rutina diaria de limpieza pulmonar",
  "copd_intro_pursed_title": "Estabiliza tus vías respiratorias",
  "copd_intro_pursed_body": "Estabiliza tus vías respiratorias y evita su colapso — alivio inmediato ante la falta de aire.",
  "copd_intro_belly_title": "Más volumen, menos esfuerzo",
  "copd_intro_belly_body": "Utiliza el diafragma en lugar de la respiración torácica superficial. Más volumen, menos esfuerzo.",
  "copd_intro_contact_title": "Las manos guían la respiración",
  "copd_intro_contact_body": "Tus manos dirigen la atención a zonas específicas de los pulmones y profundizan la respiración.",
  "copd_intro_huff_title": "Mover el moco sin esfuerzo",
  "copd_intro_huff_body": "Mueve la mucosidad hacia arriba sin forzar las vías respiratorias.",
  "copd_intro_acbt_title": "Relaja · Ventila · Limpia",
  "copd_intro_acbt_body": "Una rutina diaria de tres fases: relajar, ventilar, limpiar.",
  "copd_pursed_step1": "Inhala suavemente por la nariz.",
  "copd_pursed_step2": "Junta los labios ligeramente — como para silbar.",
  "copd_pursed_step3": "Exhala lentamente contra la resistencia de los labios. El doble de tiempo que al inhalar.",
  "copd_belly_step1": "Siéntate o acuéstate cómodamente.",
  "copd_belly_step2": "Coloca una mano sobre tu vientre.",
  "copd_belly_step3": "Inhala — siente que tu mano sube.",
  "copd_belly_step4": "Exhala — idealmente con labios fruncidos.",
  "copd_contact_step1": "Coloca las manos planas sobre las costillas o el bajo vientre.",
  "copd_contact_step2": "Al exhalar, ayuda suavemente con las manos.",
  "copd_contact_step3": "Al inhalar, empuja contra las manos.",
  "copd_huff_step1": "Inhala profundamente.",
  "copd_huff_step2": "Abre bien la boca — como para empañar un espejo.",
  "copd_huff_step3": "Expulsa el aire en ráfagas cortas y fuertes — sonido «haff».",
  "copd_acbt_p1_body": "Respira con normalidad y relajado durante unos minutos.",
  "copd_acbt_p2_body": "3–4 respiraciones profundas, cada una retenida 3 segundos.",
  "copd_acbt_p3_body": "Empuja hacia arriba la mucosidad soltada, luego tose suavemente.",
  "copd_step_next": "Siguiente",
  "copd_intensity_title": "¿Cómo era tu respiración?",
  "copd_intensity_scale_hint": "1 = fácil, 10 = muy difícil",
  "copd_intensity_before_short": "Antes",
  "copd_intensity_after_short": "Ahora",
  "copd_intensity_continue": "Continuar",
  "copd_analytics_title": "Analítica respiratoria",
  "copd_analytics_sub": "Tus patrones respiratorios en el tiempo.",
  "posture_coach_title": "Postura del cochero",
  "posture_coach_sub": "Borde de la silla, piernas separadas, codos sobre los muslos, cabeza relajada hacia adelante.",
  "posture_goalkeeper_title": "Postura de portero",
  "posture_goalkeeper_sub": "Rodillas ligeramente flexionadas, inclínate hacia adelante, manos en los muslos.",
  "posture_wall_title": "Postura de pared",
  "posture_wall_sub": "Apoya la espalda o el costado contra una pared.",
  "posture_lay_title": "Tumbado",
  "posture_lay_sub": "Boca arriba, rodillas ligeramente flexionadas, cabeza apoyada de lado.",
  "posture_upright_title": "Siéntate con la espalda recta",
  "posture_upright_sub": "En el borde de la silla, pies planos, espalda recta, hombros relajados.",
  "posture_recommended_title": "Tu postura",
  "posture_recommended_sub": "Elige la que mejor te siente.",
  "explanation_ready_btn": "Estoy preparado",
  "analytics_sect_trend": "Tendencia semanal",
  "analytics_sect_situations": "Situaciones",
  "analytics_sect_techniques": "Técnicas",
  "analytics_sect_postures": "Posturas",
  "analytics_sect_timeline": "Historial",
  "analytics_no_sessions": "Aún no hay sesiones.",
  "analytics_no_sessions_sub": "Completa tu primera respiración guiada para ver estadísticas aquí.",
  "analytics_no_data": "Sin datos",
  "analytics_kpi_sessions": "Sesiones",
  "analytics_kpi_avg_before": "Prom. antes",
  "analytics_kpi_avg_after": "Prom. después",
  "analytics_kpi_reduction": "Reducción prom.",
  "analytics_before_short": "Antes",
  "analytics_sec": "s",
  "analytics_stage_early": "Primeras señales",
  "analytics_stage_acute": "Emergencia aguda",
  "analytics_stage_subside": "Cediendo",
  "analytics_stage_prevent": "Prevención",
  "analytics_tech_pursed_lip": "Labios fruncidos",
  "analytics_tech_4_7_8": "Respiración 4-7-8",
  "analytics_tech_diaphragmatic": "Diafragmática",
  "analytics_tech_belly": "Respiración ventral",
  "analytics_tech_contact": "Respiración de contacto",
  "analytics_tech_huff": "Huffing",
  "analytics_tech_acbt": "Ciclo activo (ACBT)",
  "analytics_posture_coach": "Postura del cochero",
  "analytics_posture_goalkeeper": "Portero",
  "analytics_posture_wall": "Contra la pared",
  "analytics_posture_lay": "Tumbado",
  "analytics_posture_upright": "Erguido",
  "analytics_posture_none": "Sin postura",
  "analytics_tech_2_4_breathing": "Respiración 2-4",
  "analytics_tech_pursed": "Labios fruncidos",
  "settings": "Ajustes",
  "language": "Idioma",
  "event_display_pref": "Mostrar eventos como",
  "by_technique": "Técnica",
  "by_emotion": "Emoción",
  "by_base_situation": "Situación base",
  "privacy_and_data": "Privacidad y datos",
  "upgrade_plan": "Mejorar plan",
  "upgrade_to_coach": "Actualizar a cuenta de coach",
  "mode": "Modo",
  "switch_to_coach_view": "Cambiar a vista coach",
  "sign_out": "Cerrar sesión",
  "disclaimer": "Esta aplicación apoya la autorregulación emocional y no reemplaza la atención médica, psicológica o de emergencia.",
  "download_my_data": "Descargar mis datos",
  "gdpr_art20": "Consigue una copia de todo (RGPD Art. 20)",
  "terms_of_service": "Términos del servicio",
  "privacy_policy": "Política de privacidad",
  "refund_policy": "Política de reembolso",
  "blocked_users_title": "Usuarios bloqueados",
  "blocked_users_empty": "Aún no has bloqueado a nadie.",
  "delete_my_account": "Eliminar mi cuenta",
  "delete_my_account_sub": "Permanente · borrado en cascada de todos los datos",
  "delete_account_confirm_title": "¿Eliminar la cuenta permanentemente?",
  "delete_account_confirm_body": "Esto no se puede deshacer. Se borrarán todos los datos de diario, chat y práctica.",
  "delete_account_confirm_cta": "Eliminar",
  "need_help_now": "¿Necesitas ayuda ahora?",
  "crisis_helplines": "Líneas de crisis · números de emergencia",
  "data_sharing": "Compartir datos",
  "data_sharing_sub": "Elige qué puede ver cada coach",
  "data_sharing_ic_badge": "Inner Circle",
  "data_sharing_n_shared": "{count} compartido",
  "data_sharing_none_shared": "Nada compartido",
  "data_sharing_intro": "Decide exactamente qué puede ver {coachName}. Puedes cambiarlo en cualquier momento.",
  "data_sharing_save": "Guardar cambios",
  "data_sharing_updated": "Actualizado {when}",
  "data_sharing_none_available_body": "Aún no estás conectado con ningún coach. Reserva una sesión o únete a un Inner Circle.",
  "profile": "Perfil",
  "profile_subtitle": "Tu cuenta, tus coaches y tu enlace de referidos.",
  "edit_name": "Editar nombre",
  "email": "Correo electrónico",
  "phone": "Número de teléfono",
  "country": "País",
  "country_pick_hint": "Por favor selecciona tu país",
  "contraindications": "Contraindicaciones",
  "contraindications_hint": "Evitaremos técnicas que puedan no ser seguras para ti.",
  "weekly_report_title": "Email semanal de práctica",
  "weekly_report_hint": "Un resumen suave de tu semana cada domingo por la tarde.",
  "saved": "Guardado ✓",
  "invite_friends_earn": "Invita amigos · gana 5 € cada uno",
  "invite_friends_sub": "Ambos recibiréis recompensa tras su primera sesión",
  "account": "Cuenta",
  "edit_profile": "Editar perfil",
  "account_more": "Más",
  "account_manage": "Gestionar cuenta",
  "consent_forms_title": "Consentimientos",
  "consent_forms_sub": "Tus formularios de consentimiento firmados.",
  "consent_forms_empty": "Aún no hay formularios firmados.",
  "consent_signed_on": "Firmado el {when}",
  "consent_version": "Versión {v}",
  "unblock": "Desbloquear",
  "bio_label": "Sobre ti",
  "export_started": "Tu exportación de datos se está descargando.",
  "delete_code_prompt": "Escribe el código {code} para confirmar la eliminación permanente:",
  "delete_code_mismatch": "El código no coincide. La cuenta NO se eliminó.",
  "profile_account_section": "Datos de la cuenta",
  "profile_health_section": "Salud",
  "add": "Añadir",
  "create_account_cta": "Crear cuenta",
  "safety": "Seguridad",
  "you_re_not_alone": "Aquí estamos contigo",
  "if_you_are_in_immediate_danger_call": "Si estás en peligro inmediato, llama ahora al número de emergencias local.",
  "your_country": "Tu país",
  "safety_other": "Otro…",
  "choose_country": "Elegir país",
  "search_country": "Buscar país…",
  "no_match_try_a_different_name": "Sin coincidencias. Prueba con un nombre diferente.",
  "my_within_is_not_a_medical_device_or_a": "My Within no es un dispositivo médico ni un sustituto de atención profesional. Si estás trabajando con un terapeuta o médico, por favor continúa siguiendo su orientación.",
  "help_faq": "Ayuda y preguntas frecuentes",
  "search_all_help_articles": "Buscar en todos los artículos de ayuda…",
  "new_support_request": "Nueva solicitud de soporte",
  "start_a_new_support_chat": "Iniciar un nuevo chat de soporte",
  "your_email": "Tu correo electrónico",
  "you_email_com": "tu@email.com",
  "describe_your_issue": "Describe tu problema…",
  "suppor_send": "Enviar",
  "suppor_reply": "Responder…",
  "my_within_ai": "My Within AI",
  "status": "Estado",
  "my_within_team": "💬 Equipo de My Within",
  "forwarded_to_a_human_reply_arriving_by": "↳ Reenviado a una persona - respuesta llegará por correo electrónico.",
  "popup_email_required": "Se requiere un correo",
  "popup_email_for_reply": "Introduce tu correo para que podamos responderte.",
  "this_week": "Esta semana",
  "sessions": "sesiones",
  "streak_days": "Racha",
  "avg_drop": "Ø reducción",
  "digest_unique_days": "Días practicados",
  "digest_avg_duration": "Duración media",
  "digest_biggest_drop": "Mayor cambio",
  "digest_top_emotion": "Emoción más sentida",
  "digest_top_technique": "Técnica favorita",
  "digest_empty_client": "Esta semana sin sesiones — un solo respiro ya cuenta.",
  "digest_email_me": "Mandármelo por mail",
  "digest_hint_client": "Tu digest llega cada domingo por la tarde por email.",
  "digest_sent_title": "Enviado a tu bandeja",
  "digest_sent_body": "Revisa tu email para el digest completo.",
  "digest_trend_4w": "Últimas 4 semanas",
  "friendly_error_title": "Un momento",
  "coach_earnings_cashable": "Ganancias de coach (disponibles)",
  "coach_earnings_held": "Ganancias de coach (retenidas)",
  "credits_2": "Créditos",
  "no_transactions_yet": "Aún no hay transacciones.",
  "purchases_refunds_and_coach_earnings": "Las compras, reembolsos y ganancias del coach aparecerán aquí.",
  "transaction_history": "Historial de transacciones",
  "abbrechen_und_neu_starten": "Abbrechen und neu starten",
  "bevor_dein_vorteil_aktiviert_wird": "Antes de activar tu beneficio, verificaremos un método de pago a través de Stripe. No se realizará ningún cargo — solo una tarjeta segura guardada en archivo.",
  "case_insensitive_format_mw_gefolgt_von": "Case-insensitive · Format: MW- gefolgt von einer kurzen Kombination aus Buchstaben und Zahlen.",
  "dein_code": "Tu código",
  "dein_vorteil_wurde_deinem_account": "Tu beneficio ha sido acreditado a tu cuenta.",
  "hast_du_unsere_crowdfunding_kampagne": "¿Apoyaste nuestra campaña de crowdfunding? Ingresa tu código de apoyo y tu beneficio se activará inmediatamente después de una rápida verificación de pago.",
  "kein_code_erhalten": "Kein Code erhalten?",
  "mw_xxx_xxxx": "MW-XXX-XXXX",
  "pledge_code_einlo_sen": "Canjear código de apoyo",
  "support_my_within_com": "support@my-within.com",
  "warte_auf_deine_ru_ckkehr": "Esperando tu regreso...",
  "weiter_zur_zahlungsverifizierung": "Weiter zur Zahlungsverifizierung",
  "willkommen_bei_my_within": "Willkommen bei My Within",
  "zuru_ck_zur_startseite": "Volver al inicio",
  "ai_verdict": "Veredicto de IA",
  "become_coach_complete_steps": "Completa los dos pasos de abajo para desbloquear círculos, publicaciones, productos y suscripciones de pago.",
  "become_coach_full_access": "Tienes acceso completo a las funciones de monetización de coach.",
  "become_coach_rejected": "Sube un certificado más claro o escribe a renew@insideoutharmony.com.",
  "become_coach_title": "Ser coach",
  "dpa_accept": "Aceptar el acuerdo",
  "dpa_accept_button": "Aceptar acuerdo de corresponsables",
  "dpa_body": "Como coach, tú e Inside Out Harmony e.U. sois {joint} de los datos de vuestros clientes según el RGPD Art. 26. Aceptas procesar los datos de clientes solo en la plataforma, no exportarlos ni copiarlos externamente y notificar cualquier incidente en 24 horas.",
  "dpa_joint_controllers": "corresponsables",
  "dpa_read_full": "Leer el acuerdo completo →",
  "dpa_title": "Acuerdo de corresponsables (DPA)",
  "not_yet_verified": "Aún sin verificar",
  "once_verified": "Una vez verificado podrás:",
  "popup_approved_check": "Aprobado ✅",
  "popup_couldnt_read_image": "No se pudo leer la imagen",
  "popup_error_title": "Algo salió mal",
  "popup_submitted": "Enviado",
  "qual_cert_areas": "Áreas aceptadas: respiración, meditación, mindfulness, yoga terapéutico, coaching, psicología, terapia, experiencia somática y credenciales de bienestar relacionadas.",
  "qual_cert_before_verified": "Las recomendaciones de afiliados funcionan incluso antes de la verificación.",
  "qual_cert_hint": "Sube una foto/escaneo nítido de tu certificación de coaching, terapia, respiración o bienestar. La IA lo revisa en segundos. Si no podemos verificarlo automáticamente, un administrador lo revisa en 48 h.",
  "qual_cert_reupload": "Volver a subir el certificado",
  "qual_cert_title": "Certificado de cualificación",
  "qual_cert_upload": "Subir certificado",
  "qual_cert_upload_short": "Subir certificado",
  "account_help": "Ayuda",
  "account_support": "Soporte",
  "account_purchases": "Historial de compras",
  "account_redeem": "Canjear aporte",
  "help_search_empty": "Sin resultados para “{q}”. Prueba otras palabras o abre Soporte.",
  "purchases_balance": "Saldo",
  "weekly_digest_email_toggle": "Resumen semanal por correo",
  "redeem_needs_payment": "Se requiere verificación de pago. Complétala en la app móvil.",
  "redeem_invalid": "Código no válido o ya canjeado.",
  "support_resolved": "Resuelto",
  "ok": "OK",
  "guest_cta_title": "Crea una cuenta",
  "guest_cta_body": "Regístrate primero para empezar la verificación como coach.",

  // Breakout (Wave 1 · client parity)
  "breakout": "Breakout",
  "breakout_tab_sub": "Un camino guiado del sentimiento al alivio.",
  "breakout_start_session": "Iniciar sesión",
  "breakout_start_sub": "Elige una emoción, comparte el contexto, respira.",
  "breakout_how_it_works": "Cómo funciona",
  "breakout_step1": "Nombra la emoción",
  "breakout_step2": "Comparte la situación",
  "breakout_step3": "Puntúa la intensidad 1–10",
  "breakout_step4": "Recibe una técnica adecuada",
  "breakout_step5": "Respira con la guía",
  "breakout_step6": "Puntúa la intensidad de nuevo",
  "breakout_step7": "Guardar y revisar",
  "what_feeling": "¿Qué estás sintiendo?",
  "base_situation": "¿Cuál es la situación base?",
  "base_situation_hint": "¿Dónde vive esta emoción?",
  "bs_work": "Trabajo",
  "bs_private": "Privado",
  "bs_public": "Público",
  "bs_togetherness": "Convivencia",
  "bs_family": "Familia",
  "bs_health": "Salud",
  "bs_financial": "Finanzas",
  "bs_learning": "Aprendizaje",
  "bs_other": "Otro",
  "how_intense": "¿Qué tan intenso es?",
  "intensity_scale_hint": "1 = apenas · 10 = abrumador",
  "situation_belief_after_hint": "La situación y la creencia se preguntarán después de respirar para que empieces rápido.",
  "try_technique": "Prueba {name}",
  "how_it_works_row": "Cómo funciona",
  "expected": "Esperado",
  "duration": "Duración",
  "caution": "Precaución",
  "min": "min",
  "begin_breathing": "Comenzar a respirar",
  "step_of": "Paso {n} de {total}",

  // Share Cards (Wave 1 · client parity)
  "share_cards_title": "Tarjetas para compartir",
  "sc_tab_all": "Todas las tarjetas",
  "sc_tab_sent": "Enviadas",
  "sc_filter_all": "Todas",
  "sc_filter_client": "Tarjetas cliente",
  "sc_filter_coach": "Tarjetas coach",
  "sc_empty_filter": "No hay tarjetas en este filtro.",
  "sc_empty_sent_head": "Aún no has compartido ninguna tarjeta",
  "sc_empty_sent_body": "Cuando compartas una tarjeta, aparecerá aquí.",
  "sc_browse": "Ver tarjetas",
  "sc_share_moment": "Comparte tu momento",
  "sc_share_details": "Compartir más detalles (emoción, intensidad)",
  "sc_your_link": "Tu enlace personal",
  "sc_copy": "Copiar",
  "sc_copied": "Enlace copiado",
  "sc_step1": "Pulsa «Copiar enlace»",
  "sc_step2": "Comparte la tarjeta en tu canal",
  "sc_step3": "Pega el enlace copiado en la descripción",
  "sc_steps_note": "Solo con tu enlace ganas en el programa de afiliados.",
  "sc_download": "Descargar",
  "sc_share": "Compartir",
  "sc_fine": "Cuando alguien pulse tu enlace, llegará automáticamente a la landing de la fase activa.",
  "nav.share_cards": "Tarjetas",

  // Story Wall (Wave 1 · client parity)
  "story_wall_coach_title": "Story Wall",
  "story_wall_coach_sub": "Comparte momentos del camino de tus clientes — solo con doble consentimiento.",
  "story_wall_coach_empty": "Sin momentos aún.",
  "story_wall_coach_empty_cta": "Captura tu primer momento",
  "story_wall_create_title": "Capturar un momento",
  "story_wall_client_lbl": "Cliente",
  "story_wall_kind_lbl": "Tipo",
  "story_wall_kind_reflection": "Reflexión",
  "story_wall_kind_wellbeing_shift": "Bienestar",
  "story_wall_kind_streak": "Racha",
  "story_wall_kind_quote": "Cita",
  "story_wall_kind_milestone": "Hito",
  "story_wall_title_lbl": "Título",
  "story_wall_title_ph": "Titular breve — p. ej. \\\"De 8 a 3\\\"",
  "story_wall_body_lbl": "Descripción",
  "story_wall_body_ph": "¿Qué pasó? Que sea cálido, específico y respetuoso.",
  "story_wall_metric_lbl": "Métrica (opcional)",
  "story_wall_metric_ph": "p. ej. \\\"8 → 3\\\" o \\\"30 días\\\"",
  "story_wall_color_lbl": "Color de acento",
  "story_wall_double_consent_note": "Después de guardar, tu cliente debe confirmar el texto exacto. Solo entonces podrás publicar.",
  "story_wall_missing_fields": "Elige un/a cliente y escribe título + descripción.",
  "story_wall_draft_save": "Guardar borrador",
  "story_wall_publish": "Publicar",
  "story_wall_unpublish": "Retirar del muro",
  "story_wall_archive": "Eliminar",
  "story_wall_archive_confirm_title": "¿Eliminar este momento?",
  "story_wall_archive_confirm_body": "El registro se archiva y ya no aparece en el Story Wall.",
  "story_wall_status_draft": "Borrador",
  "story_wall_status_published": "En vivo",
  "story_wall_status_unlisted": "No listado",
  "story_wall_review": "Editar",
  "story_wall_review_and_agree": "Dar consentimiento",
  "story_wall_coach_consent_lbl": "Tu consentimiento",
  "story_wall_client_consent_lbl": "Consentimiento del/la cliente",
  "story_wall_consent_pending": "Pendiente",
  "story_wall_consent_granted": "Concedido",
  "story_wall_consent_waiting_client": "Esperando al/la cliente",
  "story_wall_consent_grant": "Sí, publicar",
  "story_wall_consent_revoke": "Revocar",
  "story_wall_coach_consent_title": "Tu consentimiento",
  "story_wall_coach_consent_body": "Confirma que este texto puede ser público. Puedes revocar tu consentimiento en cualquier momento.",
  "story_wall_show_name_lbl": "Mostrar mi nombre",
  "story_wall_show_name_coach_sub": "Por defecto: tu nombre queda privado.",
  "story_wall_show_name_client_sub": "Por defecto: solo se muestra tu inicial.",
  "story_wall_publish_needs_consents": "Espera a que ambas partes acepten.",
  "story_wall_client_title": "Momentos esperando tu OK",
  "story_wall_client_sub": "Tu coach quiere compartir estos momentos. Solo se publican con tu consentimiento.",
  "story_wall_client_empty": "Sin momentos pendientes.",
  "story_wall_client_consent_title": "¿Estás de acuerdo?",
  "story_wall_client_consent_sub": "Revisa el texto exacto abajo. Nada se hace público sin tu OK.",
  "story_wall_client_consent_thanks_title": "Gracias 🌿",
  "story_wall_client_consent_thanks_body": "Tu coach recibirá aviso y podrá publicar.",
  "story_wall_privacy_note": "Solo guardamos lo que aparece arriba. Puedes revocar tu consentimiento en cualquier momento — el momento desaparece de inmediato.",
  "story_wall_grant": "Acepto",
  "story_wall_decline": "Rechazar",
  "story_wall_by_coach": "por {name}",
  "story_wall_by_coach_anonymous": "por un/a coach",
  "story_wall_browse_public": "Ver el muro público",
  "story_wall_public_title": "Story Wall",
  "story_wall_public_sub": "Momentos reales de la comunidad my-within — compartidos con el consentimiento de todos.",
  "story_wall_public_empty": "Aún sin momentos públicos.",
  "story_wall_filter_all": "Todos",
  "story_wall_moment_title": "Momento",
  "story_wall_moment_missing_title": "Momento no encontrado",
  "story_wall_moment_missing_body": "Este momento ya no es público o fue revocado.",
  "story_wall_share_title": "Compartir este momento",
  "story_wall_share_body": "Acabo de descubrir este momento en my-within: {title}",
  "story_wall_share_copied": "Enlace copiado",
  "story_wall_share_copied_body": "El enlace está ahora en tu portapapeles.",
  "story_wall_share_cta": "Compartir",
  "story_wall_share_open_card": "Abrir fact-card",

  // Story Mode (Wave 1 · client parity)
  "nav.story_wall": "Muro de historias",
  "nav.story_mode": "Modo historia",
  "sm_title": "Modo historia",
  "sm_cover_eyebrow": "Una memoria privada de tus meses aquí",
  "sm_cover_title": "Los capítulos que has guardado.",
  "sm_cover_meta": "{entries} entradas en {days} días · {chapters} capítulos",
  "sm_cover_body": "Este es el espacio donde viven tus palabras. Nada aquí se comparte con tu coach: esta cronología es solo para ti. Desplázate despacio. Léete como un libro.",
  "sm_empty_title": "Aún nada que relatar.",
  "sm_empty_body": "Unas entradas de diario, una o dos prácticas, y el primer capítulo empieza a escribirse solo. Vuelve en una o dos semanas.",
  "sm_chapter": "Capítulo {n}",
  "sm_kind_journal": "Diario",
  "sm_kind_practice": "Práctica",
  "sm_kind_breakout": "Breakout",
  "sm_kind_booking": "Sesión",
  "sm_mood": "ánimo {a} → {b}",
  "sm_intensity": "intensidad {a} → {b}",
  "sm_download_pdf": "Descargar como PDF",
  "sm_footer_note": "Tu historia se queda contigo. El PDF es privado y se descarga en este dispositivo.",

  // Welle 2 · Client-Extras (Collections · Focus-Timer · Connected-Breath · Method-Player · Unlocked)
  "collections_title": "Mis colecciones",
  "collections_empty_title": "Aún no hay colecciones",
  "collections_empty_sub": "Toca el marcador en cualquier publicación para empezar.",
  "collections_n_posts": "{n} publicaciones",
  "collections_public": "Público",
  "collections_private": "Privado",
  "collections_not_found": "Esta colección ya no existe.",
  "collections_now_private": "De nuevo privada",
  "collections_now_private_body": "El enlace ya no funciona.",
  "collections_now_public": "Colección pública",
  "collections_now_public_body": "Cualquiera con el enlace puede verla.",
  "collections_share_msg": "Mira mi colección « {name} » en My Within: {url}",
  "collections_share_again": "Compartir enlace",
  "collections_edit_title": "Editar colección",
  "collections_field_name": "Nombre",
  "collections_field_description": "Descripción",
  "collections_field_description_ph": "¿De qué trata esta colección?",
  "collections_field_emoji": "Emoji",
  "collections_field_color": "Color",
  "collections_empty_folder": "Esta colección está vacía — guarda publicaciones para llenarla.",
  "collections_paid_tag": "De pago",
  "action_failed": "Acción fallida",
  "post_untitled": "Sin título",
  "focus_timer_title": "Temporizador Deep Work",
  "focus_timer_preset_classic": "Clásico",
  "focus_timer_preset_sprint": "Sprint",
  "focus_timer_preset_extended": "Extendido",
  "focus_timer_phase_focus": "Foco",
  "focus_timer_phase_breathing": "Respira",
  "focus_timer_phase_break": "Descanso",
  "focus_timer_phase_done": "Hecho",
  "focus_timer_phase_ready": "Listo",
  "focus_timer_hint_breathing": "Respiración cuadrada 4-4-4-4 · reinicia tu sistema nervioso.",
  "focus_timer_hint_break": "Levántate, mira a lo lejos, bebe agua.",
  "focus_timer_hint_focus": "Foco profundo — silencia notificaciones y adelante.",
  "focus_timer_hint_done": "Bien hecho — {n} sprint(s) completado(s).",
  "focus_timer_hint_ready": "Elige un preset y empieza — una pausa de respiración va tras cada sprint.",
  "focus_timer_completed_sprints": "{n} sprint(s) completado(s)",
  "focus_timer_start": "Empezar",
  "focus_timer_start_next": "Siguiente sprint",
  "focus_timer_finish": "Finalizar",
  "focus_timer_pause": "Pausar",
  "focus_timer_resume": "Reanudar",
  "focus_timer_reset": "Reiniciar",
  "focus_timer_tip": "Consejo: pon el teléfono boca abajo. La pantalla queda encendida para seguir el ritmo durante la pausa de respiración.",
  "breath_inhale": "Inhala",
  "breath_exhale": "Exhala",
  "breath_hold_in": "Retén",
  "breath_hold_out": "Descansa",
  "connected_intro_title": "Respiración conectada",
  "connected_intro_body": "Una práctica de liberación profunda — lee esto por completo antes de intentarla.",
  "connected_what_it_is": "Qué es",
  "connected_what_body": "Una respiración continua y circular — sin pausas entre inhalación y exhalación — mantenida durante 30–60 minutos. A menudo por la boca, tumbado.",
  "connected_how_works": "Cómo funciona",
  "connected_how_body": "El patrón sostenido altera la química sanguínea y reduce la vigilancia mental. Emociones, recuerdos y estados corporales retenidos pueden aflorar.",
  "connected_benefits": "Lo que puede ofrecer",
  "connected_benefits_body": "Liberación emocional, comprensión, una sensación de integración, a veces un estado muy expandido. Es una práctica potente — trátala con respeto.",
  "connected_safety": "Sólo con acompañamiento experimentado",
  "connected_safety_body": "Esta no es una práctica en solitario. No la intentes solo — ni conduciendo, ni en el agua, ni con medicación que afecte al sistema nervioso, ni durante el embarazo, ni con afecciones cardíacas o pulmonares graves, ni con traumas no tratados. Siempre practica con acompañamiento formado que sostenga el espacio, detecte la desregulación y acompañe la integración.",
  "connected_facilitator_only": "Sin reproductor en la app — a propósito.",
  "connected_close": "Entendido",
  "mp_load_failed": "Error al cargar",
  "mp_by": "por",
  "mp_auto_chain": "Avance automático",
  "mp_start": "Comenzar",
  "mp_pause": "Pausar",
  "mp_next_in": "Siguiente en",
  "mp_next_step": "Siguiente bloque",
  "mp_finish": "Listo · dejar comentarios",
  "mp_chain_cancel": "Detener avance automático",
  "mp_disclaimer": "Este ejercicio es una oferta de coaching y no reemplaza un diagnóstico médico o psicoterapia. En caso de malestar agudo, por favor consulta a un profesional.",
  "mp_fb_title": "¿Cómo estuvo la sesión?",
  "mp_fb_sub": "Tu coach verá tu respuesta breve.",
  "mp_fb_note_ph": "Opcional: ¿qué se sintió particularmente bien?",
  "mp_fb_skip": "Omitir",
  "mp_fb_send": "Enviar",
  "cm_q_required": "Obligatorio",
  "unlocked_title": "Desbloqueados",
  "unlocked_sub": "Tus métodos comprados y regalados",
  "unlocked_empty": "Aún no hay nada desbloqueado. Cuando tu coach te regale un método o compres uno, aparecerá aquí.",
  "unlock_src_gift": "Regalo",
  "unlock_src_paid": "Comprado",
  "unlock_src_public": "Público",
  "unlocked_posts_title": "Mis publicaciones desbloqueadas",
  "unlocked_posts_sub": "Publicaciones de pago de tus coaches",
  "unlocked_posts_empty_title": "Aún no hay publicaciones desbloqueadas",
  "unlocked_posts_empty_body": "Cuando desbloquees una publicación de pago en el feed, aparecerá aquí.",
  "unlocked_posts_go_feed": "Abrir feed",
  "nav.collections": "Colecciones",
  "nav.focus_timer": "Temporizador de enfoque",
  "nav.connected_breath": "Respiración conectada",
  "nav.unlocked_methods": "Desbloqueadas",
  "nav.unlocked_posts": "Posts desbloqueados",

  // Welle 2 · Methoden-Kind-Labels (Method-Player / Unlocked)
  "method_kind_audio": "Audio",
  "method_kind_video": "Vídeo",
  "method_kind_breathwork": "Respiración",
  "method_kind_questions": "Preguntas",
  "method_kind_combo": "Combo",
  "method_kind_body_scan": "Escaneo corporal",
  "method_kind_gratitude": "Gratitud",
  "method_kind_visualization": "Visualización",
  "method_kind_movement": "Movimiento",
  "method_kind_check_in": "Check-In",
  "method_kind_journal": "Diario",

  // Welle 3 · Collab-Marketplace + Snapshot-Anfragen + Blockierte Nutzer
  "client_collab_title": "Área Collab",
  "client_collab_subtitle": "Todo sobre tus colaboraciones con coaches",
  "client_collab_tile_chats_title": "Mis Chats Collab",
  "client_collab_tile_chats_sub": "Todos los chats en curso con coaches",
  "client_collab_tile_offerings_title": "Comprar ofertas Collab",
  "client_collab_tile_offerings_sub": "Descubre duos y grupos de coaches",
  "client_collab_tile_projects_title": "Mis proyectos activos",
  "client_collab_tile_projects_sub": "Ofertas y círculos en los que participas",
  "client_collab_tile_discover_title": "Descubrir Coaches Collab",
  "client_collab_tile_discover_sub": "Parejas de coaches con ofertas conjuntas",
  "client_collab_tile_reviews_title": "Mis reseñas",
  "client_collab_tile_reviews_sub": "Evalúa proyectos completados",
  "client_collab_discover_title": "Descubrir Coaches Collab",
  "client_collab_discover_sub": "Parejas y grupos con ofertas conjuntas",
  "client_collab_discover_empty": "Sin parejas de coaches con ofertas Collab.",
  "client_collab_discover_offerings": "Ofertas conjuntas",
  "client_collab_discover_circles": "Círculos Collab",
  "starter_card_eyebrow": "¿Primera vez? Prueba",
  "starter_card_eyebrow_matched": "Encaja con tu emoción más sentida · {emotion}",
  "starter_card_a11y": "Probar un paquete collab de muestra",
  "client_collab_offerings_title": "Comprar ofertas Collab",
  "client_collab_offerings_sub": "Duos y grupos de coaches para reservar",
  "client_collab_offerings_empty": "Sin ofertas Collab disponibles.",
  "client_collab_included_unlimited": "Ilimitado",
  "client_collab_included_msgs": "mens.",
  "client_collab_included_calls": "Llamadas",
  "client_collab_included_live": "Live",
  "client_collab_already_bought": "Comprado",
  "client_collab_buy_cta": "Comprar",
  "client_collab_purchase_confirm_title": "Confirmar compra",
  "client_collab_purchase_confirm_body": "¿{title} por {price}?",
  "client_collab_pay_credits": "Pagar con {n} créditos",
  "client_collab_purchase_success_title": "¡Comprado!",
  "client_collab_purchase_success_body": "Ya puedes chatear con {coaches}.",
  "client_collab_purchase_fail_body": "Compra fallida.",
  "client_collab_purchase_credits_short": "Necesitas {need} créditos, tienes {have}.",
  "client_collab_projects_title": "Mis proyectos activos",
  "client_collab_projects_sub": "Ofertas y círculos en los que participas",
  "client_collab_projects_empty": "Sin proyectos Collab activos.",
  "client_collab_kind_circle": "Círculo",
  "client_collab_kind_offering": "Oferta",
  "client_collab_kind_shared": "Multi",
  "client_collab_reviews_title": "Mis reseñas Collab",
  "client_collab_reviews_sub": "Una reseña por coach por proyecto",
  "client_collab_reviews_empty": "Sin proyectos completados para evaluar.",
  "client_collab_review_add": "Evaluar",
  "client_collab_review_saved": "Reseña guardada",
  "client_collab_review_editor_title": "Evaluar a {coach}",
  "client_collab_review_comment_ph": "Unas palabras (opcional)…",
  "client_collab_review_submit": "Guardar reseña",
  "client_collab_chats_title": "Mis Chats Collab",
  "client_collab_chats_sub": "Todos los chats con tus coaches",
  "client_collab_chats_empty": "Aún no hay chats Collab. Compra una oferta Collab para comenzar.",
  "client_collab_no_messages": "Aún sin mensajes",
  "client_collab_project_not_found": "Proyecto no encontrado",
  "client_collab_project_coaches": "Tus coaches",
  "client_collab_project_about": "Acerca de",
  "client_collab_project_chat": "Chat",
  "client_collab_project_open_chat": "Abrir chat con tus coaches",
  "client_collab_project_chat_soon": "El chat estará disponible tras la primera actividad.",
  "client_collab_project_sessions": "Sesiones",
  "client_collab_project_sessions_empty": "Sin sesiones programadas.",
  "client_collab_project_documents": "Materiales",
  "client_collab_project_documents_empty": "Sin materiales compartidos.",
  "client_collab_project_tasks": "Tareas",
  "client_collab_project_tasks_empty": "Sin tareas pendientes.",
  "session": "Sesión",
  "week": "semana",
  "month": "mes",
  "total": "total",
  "document": "Documento",
  "open_report": "Abrir informe",
  "snapshot_requests_inbox": "Solicitudes de snapshot",
  "snapshot_requests_none": "No tienes solicitudes ahora mismo.",
  "snapshot_requests_from": "De {coach}",
  "snapshot_requests_period": "Últimos {days} días",
  "snapshot_requests_approve": "Aprobar y compartir",
  "snapshot_requests_decline": "Rechazar",
  "snapshot_requests_help": "Al aprobar se genera un nuevo informe WEVA de los últimos {days} días y se comparte solo con este coach.",
  "snapshot_requests_status_pending": "Pendiente",
  "snapshot_requests_status_approved": "Compartido",
  "snapshot_requests_status_approved_no_data": "Aprobado (sin datos)",
  "snapshot_requests_status_declined": "Rechazado",
  "snapshot_approved_toast": "Snapshot compartido con tu coach ✨",
  "snapshot_declined_toast": "Rechazado — nada compartido.",
  "snapshot_no_data_msg": "No hay datos en el período seleccionado. Practica algo primero y vuelve a aprobar.",
  "popup_approve_failed": "Error al aprobar",
  "blocked_at": "Bloqueado el",
  "unblock_cta": "Desbloquear",
  "nav.snapshot_requests": "Solicitudes de snapshot",
  "nav.blocked_users": "Usuarios bloqueados",
  "circle_news_just_now": "justo ahora",
  "nav.collab_area": "Área colaborativa",
  "discover_strip_title": "Explorar",
  "discover_strip_sub": "Nuevos extras para ti",
  "discover_strip_new": "Nuevo",

  "nav.assistant": "Asistente de Práctica IA",
  "support": "Soporte",
  "aipa.title": "Asistente de Práctica IA",
  "aipa.subtitle": "Tu asistente proactivo para el día a día.",
  "aipa.upsell_headline": "Más tiempo para tus clientes",
  "aipa.upsell_sub": "Tu asistente de IA prepara un resumen cada mañana, prioriza tareas, redacta mensajes y automatiza rutinas — tú mantienes el control.",
  "aipa.feature_briefing": "Resumen diario",
  "aipa.feature_briefing_desc": "Cada mañana una visión clara de clientes, citas y prioridades.",
  "aipa.feature_tasks": "Gestor de tareas",
  "aipa.feature_tasks_desc": "Prioriza, delega en la IA y sigue tu historial.",
  "aipa.feature_chat": "Chat del asistente",
  "aipa.feature_chat_desc": "Pregunta sobre tu práctica y recibe respuestas concretas.",
  "aipa.feature_workflows": "Flujos automáticos",
  "aipa.feature_workflows_desc": "El asistente se encarga de las rutinas recurrentes — con tu aprobación.",
  "aipa.price_line": "{price} € / mes",
  "aipa.trial_note": "7 días gratis · cancela cuando quieras",
  "aipa.start_trial": "Empezar prueba de 7 días",
  "aipa.start_sub": "Suscribirse ahora",
  "aipa.starting": "Redirigiendo al pago…",
  "aipa.consent_hint": "Después 20 €/mes, se renueva automáticamente hasta la cancelación.",
  "aipa.checkout_error": "No se pudo iniciar ahora. Inténtalo de nuevo.",
  "aipa.status_trial": "Prueba",
  "aipa.status_active": "Activo",
  "aipa.status_canceled": "Cancelado",
  "auth.cb_success": "¡Sesión iniciada correctamente!",
  "auth.cb_failed": "Error al iniciar sesión con Google. Inténtalo de nuevo.",
  "auth.cb_completing": "Completando el inicio de sesión …",
  "nf.meta": "Página no encontrada",
  "nf.title": "Esta página no existe.",
  "nf.body": "Quizá encuentres lo que buscas en nuestro marketplace.",
  "nf.home": "Inicio",
  "aipa.card_ready": "Tu asistente está listo. Ábrelo para ver el briefing de hoy.",
  "aipa.card_open_tasks": "Tareas abiertas",
  "aipa.card_needs_attention": "Necesita atención",
  "aipa.card_to_approve": "Para aprobar",
  "aipa.card_setup_step": "Solo un paso más: configura tu asistente para que prepare cada mañana por ti.",
  "aipa.card_pitch": "Tu asistente proactivo: briefing diario, tareas, seguimientos automáticos y recordatorios: tú mantienes el control.",
  "aipa.card_try_free": "Prueba 7 días gratis",
  "notif.seo": "Notificaciones",
  "ads.seo": "Coach · Publicidad",
  "an.seo": "Coach · Analíticas",
  "bk.seo": "Coach · Reservas",
  "cd.seo": "Coach · Cliente",
  "win.seo": "Coach · Logros de clientes",
  "cc.seo": "Coach · Círculos",
  "cs.seo": "Coach · Configuración",
  "col2.seo": "Coach · Colectivos",
  "cf.seo": "Coach · Consentimientos",
  "soc.seo": "Coach · Social",
  "help.seo": "Coach · Ayuda",
  "ici.seo": "Coach · Invitaciones al Inner Circle",
  "cm.seo": "Coach · Métodos",
  "off.seo": "Coach · Ofertas",
  "pl.seo": "Coach · Planes",
  "pon.seo": "Coach · Perfil profesional",
  "prof.seo": "Coach · Perfil",
  "recs.seo": "Coach · Recomendaciones",
  "ref.seo": "Coach · Recomendar",
  "cset.seo": "Coach · Ajustes",
  "sup.seo": "Coach · Soporte",
  "tour.seo": "Coach · Recorrido",
  "upg.seo": "Coach · Mejora",
  "verify.seo": "Coach · Verificación",
  "aipa.seo": "Coach · Asistente de práctica IA",
  "cbr.seo": "Coach · Marca",
  "chk.seo": "Coach · Plantilla de check-in",
  "cred.seo": "Coach · Créditos",
  "refpol.seo": "Coach · Cancelación y reembolso",
  "resch.seo": "Coach · Reprogramaciones",
  "wdig.seo": "Coach · Resumen semanal",
  "common.copied": "Copiado",
  "open": "Abrir",
  "ads.topup_custom_ph": "p. ej. 75",
  "ads.ph_themes": "breathwork, límites…",
  "ads.ph_regions": "EU, DE-Berlin…",
  "ads.ph_education_backgrounds": "Formación de coach…",
  "ads.ph_life_situations": "Autónomos, padres jóvenes…",
  "ads.ph_other_traits": "Madrugadores, TDAH…",
  "aipa.renews_on": "Se renueva el {date}",
  "aipa.trial_until": "Prueba hasta {date}",
  "aipa.canceled_until": "Activo hasta {date}",
  "aipa.wizard_title": "Configurar asistente",
  "aipa.wizard_intro": "En pocos pasos tu asistente estará listo.",
  "aipa.step_label": "Paso {n} de {total}",
  "aipa.step_language": "Idioma",
  "aipa.step_language_desc": "¿En qué idioma debe escribir el asistente?",
  "aipa.lang_label": "Idioma del asistente",
  "aipa.step_briefing": "Resumen diario",
  "aipa.step_briefing_desc": "¿Cuándo debe estar listo tu resumen?",
  "aipa.briefing_time": "Hora del resumen",
  "aipa.show_on_login": "Mostrar resumen al iniciar sesión",
  "aipa.step_autonomy": "Autonomía",
  "aipa.step_autonomy_desc": "Decide qué puede hacer el asistente por sí mismo y qué confirmas tú.",
  "aipa.step_workflows": "Flujos",
  "aipa.step_workflows_desc": "Activa las rutinas que quieras que te ayuden.",
  "aipa.step_outlook": "Outlook",
  "aipa.step_outlook_desc": "Conecta calendario y correo (opcional).",
  "aipa.outlook_calendar": "Calendario de Outlook",
  "aipa.outlook_mail": "Correo de Outlook",
  "aipa.outlook_not_connected": "Aún no conectado — mientras tanto el asistente usa los datos de tu app.",
  "aipa.step_groups": "Filtro de grupos",
  "aipa.step_groups_desc": "¿En qué círculos debe centrarse el asistente? Vacío = todos.",
  "aipa.groups_all": "Todos los círculos",
  "aipa.groups_empty": "Aún no hay círculos.",
  "aipa.back": "Atrás",
  "aipa.next": "Siguiente",
  "aipa.finish_setup": "Finalizar configuración",
  "aipa.saving": "Guardando…",
  "aipa.setup_done_toast": "¡Tu asistente está listo!",
  "aipa.lvl_confirm": "Confirmar",
  "aipa.lvl_auto": "Automático",
  "aipa.lvl_never": "Nunca",
  "aipa.auto.message_clients": "Escribir a clientes",
  "aipa.auto.appointment_reminders": "Recordatorios de citas",
  "aipa.auto.outlook_events": "Crear eventos de Outlook",
  "aipa.auto.weekly_plan_reminders": "Recordatorios del plan semanal",
  "aipa.auto.post_drafts": "Borradores de publicaciones",
  "aipa.auto.mail_replies": "Respuestas de correo",
  "aipa.auto.auto_tasks": "Crear tareas automáticamente",
  "aipa.wf.daily_briefing": "Resumen diario",
  "aipa.wf.weekly_summary": "Resumen semanal",
  "aipa.wf.weekly_plan_reminder": "Recordatorio del plan semanal",
  "aipa.wf.birthday_greetings": "Felicitaciones de cumpleaños",
  "aipa.wf.session_followup": "Seguimiento de sesión",
  "aipa.wf.inactive_clients": "Clientes inactivos",
  "aipa.wf.post_draft_on_theme": "Borrador de publicación por temas",
  "aipa.wf.appointment_confirmations": "Confirmaciones de citas",
  "aipa.wf.mail_reply_drafts": "Borradores de respuesta de correo",
  "aipa.tab_briefing": "Resumen",
  "aipa.tab_tasks": "Tareas",
  "aipa.tab_agenda": "Agenda",
  "aipa.tab_chat": "Chat",
  "aipa.tab_settings": "Ajustes",
  "aipa.briefing_title": "Tu resumen diario",
  "aipa.briefing_generate": "Crear resumen",
  "aipa.briefing_generating": "Creando resumen…",
  "aipa.briefing_regenerate": "Volver a crear",
  "aipa.briefing_empty": "Aún no hay resumen de hoy. Crea el primero ahora.",
  "aipa.briefing_clients": "Clientes",
  "aipa.briefing_attention": "Necesita atención",
  "aipa.briefing_calendar": "Calendario",
  "aipa.briefing_tasks": "Tareas",
  "aipa.briefing_comm": "Sugerencias de comunicación",
  "aipa.briefing_posts": "Ideas de publicaciones",
  "aipa.briefing_add_task": "Como tarea",
  "aipa.copy": "Copiar",
  "aipa.copied": "Copiado",
  "aipa.generated_at": "Creado {date}",
  "aipa.tasks_title": "Tareas",
  "aipa.tasks_empty": "No hay tareas abiertas. ¡Bien hecho!",
  "aipa.task_title_ph": "Nueva tarea…",
  "aipa.task_desc_ph": "Descripción (opcional)",
  "aipa.task_priority": "Prioridad",
  "aipa.task_add": "Añadir",
  "aipa.task_adding": "Añadiendo…",
  "aipa.prio.urgent": "Urgente",
  "aipa.prio.important": "Importante",
  "aipa.prio.normal": "Normal",
  "aipa.prio.later": "Más tarde",
  "aipa.task_done": "Hecho",
  "aipa.task_delegate": "Delegar en la IA",
  "aipa.task_delegating": "Delegando…",
  "aipa.task_delete": "Eliminar",
  "aipa.task_ai_result": "Resultado de la IA",
  "aipa.task_history": "Mostrar historial",
  "aipa.task_history_hide": "Ocultar historial",
  "aipa.task_export": "Exportar CSV",
  "aipa.agenda_title": "Agenda de hoy",
  "aipa.agenda_events": "Citas",
  "aipa.agenda_no_events": "No hay citas hoy.",
  "aipa.agenda_recurring": "Recurrente",
  "aipa.agenda_recurring_empty": "Aún no hay entradas recurrentes.",
  "aipa.agenda_outlook_on": "Outlook conectado",
  "aipa.agenda_outlook_off": "Outlook no conectado",
  "aipa.recurring_add": "Añadir entrada",
  "aipa.recurring_title_ph": "Título (p. ej. llamada de equipo)",
  "aipa.recurring_time": "Hora",
  "aipa.recurring_save": "Guardar",
  "aipa.wd.0": "Lun",
  "aipa.wd.1": "Mar",
  "aipa.wd.2": "Mié",
  "aipa.wd.3": "Jue",
  "aipa.wd.4": "Vie",
  "aipa.wd.5": "Sáb",
  "aipa.wd.6": "Dom",
  "aipa.chat_title": "Chat del asistente",
  "aipa.chat_ph": "Pregunta a tu asistente…",
  "aipa.chat_send": "Enviar",
  "aipa.chat_empty": "Haz una pregunta sobre tu práctica.",
  "aipa.chat_clear": "Borrar historial",
  "aipa.chat_thinking": "Pensando…",
  "aipa.settings_title": "Ajustes",
  "aipa.settings_saved": "Ajustes guardados.",
  "aipa.save": "Guardar",
  "aipa.cancel_package": "Cancelar paquete",
  "aipa.cancel_confirm": "¿Seguro que quieres cancelar el paquete? Mantienes el acceso hasta el final del periodo.",
  "aipa.canceling": "Cancelando…",
  "aipa.cancel_done": "Paquete cancelado.",
  "aipa.tab_automation": "Automatización",
  "aipa.automation_title": "Flujos autónomos",
  "aipa.automation_desc": "El asistente ejecuta tus rutinas activadas. Las acciones en «Automático» se ejecutan sin preguntar; «Confirmar» crea una tarea para tu aprobación.",
  "aipa.run_now": "Ejecutar ahora",
  "aipa.running": "Ejecutando…",
  "aipa.run_done": "{auto} automáticas · {pending} por aprobar",
  "aipa.activity_title": "Actividad reciente",
  "aipa.activity_empty": "Aún no hay actividad. Activa flujos en los ajustes y ejecútalos aquí.",
  "aipa.mode_auto": "Automático",
  "aipa.mode_pending": "Por aprobar",
  "guide.ui.step": "Paso {x} de {y}",
  "guide.ui.next": "Siguiente",
  "guide.ui.done": "Listo",
  "guide.ui.later": "Más tarde",
  "guide.ui.not_now": "Ahora no",
  "guide.ui.close": "Cerrar",
  "guide.bar.title": "Tus inicios como coach",
  "guide.bar.subtitle": "Unos pasos cálidos y todo estará listo.",
  "guide.bar.progress": "{done} de {total} completados",
  "guide.bar.hide": "Ocultar por ahora",
  "guide.bar.reopen": "Guía de configuración",
  "guide.status.done": "Completado",
  "guide.status.skipped": "Omitido",
  "guide.status.open": "Pendiente",
  "guide.complete.title": "¡Todo listo, maravilloso!",
  "guide.complete.body": "Has completado tu camino inicial. Tu espacio está listo para acoger y acompañar a las personas en su proceso. Qué bueno tenerte aquí.",
  "guide.complete.cta": "Vamos",
  "guide.theme.profile.label": "Perfil",
  "guide.theme.offering.label": "Oferta",
  "guide.theme.circle.label": "Círculo",
  "guide.theme.availability.label": "Disponibilidad",
  "guide.theme.payments.label": "Pagos",
  "guide.theme.post.label": "Publicación",
  "guide.theme.method.label": "Método",
  "guide.theme.weekly_plan.label": "Plan semanal",
  "guide.theme.calendar.label": "Calendario",
  "guide.theme.discover.label": "Descubrir",
  "guide.theme.profile.title": "Muéstrate — tu perfil",
  "guide.theme.profile.cta": "Ir al perfil",
  "guide.theme.profile.step1": "Empecemos por ti. Este es tu perfil personal — la primera impresión para quienes te encuentran.",
  "guide.theme.profile.step2": "Sube una foto cálida de ti. Una cara real genera confianza al instante.",
  "guide.theme.profile.step3": "Escribe tu nombre — como te gusta que te llamen.",
  "guide.theme.profile.step4": "Cuenta en unas frases quién eres y qué te mueve. Sin tecnicismos.",
  "guide.theme.profile.step5": "Guarda tu perfil — ¡listo! Puedes cambiarlo cuando quieras.",
  "guide.theme.offering.title": "Tu primera oferta",
  "guide.theme.offering.cta": "Ir a las ofertas",
  "guide.theme.offering.step1": "Aquí defines cómo acompañas a las personas — por ejemplo, una sesión individual o un pequeño paquete.",
  "guide.theme.offering.step2": "Crea una oferta que vaya contigo. En cuanto la guardes, marcamos este paso por ti.",
  "guide.theme.circle.title": "Tu propio círculo",
  "guide.theme.circle.cta": "Ir a los círculos",
  "guide.theme.circle.step1": "Un círculo es tu espacio de comunidad — donde se reúnen las personas que acompañas.",
  "guide.theme.circle.step2": "Crea tu primer círculo. Tú decides cuán abierto o protegido será.",
  "guide.theme.availability.title": "Tus horarios",
  "guide.theme.availability.cta": "Ir a disponibilidad",
  "guide.theme.availability.step1": "Para que las personas puedan reservar contigo, indica aquí tus horarios.",
  "guide.theme.availability.step2": "Indica cuándo estás disponible para sesiones. En cuanto guardes, este paso estará listo.",
  "guide.theme.payments.title": "Configurar pagos",
  "guide.theme.payments.cta": "Conectar Stripe",
  "guide.theme.payments.step1": "Para que tus honorarios lleguen a ti de forma segura, conectamos tu cuenta con nuestro socio de pagos.",
  "guide.theme.payments.step2": "Conéctate de forma segura con Stripe. Solo tarda unos minutos — te guiamos paso a paso.",
  "guide.theme.post.title": "Tu primera publicación",
  "guide.theme.post.cta": "Ir al feed",
  "guide.theme.post.step1": "Una publicación muestra lo que te mueve — un pensamiento, una invitación, una chispa.",
  "guide.theme.post.step2": "Comparte tu primera publicación. En cuanto se publique, marcamos este paso.",
  "guide.theme.method.title": "Tu método",
  "guide.theme.method.cta": "Ir a los métodos",
  "guide.theme.method.step1": "Un método es un pequeño ejercicio o guía que compartes con las personas.",
  "guide.theme.method.step2": "Crea tu primer método. Se marca automáticamente en cuanto lo guardas.",
  "guide.theme.weekly_plan.title": "Un plan semanal",
  "guide.theme.weekly_plan.cta": "Ir a los planes semanales",
  "guide.theme.weekly_plan.step1": "Con un plan semanal acompañas a las personas día a día — con suavidad y estructura.",
  "guide.theme.weekly_plan.step2": "Crea un plan y asígnalo a alguien. Entonces este paso estará listo.",
  "guide.theme.calendar.title": "Tu calendario",
  "guide.theme.calendar.cta": "Conectar calendario",
  "guide.theme.calendar.step1": "Conecta tu calendario de Outlook para que las citas encajen automáticamente. No es obligatorio — también puedes hacerlo más tarde.",
  "guide.theme.discover.title": "Descubre tu espacio",
  "guide.theme.discover.cta": "Ir al panel",
  "guide.theme.discover.step1": "Para terminar, un pequeño recorrido. Este es tu panel — tu hogar en la app.",
  "guide.theme.discover.step2": "Aquí ves el pulso de tus personas — cómo están en este momento.",
  "guide.theme.discover.step3": "En los mensajes mantienes un contacto personal y directo.",
  "guide.theme.discover.step4": "En tus círculos cobran vida la comunidad y el intercambio.",
  "guide.theme.discover.step5": "Y aquí encuentras tu cuenta y todos los ajustes. Eso es todo — ¡que lo disfrutes!",
  // === iter273 i18n · wave 1 (CoachHome, CoachCircles) ===
  "ch.welcome": "Bienvenido de nuevo",
  "ch.default_name": "Coach",
  "ch.setup_title": "Configuración de coach · {done}/{total} completado",
  "ch.setup_sub": "Completa los 4 pasos y consigue tu insignia de Coach Fundador.",
  "ch.stat_circles": "Círculos",
  "ch.stat_upcoming": "Próximas reservas",
  "ch.wq_upcoming": "Sesiones próximas",
  "ch.wq_unread": "Mensajes sin leer",
  "ch.wq_pending": "Requiere atención",
  "ch.wq_next_sessions": "Tus próximas sesiones",
  "ch.wq_no_sessions": "No hay sesiones próximas.",
  "ch.wq_view_all": "Ver todo",
  "ch.wq_session": "Sesión",
  "ch.stat_credits": "Créditos",
  "ch.aff_title": "Tu enlace de afiliado",
  "ch.aff_hint": "Compártelo: ganas con cada recomendación.",
  "ch.aff_copied": "Enlace de afiliado copiado",
  "ch.area_title": "Tu área de coach",
  "ch.areas_count": "{n} áreas",
  "ch.gross_title": "Ingresos totales (todas las reservas)",
  "ch.g_start": "Inicio",
  "ch.g_circles": "Círculos",
  "ch.g_sell": "Vender",
  "ch.g_grow": "Crecimiento",
  "ch.g_account": "Cuenta",
  "ch.g_affiliate": "Afiliados",
  "ch.i_feed": "Feed",
  "ch.i_messages": "Mensajes",
  "ch.i_notifications": "Notificaciones",
  "ch.i_circles": "Círculos",
  "ch.i_inner": "Inner Circle",
  "ch.i_mein": "Mi Círculo",
  "ch.i_pulse": "Pulso de clientes",
  "ch.i_assistant": "Asistente de práctica IA",
  "ch.i_ads": "Publicidad",
  "ch.i_recommendations": "Recomendaciones",
  "ch.i_content": "Social y contenido",
  "ch.i_consent": "Consentimientos",
  "ch.i_client_wins": "Logros de clientes",
  "ch.i_collectives": "Colectivos",
  "ch.i_settings": "Ajustes",
  "ch.i_billing": "Facturación y planes",
  "ch.i_upgrade": "Coach Pro",
  "ch.i_support": "Soporte y ayuda",
  "ch.i_aff_link": "Recomendar y enlace de afiliado",
  "ch.i_aff_offerings": "Ofertas de afiliados",
  "ch.i_aff_payouts": "Pagos",
  "ch.s_feed": "Feed global y regional.",
  "ch.s_messages": "Mensajes directos y chats de círculo.",
  "ch.s_notifications": "Todos tus avisos de un vistazo.",
  "ch.s_circles": "Vista de Inner y Local Circle.",
  "ch.s_inner": "Define plan de suscripción, ventajas y precios.",
  "ch.s_mein": "Configura suscripciones adicionales en detalle.",
  "ch.s_pulse": "Clientes en silencio y señales de alerta.",
  "ch.s_offerings": "Sesiones, paquetes, afiliados y precios.",
  "ch.s_bookings": "Sesiones, cancelaciones y reembolsos.",
  "ch.s_earnings": "Ingresos, pagos e impuestos.",
  "ch.s_availability": "Abre y cierra franjas semanales.",
  "ch.s_assistant": "Tu asistente de coaching autónomo.",
  "ch.s_analytics": "Análisis de 12 bloques: crecimiento e informes.",
  "ch.s_ads": "Campañas, IA de audiencia y créditos.",
  "ch.s_recommendations": "Impacto de publicaciones y recomendaciones cálidas.",
  "ch.s_collab": "Red, proyectos y ofertas conjuntas.",
  "ch.s_content": "Publicaciones, planificador, historias y WEVA.",
  "ch.s_methods": "Crea ejercicios: audio, vídeo, combo.",
  "ch.s_plans": "Comparte planes diarios y breathwork semanal.",
  "ch.s_profile": "Perfil público, bio y marca.",
  "ch.s_verify": "Sube cualificaciones y estado.",
  "ch.s_consent": "Formularios de consentimiento y firmas.",
  "ch.s_client_wins": "Sugerencias de IA para casos de éxito.",
  "ch.s_collectives": "Alianzas de coaches con ingresos compartidos.",
  "ch.s_settings": "Política de cancelación, recitas, marca.",
  "ch.s_billing": "Créditos, plan de plataforma y asistente IA.",
  "ch.s_upgrade": "Mejora: 10% de comisión, marca y más.",
  "ch.s_support": "Tickets al equipo, FAQ y recorrido.",
  "ch.s_aff_link": "Comparte tu enlace y gana.",
  "ch.s_aff_offerings": "Promociona productos externos.",
  "ch.s_aff_payouts": "Comisiones y pagos.",
  "cc.title": "Círculos",
  "cc.subtitle": "Tus espacios de acompañamiento en un solo lugar: Inner Circle, Mi Círculo, Local y el Pulso de clientes.",
  "cc.card_inner_sub": "Tu acompañamiento exclusivo",
  "cc.card_mein_sub": "Círculos individuales y guiados",
  "cc.card_local_sub": "Tu comunidad gratuita",
  "cc.card_pulse_sub": "Mantén el compromiso a la vista",
  "cc.your_circles": "Tus círculos",
  "cc.new_circle": "Nuevo círculo",
  "cc.empty": "Aún no hay círculos. Crea tu primer círculo.",
  "cc.archived": "Archivado",
  "cc.actions": "Acciones del círculo",
  "cc.rename": "Renombrar",
  "cc.archive": "Archivar",
  "cc.restore": "Restaurar",
  "cc.delete": "Eliminar",
  "cc.health_line": "{total} miembros · {msgs} mens./7d · {active} activos",
  "cc.health_active": "Activo",
  "cc.health_quiet": "Tranquilo",
  "cc.health_silent": "En silencio",
  "cc.copy_code": "Copiar código de invitación",
  "cc.code_copied": "Código copiado",
  "cc.my_clients": "Mis clientes",
  "cc.no_clients": "Ahora mismo no hay clientes sin círculo.",
  "cc.client": "Cliente",
  "cc.rename_title": "Renombrar círculo",
  "cc.rename_desc": "Dale un nuevo nombre al círculo. Todos los miembros verán el nombre actualizado.",
  "cc.rename_ph": "Nombre del círculo",
  "cc.cancel": "Cancelar",
  "cc.save": "Guardar",
  "cc.renamed": "Círculo renombrado",
  "cc.name_short": "El nombre es demasiado corto (mín. 2 caracteres)",
  "cc.archived_toast": "Círculo archivado",
  "cc.restored_toast": "Círculo restaurado",
  "cc.delete_title": "¿Eliminar el círculo «{name}»?",
  "cc.delete_desc": "Esta acción no se puede deshacer. El círculo y todos sus mensajes, anuncios y actividad se eliminarán permanentemente.",
  "cc.delete_confirm": "Eliminar definitivamente",
  "cc.deleted": "Círculo eliminado",
  "cc.kind_local": "LOCAL",
  "cc.kind_individual": "Mi Círculo",
  "cc.kind_inner": "Inner Circle",
  // === iter273 i18n · wave 2 (Billing, Membership) ===
  "tier.plus_blurb": "Para empezar con calma en la reflexión con IA.",
  "tier.pro_blurb": "Más informes y planes de inicio.",
  "tier.unlimited_blurb": "Reflexión ilimitada, priorizada.",
  "tier.coach_pro_blurb": "Todo lo de Unlimited + herramientas de coaching.",
  "feat.reports_unlimited": "Informes WEVA ilimitados (uso razonable)",
  "feat.reports_count": "{n} informes WEVA / mes",
  "feat.ad_free": "Sin publicidad",
  "feat.voice_journal": "Diario de voz",
  "feat.starter_plans": "Planes de inicio",
  "feat.priority": "Procesamiento prioritario",
  "feat.commission": "Solo {pct}% de comisión de plataforma",
  "feat.advanced_analytics": "Analíticas avanzadas de coach",
  "bill.title": "Facturación y planes",
  "bill.sub_coach": "Créditos, membresía de plataforma y el Asistente de práctica IA, todo en un solo lugar. Pago seguro con Stripe.",
  "bill.sub_client": "Créditos y membresía de plataforma, todo en un solo lugar. Pago seguro con Stripe.",
  "bill.credits": "Créditos",
  "bill.credit_rate": "1 crédito = €0,10 · IVA incl.",
  "bill.n_credits": "{n} créditos",
  "bill.popular": "Popular",
  "bill.credits_word": "Créditos",
  "bill.incl_vat_per": "IVA incl. · {per}/crédito",
  "bill.buy": "Comprar",
  "bill.credits_added": "¡Créditos añadidos!",
  "bill.purchase_failed": "La compra falló.",
  "bill.payment_received": "Pago recibido, ¡gracias!",
  "bill.cancelled": "Proceso cancelado.",
  "bill.sub_activated": "Membresía activada, ¡gracias!",
  "bill.membership": "Membresía de plataforma",
  "bill.membership_sub": "Elige el plan que se adapte a tu trabajo interior. Cancela cuando quieras.",
  "bill.current_plan": "Plan actual: {name}",
  "bill.manage_hint": "Gestiona tu suscripción, cambia el método de pago o cancela, de forma segura en el portal de Stripe. Tu acceso se mantiene hasta el final del periodo.",
  "bill.manage": "Gestionar suscripción",
  "bill.monthly": "Mensual",
  "bill.yearly": "Anual · ahorra más",
  "bill.recommended": "Recomendado",
  "bill.per_year": "año",
  "bill.per_month": "mes",
  "bill.current": "Plan actual",
  "bill.choose": "Elegir",
  "bill.activated": "¡Membresía activada!",
  "bill.finish_failed": "No se pudo completar.",
  "bill.stripe_note": "Pago seguro con Stripe · IVA austríaco incl.",
  "bill.stripe_note_vat": "Pago seguro con Stripe · IVA austríaco incl. · los precios incluyen IVA.",
  "bill.manage_demo": "La gestión de suscripción no está disponible en modo demo.",
  "bill.no_active_sub": "Sin suscripción activa.",
  "bill.manage_failed": "No se pudo abrir la gestión de suscripción.",
  "bill.ai_title": "Asistente de práctica IA",
  "bill.ai_sub": "Tu asistente de coaching autónomo: briefing diario, tareas, chat y flujos.",
  "bill.ai_active": "Activo",
  "bill.ai_runs_until": "Activo hasta {date}",
  "bill.ai_is_active": "Tu asistente está activo.",
  "bill.ai_open": "Abrir asistente",
  "bill.ai_upsell": "Automatiza tareas rutinarias y recibe cada mañana un briefing diario claro.",
  "bill.ai_f_briefing": "Briefing diario",
  "bill.ai_f_tasks": "Delegación de tareas",
  "bill.ai_f_chat": "Chat IA",
  "bill.ai_f_workflows": "Flujos autónomos",
  "bill.ai_starting": "Iniciando…",
  "bill.ai_start_sub": "Iniciar suscripción",
  "bill.ai_trial": "Prueba 7 días gratis",
  "bill.ai_price": "{price}€ / mes",
  "bill.ai_checkout_failed": "El pago falló.",
  "mem.title": "Membresía",
  // === iter273 i18n · wave 3 (auth + public pages) ===
  "fp.meta": "Restablecer contraseña",
  "fp.title": "¿Olvidaste tu contraseña?",
  "fp.subtitle": "Te enviaremos un enlace para restablecerla.",
  "fp.back": "Volver al inicio de sesión",
  "fp.sent": "Si este correo está registrado, recibirás en breve un enlace para restablecerla.",
  "fp.email": "Correo electrónico",
  "fp.email_ph": "tu@ejemplo.com",
  "fp.submit": "Enviar enlace",
  "rp.meta": "Nueva contraseña",
  "rp.title": "Nueva contraseña",
  "rp.subtitle": "Elige una contraseña segura para tu cuenta.",
  "rp.back": "Al inicio de sesión",
  "rp.no_token": "Este enlace no es válido. Solicita un nuevo enlace de restablecimiento.",
  "rp.new_pw": "Nueva contraseña",
  "rp.pw_ph": "Al menos 8 caracteres",
  "rp.submit": "Guardar contraseña",
  "rp.updated": "Contraseña actualizada.",
  "rp.failed": "El restablecimiento falló.",
  "cpg.meta": "Coaches",
  "cpg.meta_desc": "Descubre coaches verificados en My Within, por tema, experiencia y región.",
  "cpg.title": "Nuestros coaches",
  "cpg.subtitle": "Acompañantes verificados para tu trabajo interior: encuentra a la persona que encaja contigo.",
  "cpg.search_ph": "Busca por nombre, experiencia o profesión …",
  "cpg.empty_title": "No se encontraron coaches",
  "cpg.empty_desc": "Prueba con otro término de búsqueda.",
  "cpg.reset_search": "Restablecer búsqueda",
  "od.fallback_title": "Oferta",
  "od.notfound_title": "Oferta no encontrada",
  "od.notfound_desc": "Esta oferta ya no está disponible.",
  "od.to_marketplace": "Al marketplace",
  "od.marketplace": "Marketplace",
  "od.recommended": "Recomendado",
  "od.minutes": "{n} minutos",
  "od.included": "Qué incluye",
  "od.savings": "Ahorras {amount} en el paquete.",
  "od.price": "Precio",
  "od.cta": "Ver coach y disponibilidad",
  "od.create_account": "Crea una cuenta",
  "od.signup_rest": " para reservar y chatear.",
  "od.more_from": "Más ofertas de {name}",
  "mkt.meta": "Mercado",
  "mkt.meta_desc": "Descubre ofertas de coaching, cursos y paquetes de coaches verificados en My Within.",
  "mkt.title": "Mercado",
  "mkt.subtitle": "Ofertas, cursos y paquetes de coaches verificados: encuentra lo que encaja con tu camino.",
  "mkt.search_ph": "Busca por tema, título o coach …",
  "mkt.art": "Tipo",
  "mkt.all_types": "Todos los tipos",
  "mkt.region": "Región",
  "mkt.all_regions": "Todas las regiones",
  "mkt.theme": "Tema",
  "mkt.all_themes": "Todos los temas",
  "mkt.filters_active": "{n} filtros activos",
  "mkt.reset": "Restablecer",
  "mkt.count_one": "{n} oferta encontrada",
  "mkt.count_other": "{n} ofertas encontradas",
  "mkt.empty_title": "No se encontraron ofertas",
  "mkt.empty_desc": "Ajusta tu búsqueda o filtros para ver más ofertas.",
  "mkt.reset_filters": "Restablecer filtros",
  "mkt.loading": "Cargando …",
  "mkt.load_more": "Mostrar más",
  "cp.meta_fallback": "Coach",
  "cp.notfound_title": "Coach no encontrado",
  "cp.notfound_desc": "Este perfil no está disponible.",
  "cp.all_coaches": "Todos los coaches",
  "cp.since_year": "En la profesión desde {year}",
  "cp.about": "Sobre {name}",
  "cp.posts": "Publicaciones",
  "cp.more_exclusive": "{n} publicaciones exclusivas más: desbloquéalas como miembro.",
  "cp.no_posts": "Aún no hay publicaciones públicas.",
  "cp.focus": "Áreas de enfoque",
  "cp.topics": "Temas",
  "cp.qualifications": "Cualificaciones",
  "cp.visit_website": "Visitar sitio web",
  "cir.health_active": "Activo",
  "cir.health_quiet": "Tranquilo",
  "cir.health_still": "En calma",
  "cir.kind_individual": "Mi Círculo",
  "cir.load_error": "No se pudieron cargar los círculos.",
  "cir.created": "Círculo creado",
  "cir.joined": "Te uniste al círculo",
  "cir.join_failed": "No se pudo unir",
  "cir.invite_sent": "Invitación enviada",
  "cir.member_removed": "Miembro eliminado",
  "cir.remove_failed": "No se pudo eliminar",
  "cir.code_copied": "Código copiado",
  "cir.link_copied": "Enlace copiado",
  "cir.pin_updated": "Fijado actualizado",
  "cir.eyebrow": "Comunidad",
  "cir.title": "Círculos",
  "cir.subtitle": "Acompaña a tus grupos y mantente conectado con tus clientes.",
  "cir.new_circle": "Nuevo círculo",
  "cir.new_circle_desc": "Elige el tipo y dale un nombre a tu círculo.",
  "cir.local_circle": "Círculo Local",
  "cir.local_circle_desc": "Grupo gratuito para tu comunidad.",
  "cir.mein_kreis": "Mi Círculo",
  "cir.mein_kreis_desc": "Círculo individual y acompañado.",
  "cir.name_ph": "Nombre del círculo",
  "cir.desc_ph": "Descripción (opcional)",
  "cir.cancel": "Cancelar",
  "cir.create": "Crear",
  "cir.invite_code_ph": "Código de invitación",
  "cir.join": "Unirse",
  "cir.empty": "Aún no hay círculos. Crea uno o únete con un código.",
  "cir.health_stat": "· {total} miembros · {msgs} msj/7d · {active} activos",
  "cir.copy_invite_code": "Copiar código de invitación",
  "cir.select_circle": "Selecciona un círculo a la izquierda.",
  "cir.invite_code_prefix": "Código de invitación:",
  "cir.copy_code": "Copiar código",
  "cir.members_count": "{n} miembros",
  "cir.share_link": "Compartir enlace de invitación",
  "cir.member_health": "Salud de miembros",
  "cir.start_convo": "Inicia la conversación",
  "cir.start_convo_desc": "Escribe el primer mensaje a tu círculo.",
  "cir.pin": "Fijar",
  "cir.msg_ph": "Escribe un mensaje …",
  "cir.invite_email_ph": "Invitar por correo",
  "cir.invite": "Invitar",
  "cir.manage_members": "Gestionar miembros",
  "cir.manage_members_desc": "Ver, invitar y eliminar miembros de tu círculo.",
  "cir.no_members": "Aún no hay miembros.",
  "cir.member_fallback": "Miembro",
  "cir.coach": "Coach",
  "cir.remove": "Eliminar",
  "cir.remove_member_q": "¿Eliminar miembro?",
  "cir.remove_member_desc": "{who} será eliminado del círculo. Esto no se puede deshacer.",
  "cir.this_member": "Este miembro",
  "mk.seo": "Coach · Mi Círculo",
  "mk.eyebrow": "Mi Círculo",
  "mk.title": "Mi Círculo",
  "mk.subtitle": "Círculos individuales y acompañados con tu propio precio, plazas y mensaje de bienvenida.",
  "mk.new": "Nuevo",
  "mk.empty_title": "Aún no tienes un círculo propio",
  "mk.empty_desc": "Crea tu primer círculo individual con precio y plazas.",
  "mk.create_circle": "Crear círculo",
  "mk.bl_one_time": "único",
  "mk.bl_monthly": "/mes",
  "mk.bl_yearly": "/año",
  "mk.free": "gratis",
  "mk.seats": "{n} plazas",
  "mk.unlimited_seats": "Plazas ilimitadas",
  "mk.edit": "Editar",
  "mke.seo_edit": "Coach · Editar círculo",
  "mke.seo_create": "Coach · Crear círculo",
  "mke.title_edit": "Editar círculo",
  "mke.title_create": "Crear círculo",
  "mke.subtitle": "Suscripción adicional: tan detallada como el Inner Circle, con/sin límite de tiempo y de participantes.",
  "mke.b_one_time": "Único",
  "mke.b_monthly": "Mensual",
  "mke.b_yearly": "Anual",
  "mke.period_month": "por mes",
  "mke.period_week": "por semana",
  "mke.period_total": "total",
  "mke.unit_days": "Días",
  "mke.unit_weeks": "Semanas",
  "mke.unit_months": "Meses",
  "mke.err_name": "Introduce un nombre (mín. 2 caracteres).",
  "mke.saved": "Círculo guardado",
  "mke.basics": "Datos básicos",
  "mke.name": "Nombre",
  "mke.description": "Descripción",
  "mke.desc_ph": "¿De qué trata este círculo?",
  "mke.cover": "Imagen de portada",
  "mke.cover_ph": "… o pega una URL de imagen",
  "mke.price_billing": "Precio y suscripción",
  "mke.price_eur": "Precio (€)",
  "mke.price_credits": "Precio (créditos)",
  "mke.price_hint": "Déjalo vacío (€ o créditos) para que la plataforma deduzca el precio que falta automáticamente. 0 = gratis.",
  "mke.access_section": "Participantes y límite de tiempo",
  "mke.limit_seats": "Limitar número de participantes",
  "mke.limit_seats_hint": "Desactivado = miembros ilimitados.",
  "mke.max_seats": "Participantes máximos",
  "mke.seats_ph": "p. ej. 12",
  "mke.limit_time": "Acceso con tiempo limitado",
  "mke.limit_time_hint": "Desactivado = suscripción permanente sin límite de tiempo.",
  "mke.duration": "Duración",
  "mke.duration_ph": "p. ej. 3",
  "mke.perks_title": "Beneficios incluidos",
  "mke.perks_hint": "Agrupa ofertas de todo tipo: tan detallado como el Inner Circle.",
  "mke.visibility": "Visibilidad",
  "mke.vis_public": "Visible públicamente",
  "mke.vis_public_hint": "Aparece en tu perfil de coach.",
  "mke.vis_invite": "Solo por invitación",
  "mke.vis_invite_hint": "Unirse solo con código/enlace de invitación.",
  "mke.published": "Publicado",
  "mke.published_hint": "Desactivado = guardado pero oculto para los clientes.",
  "mke.welcome_links": "Bienvenida y enlaces",
  "mke.welcome": "Mensaje de bienvenida",
  "mke.welcome_ph": "Da la bienvenida a nuevos miembros …",
  "mke.zoom": "Enlace de Zoom",
  "mke.onboarding_video": "Vídeo de bienvenida",
  "mke.video_ph": "… o pega una URL de vídeo",
  "mke.sessions": "Sesiones incluidas",
  "mke.add": "Añadir",
  "mke.no_sessions": "Aún no se han añadido sesiones.",
  "mke.session_title_ph": "Título de la sesión",
  "mke.save": "Guardar",
  "mke.create": "Crear",
  "ctl.deliverables": "Entregas",
  "ctl.todos": "Tareas",
  "ctl.clients": "Clientes",
  "ctl.chats": "Chats",
  "ctl.weva": "Análisis de grupo WEVA",
  "ctl.members": "Salud de miembros",
  "ctl.load_error": "No se pudo cargar.",
  "ctl.deliverables_saved": "Entregas guardadas",
  "ctl.weva_too_few": "Datos insuficientes para un análisis de grupo (mín. 3 miembros activos).",
  "ctl.analysis_created": "Análisis creado",
  "ctl.analysis_pro": "Análisis no posible (solo Coach Pro).",
  "ctl.seo": "Coach · {title}",
  "ctl.back": "Panel",
  "ctl.inner_readonly": "Las entregas del Inner Circle se gestionan en el plan Inner Circle (solo lectura aquí).",
  "ctl.no_deliverables": "No hay entregas disponibles.",
  "ctl.save": "Guardar",
  "ctl.todo_behind": "Con retraso",
  "ctl.todo_behind_empty": "Todo según lo previsto.",
  "ctl.todo_dms": "DMs abiertos",
  "ctl.todo_dms_empty": "No hay DMs abiertos.",
  "ctl.msg": "Mensaje",
  "ctl.todo_snapshots": "Nuevos snapshots",
  "ctl.todo_snapshots_empty": "No hay nuevos snapshots.",
  "ctl.snapshot": "Snapshot",
  "ctl.no_clients": "Aún no hay clientes en esta área.",
  "ctl.client": "Cliente",
  "ctl.dm_limit": "Límite de DM activo: {n}/mes.",
  "ctl.no_chats": "No hay chats.",
  "ctl.no_members": "Aún no hay miembros en esta área.",
  "ctl.entries_30d": "{n} entradas (30d)",
  "ctl.last_emotion": " · última: {emotion}",
  "ctl.start_analysis": "Iniciar análisis",
  "ctl.privacy_min": "Por privacidad, las perspectivas de grupo solo se muestran a partir de 3 miembros activos con datos.",
  "ctl.themes": "Temas",
  "ctl.emotions": "Emociones",
  "ctl.beliefs": "Creencias",
  "ctl.latest_analysis": "Último análisis",
  "ctl.history": "Historial",
  "ctl.analysis": "Análisis",
  "ctl.privacy_note": "Las perspectivas de WEVA están agregadas y anonimizadas. Las entradas individuales nunca se comparten en texto claro.",
  "ctl.no_data": "Sin datos.",
  "cdb.weva": "Análisis WEVA",
  "cdb.load_error": "No se pudo cargar el resumen.",
  "cdb.seo": "Coach · {title}",
  "cdb.subtitle": "Resumen de actividad, ingresos y entregas.",
  "cdb.all_circles": "Todos los círculos",
  "cdb.active_members": "Miembros activos",
  "cdb.earnings_month": "Ingresos (mes)",
  "cdb.snapshots_confirmed": "Snapshots confirmados",
  "cdb.entries_received": "Entradas recibidas",
  "cdb.bookings": "Reservas",
  "cdb.active_offerings": "Ofertas activas",
  "cdb.included_deliverables": "Entregas incluidas",
  "cdb.no_deliverables_defined": "Aún no se han definido entregas.",
  "cdb.per_month": "{n}× / mes",
  "cdb.earnings_this_month": "Ingresos este mes",
  "cdb.bookings_received": "Reservas recibidas",
  "cdb.areas": "Áreas",
  "perk.weva_snapshot_analysis": "Análisis de snapshots WEVA",
  "perk.user_entries_analysis": "Análisis de entradas",
  "perk.weekly_plan": "Plan semanal del coach",
  "perk.dm_monthly": "Mensajes directos por mes",
  "perk.paid_content": "Acceso a todo el contenido de pago",
  "perk.group_chat": "Chat de grupo privado con otros miembros",
  "perk.video_call": "Minutos de videollamada 1:1 por mes",
  "perk.belief_text_beliefs": "Trabajo de creencias por texto · creencias por mes",
  "perk.belief_text_dms": "Trabajo de creencias por texto · DMs por mes",
  "perk.belief_phone": "Trabajo de creencias por teléfono · minutos por mes",
  "perk.belief_video": "Trabajo de creencias por videollamada · minutos por mes",
  "perk.emergency_support": "Apoyo emocional de emergencia",
  "perk.unit_month": "/mes",
  "perk.unit_dms_month": "DMs/mes",
  "perk.unit_min_month": "min/mes",
  "perk.recommended": "· recomendado",
  "perk.custom_hint": "Añade tus propios beneficios / ofertas (p. ej. «5 mensajes de voz / mes»).",
  "perk.min_short": "min",
  "perk.offer_name_ph": "Nombre de la oferta",
  "perk.count_ph": "Cantidad",
  "perk.add": "Añadir",
  "cext.err_title": "Se requiere un título (mín. 2 caracteres).",
  "cext.published": "Anuncio publicado",
  "cext.pinned": "Fijado",
  "cext.unpin": "Desfijar",
  "cext.announcements": "Anuncios",
  "cext.new": "Nuevo",
  "cext.post_title": "Publicar anuncio",
  "cext.post_desc": "Comparte una novedad con tu círculo.",
  "cext.title": "Título",
  "cext.text": "Texto",
  "cext.body_ph": "Tu mensaje …",
  "cext.require_confirm": "Requerir confirmación de lectura",
  "cext.schedule": "Programar (opcional)",
  "cext.attachment": "Adjunto (opcional)",
  "cext.post": "Publicar",
  "cext.empty": "Aún no hay anuncios.",
  "cext.scheduled": "programado",
  "cext.confirmed": "Confirmado",
  "cext.read": "Leído",
  "earn.p_month": "Mes",
  "earn.p_quarter": "Trimestre",
  "earn.p_year": "Año",
  "earn.p_all": "Total",
  "earn.src_inner": "Inner Circle",
  "earn.src_local": "Local Circle",
  "earn.src_sessions": "Sesiones",
  "earn.src_affiliate": "Afiliados",
  "earn.src_paid": "Contenido de pago",
  "earn.src_other": "Otros",
  "earn.paid_status": "Pagado",
  "earn.pending_status": "Pendiente",
  "earn.failed_status": "Fallido",
  "earn.seo": "Coach · Ingresos",
  "earn.back": "Panel de coach",
  "earn.eyebrow": "Ingresos",
  "earn.title": "Ingresos y pagos",
  "earn.subtitle": "Ingresos por fuente, pagos y estado de Stripe.",
  "earn.stripe_err": "No se pudo iniciar la configuración de Stripe.",
  "earn.gross": "Ingresos brutos",
  "earn.paid_out": "Pagado",
  "earn.pending": "Pendiente",
  "earn.next_payout": "Próximo pago",
  "earn.by_source": "Ingresos por fuente",
  "earn.no_revenue": "Sin ingresos en este período.",
  "earn.stripe_payouts": "Pagos de Stripe",
  "earn.active": "Activo",
  "earn.setup_needed": "Configuración necesaria",
  "earn.opening_stripe": "Abriendo Stripe…",
  "earn.continue_onboarding": "Continuar configuración",
  "earn.connect_stripe": "Conectar Stripe",
  "earn.payouts": "Pagos",
  "earn.no_payouts": "Aún no hay pagos.",
  "earn.paid_on": "Pagado {date}",
  "earn.created_on": "Creado {date}",
  "earn.step_connect": "Conectar cuenta de Stripe",
  "earn.step_identity": "Verificar identidad",
  "earn.step_bank": "Añadir cuenta bancaria para pagos",
  "earn.step_documents": "Subir documentos solicitados (si es necesario)",
  "cpul.seg_all": "Todos",
  "cpul.seg_rising": "En aumento",
  "cpul.seg_stable": "Estable",
  "cpul.seg_dropping": "En riesgo",
  "cpul.seg_no_data": "Sin datos",
  "cpul.load_err": "No se pudo cargar el pulso.",
  "cpul.seo": "Coach · Pulso de clientes",
  "cpul.eyebrow": "Pulso de clientes",
  "cpul.title": "Pulso de clientes",
  "cpul.subtitle": "Mantén un ojo en el compromiso de tus clientes.",
  "cpul.refresh": "Actualizar",
  "cpul.alert_one": "{n} cliente con compromiso decreciente.",
  "cpul.alert_other": "{n} clientes con compromiso decreciente.",
  "cpul.all_good_title": "Todo en verde",
  "cpul.all_good_desc": "Todos los clientes estables o en aumento.",
  "cpul.h7": "7d:",
  "cpul.h30": "30d:",
  "cpul.sessions": "Sesiones:",
  "mh.bucket_healthy": "Activo",
  "mh.bucket_silent": "Tranquilo",
  "mh.bucket_inactive": "Inactivo",
  "mh.bucket_churned": "Abandonado",
  "mh.load_err": "No se pudo cargar la salud de miembros.",
  "mh.nudge_sent": "Recordatorio enviado",
  "mh.bulk_nudged": "{n} miembros recordados",
  "mh.seo": "Coach · Salud de miembros",
  "mh.eyebrow": "Miembros",
  "mh.title": "Salud de miembros",
  "mh.subtitle": "Actividad de tus miembros y recordatorios dirigidos.",
  "mh.all_silent": "Todos los inactivos ({n})",
  "mh.empty_title": "Aún no hay miembros",
  "mh.empty_desc": "En cuanto se unan miembros, verás aquí su actividad.",
  "mh.not_active": "Aún no activo",
  "mh.last_active": "Última actividad hace {n} día(s)",
  "mh.expiring": " · suscripción por vencer",
  "mh.nudge": "Recordar",
  "mh.nudge_title": "Dar un toque a {name}",
  "mh.nudge_desc": "Un mensaje cálido + notificación.",
  "mh.nudge_ph": "Mensaje opcional …",
  "mh.send": "Enviar",
  "mh.bulk_title": "Dar un toque a todos los miembros inactivos",
  "mh.bulk_desc": "Solo miembros que estuvieron inactivos recientemente (máx. 1× por 24h).",
  "av.wd_mon": "Lunes",
  "av.wd_tue": "Martes",
  "av.wd_wed": "Miércoles",
  "av.wd_thu": "Jueves",
  "av.wd_fri": "Viernes",
  "av.wd_sat": "Sábado",
  "av.wd_sun": "Domingo",
  "av.wds_mon": "Lu",
  "av.wds_tue": "Ma",
  "av.wds_wed": "Mi",
  "av.wds_thu": "Ju",
  "av.wds_fri": "Vi",
  "av.wds_sat": "Sá",
  "av.wds_sun": "Do",
  "av.load_err": "No se pudo cargar la disponibilidad.",
  "av.outlook_connected": "Calendario de Outlook conectado.",
  "av.outlook_failed": "Falló la conexión con Outlook.",
  "av.outlook_not_setup": "Outlook aún no está configurado.",
  "av.outlook_disconnected": "Outlook desconectado.",
  "av.saved": "Disponibilidad guardada.",
  "av.save_failed": "Error al guardar.",
  "av.day_updated": "{day} actualizado.",
  "av.day_reset": "{day} restablecido.",
  "av.day_save_failed": "No se pudo guardar el día.",
  "av.seo": "Coach · Disponibilidad",
  "av.eyebrow": "Disponibilidad",
  "av.title": "Disponibilidad y calendario",
  "av.subtitle": "Abre franjas semanales o ajusta días concretos durante las próximas semanas.",
  "av.outlook_cal": "Calendario de Outlook",
  "av.outlook_soon": "Lo configura el equipo: disponible pronto.",
  "av.connected": "Conectado",
  "av.reconnect_needed": " · se requiere reconectar",
  "av.outlook_hint": "Conecta tu calendario de Outlook para sincronizar libre/ocupado.",
  "av.disconnect": "Desconectar",
  "av.reconnect": "Reconectar",
  "av.outlook_connect": "Conectar Outlook",
  "av.mode_uniform": "Uniforme",
  "av.mode_individual": "Individual",
  "av.timezone": "Zona horaria",
  "av.uniform_hint": "La plantilla semanal se aplica a todas las {weeks} semanas: días concretos ajustables abajo.",
  "av.individual_hint": "Cada día se edita de forma individual.",
  "av.week_template": "Plantilla semanal",
  "av.saving": "Guardando…",
  "av.save_template": "Guardar plantilla",
  "av.next_weeks": "Próximas {weeks} semanas",
  "av.tap_hint": "· toca un día para ajustar",
  "av.view": "Vista",
  "av.month": "Mes",
  "av.weeks_short": "{w} sem.",
  "av.custom": "Personalizado",
  "av.adjust_day": "Ajustar {day}",
  "av.available": "Disponible",
  "av.reset": "Restablecer",
  "av.save": "Guardar",
  "av.slot": "Franja",
  "ic.seo": "Coach · Inner Circle",
  "ic.subtitle": "Tu suscripción mensual exclusiva: agrupa ofertas de todo tipo en un acompañamiento constante.",
  "ic.tab_settings": "Ajustes",
  "ic.tab_overview": "Resumen",
  "ic.tab_clients": "Clientes",
  "ic.tab_weva": "WEVA",
  "ic.tab_invites": "Invitaciones",
  "ic.err_price": "Define un precio en € o créditos.",
  "ic.err_min_eur": "El precio mínimo es 4,99 € / mes.",
  "ic.err_min_credits": "El precio mínimo es 50 créditos / mes.",
  "ic.saved_published": "Inner Circle guardado y publicado.",
  "ic.saved_hidden": "Inner Circle guardado (oculto).",
  "ic.setup_intro": "Define un precio mensual y elige lo que reciben tus miembros cada mes.",
  "ic.enable_card": "Activar pagos con tarjeta",
  "ic.enable_card_desc": "Completa ambos pasos para que los clientes puedan suscribirse con tarjeta.",
  "ic.step1": "1 · Conectar pagos de Stripe",
  "ic.stripe_not_started": "Aún no iniciado: Stripe verifica identidad y datos bancarios para tus pagos.",
  "ic.stripe_submitted": "Enviado: Stripe aún lo revisa (normalmente <24h).",
  "ic.stripe_connected": "Conectado: puedes recibir pagos.",
  "ic.stripe_incomplete": "Iniciado pero incompleto: completa el formulario KYC.",
  "ic.stripe_start": "Iniciar configuración de Stripe",
  "ic.step2": "2 · Definir precio en €",
  "ic.price_set": "{price}/mes definido. Guarda para activar.",
  "ic.price_enter": "Introduce un precio mensual abajo (mín. 4,99 €/mes).",
  "ic.card_active": "Pagos con tarjeta activos",
  "ic.card_active_desc": "Los clientes pueden suscribirse con tarjeta (Stripe) o créditos. {price}/mes · {share}% para ti.",
  "ic.price_eur": "Precio mensual (€)",
  "ic.only_credits_hint": "Déjalo vacío si solo quieres aceptar créditos.",
  "ic.price_credits": "Precio mensual (créditos)",
  "ic.price_credits_ph": "p. ej. 50",
  "ic.credits_month": "créditos/mes",
  "ic.credits_auto_hint": "Déjalo vacío para que la plataforma deduzca el precio en créditos automáticamente.",
  "ic.revenue_split": "La plataforma se queda {platform}% · Tú recibes {coach}%",
  "ic.coach_pro_hint": " · actualizar a Coach Pro lo baja al 15%",
  "ic.description_label": "Descripción: lo que reciben los suscriptores",
  "ic.description_ph": "Un compromiso mensual con tu trabajo interior …",
  "ic.whats_included": "Qué incluye",
  "ic.core_hint": "Los primeros cuatro son beneficios clave (coaching WEVA) y se recomiendan.",
  "ic.visibility": "Visibilidad",
  "ic.visibility_hint": "¿Tu Inner Circle aparece públicamente en tu perfil o solo por invitación?",
  "ic.vis_public": "Visible públicamente",
  "ic.vis_public_hint": "Aparece en tu perfil de coach, cualquiera puede suscribirse.",
  "ic.vis_invite": "Solo por invitación",
  "ic.vis_invite_hint": "Solo pueden unirse los clientes invitados.",
  "ic.waitlist": "{n} esperan tu Inner Circle",
  "ic.waitlist_hint": "Recibirán una notificación en cuanto actives «Publicado».",
  "ic.dm_limit": "Límite estricto de DM",
  "ic.dm_limit_hint": "Activado = los miembros no pueden superar la cuota mensual de DM.",
  "ic.save": "Guardar Inner Circle",
  "ic.no_members": "Aún no hay miembros del Inner Circle",
  "ic.no_members_hint": "En cuanto alguien se suscriba, aparecerá aquí.",
  "ic.planned": "{n} próximas",
  "ic.past": "{n} pasadas",
  "ic.weva_err": "No se pudo cargar el informe WEVA.",
  "ic.snapshot7": "Snapshot (7d)",
  "ic.days30": "30 días",
  "ic.history90": "Historial (90d)",
  "ic.members_one": "{n} miembro",
  "ic.members_other": "{n} miembros",
  "ic.period": "Período: últimos {n} días",
  "ic.top_beliefs": "Creencias más comunes",
  "ic.upper_limits": "Puntos críticos de límite superior",
  "ic.not_enough": "No hay suficiente actividad en este período para un informe.",
  "ic.min": "min",
  "ic.days": "días",
  "ic.err_email": "Introduce al menos un correo válido.",
  "ic.invites_created": "{n} invitación(es) creada(s).",
  "ic.invites_err": "No se pudieron enviar las invitaciones.",
  "ic.invite_revoked": "Invitación retirada",
  "ic.emails_label": "Direcciones de correo",
  "ic.emails_hint": "Separa varias direcciones con coma, punto y coma o salto de línea.",
  "ic.note_label": "Nota personal (opcional)",
  "ic.note_ph": "Bienvenido al Inner Circle …",
  "ic.sending": "Enviando…",
  "ic.kpi_sent": "Enviadas",
  "ic.kpi_accept_rate": "Tasa de aceptación",
  "ic.kpi_accepted": "Aceptadas",
  "ic.kpi_pending": "Pendientes",
  "ic.kpi_revoked": "Retiradas",
  "ic.kpi_avg_time": "Tiempo medio de unión",
  "ic.kpi_active": "Miembros activos",
  "ic.kpi_retention": "Retención 30d",
  "ic.sec_pending": "Pendientes",
  "ic.sec_pending_empty": "Aún no hay invitaciones pendientes.",
  "ic.sec_accepted": "Aceptadas",
  "ic.sec_accepted_empty": "Aún no hay aceptaciones.",
  "ic.sec_revoked": "Retiradas",
  "ic.back": "Círculos",
  "ic.tile_deliverables": "Entregas",
  "ic.tile_todos": "Tareas",
  "ic.tile_clients": "Clientes",
  "ic.tile_chats": "Chats",
  "ic.tile_weva": "Análisis WEVA",
  "ic.tile_members": "Salud de miembros",
  "ic.save_err": "Error al guardar.",
  "ic.stripe_onboard_err": "No se pudo iniciar la configuración de Stripe.",
  "ic.opening_stripe": "Abriendo Stripe…",
  "ic.continue_onboarding": "Continuar configuración",
  "ic.ov_active_members": "Miembros activos",
  "ic.ov_earnings": "Ingresos (mes)",
  "ic.ov_snapshots": "Snapshots confirmados",
  "ic.ov_entries": "Entradas recibidas",
  "ic.ov_bookings": "Reservas",
  "ic.ov_offerings": "Ofertas activas",
  "ic.deliverables_title": "Entregas incluidas",
  "ic.no_deliverables": "Aún no hay entregas definidas.",
  "ic.per_month": "{n}× / mes",
  "ic.areas": "Áreas",
  "ic.published": "Publicado",
  "ic.published_hint": "Desactivado = guardado pero oculto para los clientes.",
  "ic.saving": "Guardando…",
  "ic.invite": "Invitar",
  "ic.month_suffix": "/mes",
  "ic.overview_err": "No se pudo cargar el resumen.",

  // UX Rework 3.0
  "rw3.dw_areas": "Áreas",
  "rw3.dw_quick": "Acceso rápido",
  "rw3.mem_on_free": "Actualmente usas el plan gratuito.",
  "rw3.mem_free_access": "Incluye: Respirar, Diario y Deep Within, además de informes WEVA limitados.",
  "rw3.mem_credits_title": "Créditos y facturación",
  "rw3.mem_credits_note": "Las sesiones e informes individuales se pagan con créditos, aparte de tu membresía.",
  "rw3.mem_credits_cta": "Ir a facturación",
  "rw3.mem_lifetime": "Tienes acceso de por vida: no necesitas suscripción.",
  "rw3.mem_coach_note": "Los planes de coach incluyen todas las ventajas personales más herramientas de práctica.",
  "rw3.pl_confirm_multi": "¿Enviar el plan «{name}» a {n} clientes?",
  "rw3.pl_confirm_circle": "¿Enviar el plan «{name}» a todos los miembros de este círculo?",
  "rw3.off_online": "En línea",
  "rw3.off_inperson": "Presencial",
  "rw3.ic_this_month": "Este mes",
  "rw3.ic_recurring_est": "recurrente est. / mes",
  "ch.earn_title": "Ingresos (mes)",
  "ch.earn_view": "Detalles",
  "ch.earn_gross": "Bruto",
  "ch.earn_pending": "Pendiente",
  "ch.earn_paid": "Pagado",
  "ch.earn_next": "Próximo pago",
  "ch.earn_period_note": "Mes actual · consulta Ingresos para periodos y detalle.",
  "ch.earn_vs_prev": "vs. mes anterior",
  "dw.progress_label": "{done} de {total} transformadas",
};

export default es;
